export default {
    "关": [
        {
            "line": "关关雎鸠，在河之洲",
            "poemId": "poem_0"
        },
        {
            "line": "关东有义士，兴兵讨群凶",
            "poemId": "poem_30"
        },
        {
            "line": "关山三五月，客子忆秦川",
            "poemId": "poem_74"
        },
        {
            "line": "关山四面绝，故乡几千里",
            "poemId": "poem_87"
        },
        {
            "line": "关山虽胜路难堪，才上征鞍又解骖",
            "poemId": "poem_239"
        },
        {
            "line": "关城树色催寒近，御苑砧声向晚多",
            "poemId": "poem_458"
        },
        {
            "line": "关门令尹谁能识，河上仙翁去不回",
            "poemId": "poem_477"
        },
        {
            "line": "关中昔丧乱，兄弟遭杀戮",
            "poemId": "poem_506"
        }
    ],
    "窈": [
        {
            "line": "窈窕淑女，君子好逑",
            "poemId": "poem_0"
        },
        {
            "line": "窈窕淑女，寤寐求之",
            "poemId": "poem_0"
        },
        {
            "line": "窈窕淑女，琴瑟友之",
            "poemId": "poem_0"
        },
        {
            "line": "窈窕淑女，钟鼓乐之",
            "poemId": "poem_0"
        }
    ],
    "参": [
        {
            "line": "参差荇菜，左右流之",
            "poemId": "poem_0"
        },
        {
            "line": "参差荇菜，左右采之",
            "poemId": "poem_0"
        },
        {
            "line": "参差荇菜，左右芼之",
            "poemId": "poem_0"
        },
        {
            "line": "参差连曲陌，迢递送斜晖",
            "poemId": "poem_387"
        }
    ],
    "求": [
        {
            "line": "求之不得，寤寐思服",
            "poemId": "poem_0"
        }
    ],
    "悠": [
        {
            "line": "悠哉悠哉，辗转反侧",
            "poemId": "poem_0"
        },
        {
            "line": "悠悠生死别经年，魂魄不曾来入梦",
            "poemId": "poem_526"
        }
    ],
    "采": [
        {
            "line": "采薇采薇，薇亦作止",
            "poemId": "poem_1"
        },
        {
            "line": "采薇采薇，薇亦柔止",
            "poemId": "poem_1"
        },
        {
            "line": "采薇采薇，薇亦刚止",
            "poemId": "poem_1"
        },
        {
            "line": "采之欲遗谁，所思在远道",
            "poemId": "poem_25"
        },
        {
            "line": "采菊东篱下，悠然见南山",
            "poemId": "poem_44"
        }
    ],
    "曰": [
        {
            "line": "曰归曰归，岁亦莫止",
            "poemId": "poem_1"
        },
        {
            "line": "曰归曰归，心亦忧止",
            "poemId": "poem_1"
        },
        {
            "line": "曰归曰归，岁亦阳止",
            "poemId": "poem_1"
        }
    ],
    " ": [
        {
            "line": " 靡室靡家，猃狁之故",
            "poemId": "poem_1"
        },
        {
            "line": " 忧心烈烈，载饥载渴",
            "poemId": "poem_1"
        },
        {
            "line": " 王事靡盬，不遑启处",
            "poemId": "poem_1"
        },
        {
            "line": " 戎车既驾，四牡业业",
            "poemId": "poem_1"
        },
        {
            "line": " 四牡翼翼，象弭鱼服",
            "poemId": "poem_1"
        },
        {
            "line": " 行道迟迟，载渴载饥",
            "poemId": "poem_1"
        },
        {
            "line": " 少小去乡邑，扬声沙漠垂",
            "poemId": "poem_38"
        },
        {
            "line": " 众鸟欣有托，吾亦爱吾庐",
            "poemId": "poem_61"
        },
        {
            "line": " 既耕亦已种，时还读我书",
            "poemId": "poem_61"
        },
        {
            "line": " 穷巷隔深辙，颇回故人车",
            "poemId": "poem_61"
        },
        {
            "line": " 欢言酌春酒，摘我园中蔬",
            "poemId": "poem_61"
        },
        {
            "line": " 微雨从东来，好风与之俱",
            "poemId": "poem_61"
        },
        {
            "line": " 泛览《周王传》，流观《山海》图",
            "poemId": "poem_61"
        },
        {
            "line": " 俯仰终宇宙，不乐复何如",
            "poemId": "poem_61"
        },
        {
            "line": " ",
            "poemId": "poem_73"
        },
        {
            "line": " ",
            "poemId": "poem_78"
        },
        {
            "line": " ",
            "poemId": "poem_129"
        },
        {
            "line": " ",
            "poemId": "poem_141"
        },
        {
            "line": " 万顷波光摇月碎，一天风露藕花香",
            "poemId": "poem_204"
        },
        {
            "line": " ",
            "poemId": "poem_204"
        },
        {
            "line": " 平阳歌舞新承宠，帘外春寒赐锦袍",
            "poemId": "poem_309"
        },
        {
            "line": " 含情欲说宫中事，鹦鹉前头不敢言",
            "poemId": "poem_313"
        },
        {
            "line": " 红颜未老恩先断，斜倚薰笼坐到明",
            "poemId": "poem_314"
        },
        {
            "line": " 妆罢低声问夫婿，画眉深浅入时无",
            "poemId": "poem_315"
        },
        {
            "line": " 马上相逢无纸笔，凭君传语报平安",
            "poemId": "poem_319"
        },
        {
            "line": " 春风举国裁宫锦，半作障泥半作帆",
            "poemId": "poem_321"
        },
        {
            "line": " 八骏日行三万里，穆王何事不重来",
            "poemId": "poem_322"
        },
        {
            "line": " 何当共剪西窗烛，却话巴山夜雨时",
            "poemId": "poem_324"
        },
        {
            "line": " 无端嫁得金龟婿，辜负香衾事早朝",
            "poemId": "poem_325"
        },
        {
            "line": " 正是江南好风景，落花时节又逢君",
            "poemId": "poem_326"
        },
        {
            "line": " 休问梁园旧宾客，茂陵秋雨病相如",
            "poemId": "poem_327"
        },
        {
            "line": " 欲把一麾江海去，乐游原上望昭陵",
            "poemId": "poem_333"
        },
        {
            "line": " 三春白雪归青冢，万里黄河绕黑山",
            "poemId": "poem_336"
        },
        {
            "line": " 君看六幅南朝事，老木寒云满故城",
            "poemId": "poem_338"
        },
        {
            "line": " 春潮带雨晚来急，野渡无人舟自横",
            "poemId": "poem_339"
        },
        {
            "line": " 桃花尽日随流水，洞在清溪何处边",
            "poemId": "poem_340"
        },
        {
            "line": " 潮落夜江斜月里，两三星火是瓜州",
            "poemId": "poem_342"
        },
        {
            "line": " 昨夜上皇新授箓，太真含笑入帘来",
            "poemId": "poem_344"
        },
        {
            "line": " 旧时王谢堂前燕，飞入寻常百姓家",
            "poemId": "poem_349"
        },
        {
            "line": " 寂寞空庭春欲晚，梨花满地不开门",
            "poemId": "poem_351"
        },
        {
            "line": " 雁声远过潇湘去，十二楼中月自明",
            "poemId": "poem_352"
        },
        {
            "line": " 日暮汉宫传蜡烛，轻烟散入五侯家",
            "poemId": "poem_353"
        },
        {
            "line": " 君门一入无由出，唯有宫莺得见人",
            "poemId": "poem_357"
        },
        {
            "line": " 郡邑浮前浦，波澜动远空",
            "poemId": "poem_358"
        },
        {
            "line": " 今夜偏知春气暖，虫声新透绿窗纱",
            "poemId": "poem_359"
        },
        {
            "line": " 分野中峰变，阴晴众壑殊",
            "poemId": "poem_360"
        },
        {
            "line": " 行到中庭数花朵，蜻蜓飞上玉搔头",
            "poemId": "poem_361"
        },
        {
            "line": " 松风吹解带，山月照弹琴",
            "poemId": "poem_363"
        },
        {
            "line": " 荒城临古渡，落日满秋山",
            "poemId": "poem_365"
        },
        {
            "line": " 八尺龙须方锦褥，已凉天气未寒时",
            "poemId": "poem_368"
        },
        {
            "line": " 晓月过残垒，繁星宿故关",
            "poemId": "poem_373"
        },
        {
            "line": " 江静潮初落，林昏瘴不开",
            "poemId": "poem_374"
        },
        {
            "line": " 客心洗流水，馀响入霜钟",
            "poemId": "poem_375"
        },
        {
            "line": " 醉月频中圣，迷花不事君",
            "poemId": "poem_377"
        },
        {
            "line": " 白发悲花落，青云羡鸟飞",
            "poemId": "poem_380"
        },
        {
            "line": " 北斗兼春远，南陵寓使迟",
            "poemId": "poem_382"
        },
        {
            "line": " 独敲初夜磬，闲倚一枝藤",
            "poemId": "poem_383"
        },
        {
            "line": " 薄宦梗犹泛，故园芜已平",
            "poemId": "poem_384"
        },
        {
            "line": " 肠断未忍扫，眼穿仍欲归",
            "poemId": "poem_387"
        },
        {
            "line": " 列郡讴歌惜，三朝出入荣",
            "poemId": "poem_388"
        },
        {
            "line": " 香雾云鬟湿，清辉玉臂寒",
            "poemId": "poem_389"
        },
        {
            "line": " 近得归京邑，移官岂至尊",
            "poemId": "poem_392"
        },
        {
            "line": " 对棋陪谢傅，把剑觅徐君",
            "poemId": "poem_394"
        },
        {
            "line": " 风暖鸟声碎，日高花影重",
            "poemId": "poem_397"
        },
        {
            "line": " 不寝听金钥，因风想玉珂",
            "poemId": "poem_399"
        },
        {
            "line": " 建德非吾土，维扬忆旧游",
            "poemId": "poem_400"
        },
        {
            "line": " 白发催年老，青阳逼岁除",
            "poemId": "poem_403"
        },
        {
            "line": " 欲济无舟楫，端居耻圣明",
            "poemId": "poem_406"
        },
        {
            "line": " 芳草已云暮，故人殊未来",
            "poemId": "poem_409"
        },
        {
            "line": " 海门深不见，浦树远含滋",
            "poemId": "poem_411"
        },
        {
            "line": " 叹凤嗟身否，伤麟怨道穷",
            "poemId": "poem_412"
        },
        {
            "line": " 丹灶初开火，仙桃正落花",
            "poemId": "poem_415"
        },
        {
            "line": " 大汉无兵阻，穷边有客游",
            "poemId": "poem_420"
        },
        {
            "line": " 无人收废帐，归马识残旗",
            "poemId": "poem_421"
        },
        {
            "line": " 岭猿同旦暮，江柳共风烟",
            "poemId": "poem_422"
        },
        {
            "line": " 树色随山迥，河声入海遥",
            "poemId": "poem_423"
        },
        {
            "line": " 过雨看松色，随山到水源",
            "poemId": "poem_424"
        },
        {
            "line": " 江上几人在，天涯孤棹还",
            "poemId": "poem_425"
        },
        {
            "line": " 扣门无犬吠，欲去问西家",
            "poemId": "poem_428"
        },
        {
            "line": " 得相能开国，生儿不象贤",
            "poemId": "poem_430"
        },
        {
            "line": " 闲门向山路，深柳读书堂",
            "poemId": "poem_432"
        },
        {
            "line": " 闲鹭栖常早，秋花落更迟",
            "poemId": "poem_434"
        },
        {
            "line": " 风枝惊暗鹊，露草覆寒蛩",
            "poemId": "poem_438"
        },
        {
            "line": " 节候看应晚，心期卧亦赊",
            "poemId": "poem_441"
        },
        {
            "line": " 春风不相识，何事入罗帏",
            "poemId": "poem_499"
        },
        {
            "line": " ",
            "poemId": "poem_505"
        },
        {
            "line": " 若非巾柴车，应是钓秋水",
            "poemId": "poem_508"
        },
        {
            "line": " 草色新雨中，松声晚窗里",
            "poemId": "poem_508"
        },
        {
            "line": " 虽无宾主意，颇得清净理",
            "poemId": "poem_508"
        },
        {
            "line": " 樵人归欲尽，烟鸟栖初定",
            "poemId": "poem_512"
        },
        {
            "line": " 晓耕翻露草，夜榜响溪石",
            "poemId": "poem_513"
        },
        {
            "line": " 冥冥花正开，飏飏燕新乳",
            "poemId": "poem_514"
        },
        {
            "line": " 人归山郭暗，雁下芦洲白",
            "poemId": "poem_516"
        },
        {
            "line": " 今朝此为别，何处还相遇",
            "poemId": "poem_520"
        },
        {
            "line": " 茅亭宿花影，药院滋苔纹",
            "poemId": "poem_522"
        },
        {
            "line": " 轮台九月风夜吼，一川碎石大如斗，随风满地石乱走",
            "poemId": "poem_531"
        },
        {
            "line": " 匈奴草黄马正肥，金山西见烟尘飞，汉家大将西出师",
            "poemId": "poem_531"
        },
        {
            "line": " 将军金甲夜不脱，半夜军行戈相拨，风头如刀面如割",
            "poemId": "poem_531"
        },
        {
            "line": " 马毛带雪汗气蒸，五花连钱旋作冰，幕中草檄砚水凝",
            "poemId": "poem_531"
        },
        {
            "line": " 虏骑闻之应胆慑，料知短兵不敢接，车师西门伫献捷",
            "poemId": "poem_531"
        },
        {
            "line": " 霓为衣兮风为马，云之君兮纷纷而来下",
            "poemId": "poem_534"
        },
        {
            "line": " 行军司马智且勇，十四万众犹虎貔",
            "poemId": "poem_536"
        },
        {
            "line": " 世人解听不解赏，长飙风中自来往",
            "poemId": "poem_538"
        },
        {
            "line": " 忽然更作渔阳掺，黄云萧条白日暗",
            "poemId": "poem_538"
        },
        {
            "line": " 若非群玉山头见，会向瑶台月下逢",
            "poemId": "poem_568"
        }
    ],
    "不": [
        {
            "line": "不遑启居，猃狁之故",
            "poemId": "poem_1"
        },
        {
            "line": "不如子之衣，安且吉兮",
            "poemId": "poem_7"
        },
        {
            "line": "不如子之衣，安且燠兮",
            "poemId": "poem_7"
        },
        {
            "line": "不稼不穑，胡取禾三百廛兮",
            "poemId": "poem_12"
        },
        {
            "line": "不狩不猎，胡瞻尔庭有县貆兮",
            "poemId": "poem_12"
        },
        {
            "line": "不稼不穑，胡取禾三百亿兮",
            "poemId": "poem_12"
        },
        {
            "line": "不狩不猎，胡瞻尔庭有县特兮",
            "poemId": "poem_12"
        },
        {
            "line": "不稼不穑，胡取禾三百囷兮",
            "poemId": "poem_12"
        },
        {
            "line": "不狩不猎，胡瞻尔庭有县鹑兮",
            "poemId": "poem_12"
        },
        {
            "line": "不聊忧餐食，慊慊常饥空",
            "poemId": "poem_40"
        },
        {
            "line": "不管烟波与风雨，载将离恨过江南",
            "poemId": "poem_81"
        },
        {
            "line": "不上楼来知几日，满城无算柳梢黄",
            "poemId": "poem_102"
        },
        {
            "line": "不能手提天下往，何忍身去游其间",
            "poemId": "poem_116"
        },
        {
            "line": "不识庐山真面目，只缘身在此山中",
            "poemId": "poem_123"
        },
        {
            "line": "不愁屋漏床床湿，且喜溪流岸岸深",
            "poemId": "poem_149"
        },
        {
            "line": "不因送客东城去，过却春光总不知",
            "poemId": "poem_203"
        },
        {
            "line": "不要人夸颜色好，只流清气满乾坤",
            "poemId": "poem_205"
        },
        {
            "line": "不要人夸好颜色，只留清气满乾坤",
            "poemId": "poem_205"
        },
        {
            "line": "不炼金丹不坐禅，不为商贾不耕田",
            "poemId": "poem_221"
        },
        {
            "line": "不知天外雁，何事乐长征",
            "poemId": "poem_222"
        },
        {
            "line": "不见两关传露布，尚闻三殿未垂衣",
            "poemId": "poem_235"
        },
        {
            "line": "不当差，不纳粮，大家快活过一场",
            "poemId": "poem_237"
        },
        {
            "line": "不惜千金买宝刀，貂裘换酒也堪豪",
            "poemId": "poem_275"
        },
        {
            "line": "不知香积寺，数里入云峰",
            "poemId": "poem_369"
        },
        {
            "line": "不觉碧山暮，秋云暗几重",
            "poemId": "poem_375"
        },
        {
            "line": "不才明主弃，多病故人疏",
            "poemId": "poem_403"
        },
        {
            "line": "不堪盈手赠，还寝梦佳期",
            "poemId": "poem_419"
        },
        {
            "line": "不据山河据平地，长戈利矛日可麾",
            "poemId": "poem_536"
        },
        {
            "line": "不露文章世已惊，未辞翦伐谁能送",
            "poemId": "poem_541"
        },
        {
            "line": "不疑灵境难闻见，尘心未尽思乡县",
            "poemId": "poem_564"
        },
        {
            "line": "不复醒 一作：不愿醒/不用醒)古来圣贤皆寂寞，惟有饮者留其名",
            "poemId": "poem_570"
        },
        {
            "line": "不信妾断肠，归来看取明镜前",
            "poemId": "poem_574"
        },
        {
            "line": "不敢长语临交衢，且为王孙立斯须",
            "poemId": "poem_585"
        }
    ],
    "我": [
        {
            "line": "我戍未定，靡使归聘",
            "poemId": "poem_1"
        },
        {
            "line": "我心伤悲，莫知我哀",
            "poemId": "poem_1"
        },
        {
            "line": "我有嘉宾，鼓瑟吹笙",
            "poemId": "poem_32"
        },
        {
            "line": "我是虏家儿，不解汉儿歌",
            "poemId": "poem_73"
        },
        {
            "line": "我亦且如常日醉，莫教弦管作离声",
            "poemId": "poem_108"
        },
        {
            "line": "我劝天公重抖擞，不拘一格降人才",
            "poemId": "poem_266"
        },
        {
            "line": "我自横刀向天笑，去留肝胆两昆仑",
            "poemId": "poem_273"
        },
        {
            "line": "我行殊未已，何日复归来",
            "poemId": "poem_374"
        },
        {
            "line": "我家襄水曲，遥隔楚云端",
            "poemId": "poem_401"
        },
        {
            "line": "我心素已闲，清川澹如此",
            "poemId": "poem_494"
        },
        {
            "line": "我歌月徘徊，我舞影零乱",
            "poemId": "poem_498"
        },
        {
            "line": "我醉君复乐，陶然共忘机",
            "poemId": "poem_507"
        },
        {
            "line": "我持长瓢坐巴丘，酌饮四坐以散愁",
            "poemId": "poem_528"
        },
        {
            "line": "我闻琵琶已叹息，又闻此语重唧唧",
            "poemId": "poem_529"
        },
        {
            "line": "我从去年辞帝京，谪居卧病浔阳城",
            "poemId": "poem_529"
        },
        {
            "line": "我本楚狂人，凤歌笑孔丘",
            "poemId": "poem_540"
        },
        {
            "line": "我来正逢秋雨节，阴气晦昧无清风",
            "poemId": "poem_553"
        }
    ],
    "忧": [
        {
            "line": "忧心孔疚，我行不来",
            "poemId": "poem_1"
        },
        {
            "line": "忧愁不能寐，揽衣起徘徊",
            "poemId": "poem_19"
        },
        {
            "line": "忧从中来，不可断绝",
            "poemId": "poem_32"
        },
        {
            "line": "忧思独伤心",
            "poemId": "poem_37"
        }
    ],
    "彼": [
        {
            "line": "彼尔维何",
            "poemId": "poem_1"
        },
        {
            "line": "彼路斯何",
            "poemId": "poem_1"
        },
        {
            "line": "彼君子兮，不素餐兮",
            "poemId": "poem_12"
        },
        {
            "line": "彼君子兮，不素食兮",
            "poemId": "poem_12"
        },
        {
            "line": "彼君子兮，不素飧兮",
            "poemId": "poem_12"
        }
    ],
    "维": [
        {
            "line": "维常之华",
            "poemId": "poem_1"
        }
    ],
    "君": [
        {
            "line": "君子之车",
            "poemId": "poem_1"
        },
        {
            "line": "君子所依，小人所腓",
            "poemId": "poem_1"
        },
        {
            "line": "君去日已远，郁结令人老",
            "poemId": "poem_40"
        },
        {
            "line": "君子死知己，提剑出燕京",
            "poemId": "poem_48"
        },
        {
            "line": "君看萧萧只数叶，满堂风雨不胜寒",
            "poemId": "poem_220"
        },
        {
            "line": "君看落空阔，何异大星芒",
            "poemId": "poem_250"
        },
        {
            "line": "君自故乡来，应知故乡事",
            "poemId": "poem_281"
        },
        {
            "line": "君问归期未有期，巴山夜雨涨秋池",
            "poemId": "poem_324"
        },
        {
            "line": "君问穷通理，渔歌入浦深",
            "poemId": "poem_363"
        },
        {
            "line": "君宠益娇态，君怜无是非",
            "poemId": "poem_496"
        },
        {
            "line": "君言不得意，归卧南山陲",
            "poemId": "poem_500"
        },
        {
            "line": "君今在罗网，何以有羽翼",
            "poemId": "poem_501"
        },
        {
            "line": "君今在罗网，何以有羽翼",
            "poemId": "poem_501"
        },
        {
            "line": "君王掩面救不得，回看血泪相和流",
            "poemId": "poem_526"
        },
        {
            "line": "君臣相顾尽沾衣，东望都门信马归",
            "poemId": "poem_526"
        },
        {
            "line": "君不见走马川行雪海边，平沙莽莽黄入天",
            "poemId": "poem_531"
        },
        {
            "line": "君臣已与时际会，树木犹为人爱惜",
            "poemId": "poem_541"
        },
        {
            "line": "君不见金粟堆前松柏里，龙媒去尽鸟呼风",
            "poemId": "poem_547"
        },
        {
            "line": "君歌声酸辞且苦，不能听终泪如雨",
            "poemId": "poem_554"
        },
        {
            "line": "君歌且休听我歌，我歌今与君殊科",
            "poemId": "poem_554"
        },
        {
            "line": "君不见昔时燕家重郭隗，拥篲折节无嫌猜",
            "poemId": "poem_567"
        },
        {
            "line": "君不见，黄河之水天上来，奔流到海不复回",
            "poemId": "poem_570"
        },
        {
            "line": "君不见，高堂明镜悲白发，朝如青丝暮成雪",
            "poemId": "poem_570"
        },
        {
            "line": "君不见吴中张翰称达生，秋风忽忆江东行",
            "poemId": "poem_573"
        },
        {
            "line": "君不闻汉家山东二百州，千村万落生荆杞",
            "poemId": "poem_583"
        },
        {
            "line": "君不见，青海头，古来白骨无人收",
            "poemId": "poem_583"
        },
        {
            "line": "君不见沙场征战苦，至今犹忆李将军",
            "poemId": "poem_591"
        },
        {
            "line": "君家何处住，妾住在横塘",
            "poemId": "poem_598"
        }
    ],
    "岂": [
        {
            "line": "岂敢定居",
            "poemId": "poem_1"
        },
        {
            "line": "岂不日戒",
            "poemId": "poem_1"
        },
        {
            "line": "岂曰无衣",
            "poemId": "poem_7"
        },
        {
            "line": "岂曰无衣",
            "poemId": "poem_7"
        },
        {
            "line": "岂不罹凝寒，松柏有本性",
            "poemId": "poem_33"
        },
        {
            "line": "岂伊地气暖",
            "poemId": "poem_525"
        },
        {
            "line": "岂无山歌与村笛",
            "poemId": "poem_529"
        }
    ],
    "一": [
        {
            "line": "一月三捷",
            "poemId": "poem_1"
        },
        {
            "line": "一顾倾人城",
            "poemId": "poem_11"
        },
        {
            "line": "一苇杭之",
            "poemId": "poem_16"
        },
        {
            "line": "一阕声长听不尽，轻舟短楫去如飞",
            "poemId": "poem_96"
        },
        {
            "line": "一雨池塘水面平，淡磨明镜照檐楹",
            "poemId": "poem_114"
        },
        {
            "line": "一番桃李花开尽，惟有青青草色齐",
            "poemId": "poem_115"
        },
        {
            "line": "一年好景君须记，最是橙黄橘绿时",
            "poemId": "poem_124"
        },
        {
            "line": "一夕轻雷落万丝，霁光浮瓦碧参差",
            "poemId": "poem_134"
        },
        {
            "line": "一春略无十日晴，处处浮云将雨行",
            "poemId": "poem_142"
        },
        {
            "line": "一夕骄阳转作霖，梦回凉冷润衣襟",
            "poemId": "poem_149"
        },
        {
            "line": "一自胡尘入汉关，十年伊洛路漫漫",
            "poemId": "poem_152"
        },
        {
            "line": "一担乾柴古渡头，盘缠一日颇优游",
            "poemId": "poem_155"
        },
        {
            "line": "一叶渔船两小童，收篙停棹坐船中",
            "poemId": "poem_171"
        },
        {
            "line": "一片能教一断肠，可堪平砌更堆墙",
            "poemId": "poem_186"
        },
        {
            "line": "一击车中胆气豪，祖龙社稷已惊摇",
            "poemId": "poem_208"
        },
        {
            "line": "一灯群动息，孤磬四天空",
            "poemId": "poem_253"
        },
        {
            "line": "一腔热血勤珍重，洒去犹能化碧涛",
            "poemId": "poem_275"
        },
        {
            "line": "一声何满子，双泪落君前",
            "poemId": "poem_299"
        },
        {
            "line": "一丘常欲卧，三径苦无资",
            "poemId": "poem_405"
        },
        {
            "line": "一路经行处，莓苔见履痕",
            "poemId": "poem_424"
        },
        {
            "line": "一去紫台连朔漠，独留青冢向黄昏",
            "poemId": "poem_459"
        },
        {
            "line": "一声已动物皆静，四座无言星欲稀",
            "poemId": "poem_539"
        },
        {
            "line": "一年明月今宵多，人生由命非由他",
            "poemId": "poem_554"
        },
        {
            "line": "一身转战三千里，一剑曾当百万师",
            "poemId": "poem_561"
        },
        {
            "line": "一枝红艳露凝香，云雨巫山枉断肠",
            "poemId": "poem_569"
        }
    ],
    "驾": [
        {
            "line": "驾彼四牡，四牡骙骙",
            "poemId": "poem_1"
        }
    ],
    "猃": [
        {
            "line": "猃狁孔棘",
            "poemId": "poem_1"
        }
    ],
    "昔": [
        {
            "line": "昔我往矣，杨柳依依",
            "poemId": "poem_1"
        },
        {
            "line": "昔闻洞庭水，今上岳阳楼",
            "poemId": "poem_386"
        },
        {
            "line": "昔日戏言身后意，今朝都到眼前来",
            "poemId": "poem_437"
        },
        {
            "line": "昔人已乘黄鹤去，此地空余黄鹤楼",
            "poemId": "poem_478"
        },
        {
            "line": "昔岁逢太平，山林二十年",
            "poemId": "poem_502"
        },
        {
            "line": "昔别君未婚，儿女忽成行",
            "poemId": "poem_505"
        },
        {
            "line": "昔有佳人公孙氏，一舞剑器动四方",
            "poemId": "poem_542"
        },
        {
            "line": "昔随刘氏定长安，帷幄未改神惨伤",
            "poemId": "poem_546"
        },
        {
            "line": "昔日太宗拳毛騧，近时郭家狮子花",
            "poemId": "poem_547"
        },
        {
            "line": "昔日长城战，咸言意气高",
            "poemId": "poem_558"
        },
        {
            "line": "昔时飞箭无全目，今日垂杨生左肘",
            "poemId": "poem_561"
        }
    ],
    "今": [
        {
            "line": "今我来思，雨雪霏霏",
            "poemId": "poem_1"
        },
        {
            "line": "今宵绝胜无人共，卧看星河尽意明",
            "poemId": "poem_157"
        },
        {
            "line": "今日复今日，今日何其少",
            "poemId": "poem_232"
        },
        {
            "line": "今日又不为，此事何其了",
            "poemId": "poem_232"
        },
        {
            "line": "今夜鄜州月，闺中只独看",
            "poemId": "poem_389"
        },
        {
            "line": "今看两楹奠，当与梦时同",
            "poemId": "poem_412"
        },
        {
            "line": "今日俸钱过十万，与君营奠复营斋",
            "poemId": "poem_442"
        },
        {
            "line": "今逢四海为家日，故垒萧萧芦荻秋",
            "poemId": "poem_483"
        },
        {
            "line": "今日龙钟人共弃，愧君犹遣慎风波",
            "poemId": "poem_491"
        },
        {
            "line": "今来典斯郡，山夷又纷然",
            "poemId": "poem_502"
        },
        {
            "line": "今彼征敛者，迫之如火煎",
            "poemId": "poem_502"
        },
        {
            "line": "今夕复何夕，共此灯烛光",
            "poemId": "poem_505"
        },
        {
            "line": "今朝郡斋冷，忽念山中客",
            "poemId": "poem_519"
        },
        {
            "line": "今我游冥冥，弋者何所慕",
            "poemId": "poem_521"
        },
        {
            "line": "今夜闻君琵琶语，如听仙乐耳暂明",
            "poemId": "poem_529"
        },
        {
            "line": "今为羌笛出塞声，使我三军泪如雨",
            "poemId": "poem_545"
        },
        {
            "line": "今我不乐思岳阳，身欲奋飞病在床",
            "poemId": "poem_546"
        },
        {
            "line": "今之新图有二马，复令识者久叹嗟",
            "poemId": "poem_547"
        }
    ],
    "蒹": [
        {
            "line": "蒹葭苍苍，白露为霜",
            "poemId": "poem_2"
        },
        {
            "line": "蒹葭萋萋，白露未晞",
            "poemId": "poem_2"
        },
        {
            "line": "蒹葭采采，白露未已",
            "poemId": "poem_2"
        }
    ],
    "所": [
        {
            "line": "所谓伊人，在水一方",
            "poemId": "poem_2"
        },
        {
            "line": "所谓伊人，在水之湄",
            "poemId": "poem_2"
        },
        {
            "line": "所谓伊人，在水之涘",
            "poemId": "poem_2"
        },
        {
            "line": "所遇无故物，焉得不速老",
            "poemId": "poem_26"
        },
        {
            "line": "所守或匪亲，化为狼与豺",
            "poemId": "poem_576"
        }
    ],
    "溯": [
        {
            "line": "溯洄从之，道阻且长",
            "poemId": "poem_2"
        },
        {
            "line": "溯游从之，宛在水中央",
            "poemId": "poem_2"
        },
        {
            "line": "溯洄从之，道阻且跻",
            "poemId": "poem_2"
        },
        {
            "line": "溯游从之，宛在水中坻",
            "poemId": "poem_2"
        },
        {
            "line": "溯洄从之，道阻且右",
            "poemId": "poem_2"
        },
        {
            "line": "溯游从之，宛在水中沚",
            "poemId": "poem_2"
        }
    ],
    "桃": [
        {
            "line": "桃之夭夭，灼灼其华",
            "poemId": "poem_3"
        },
        {
            "line": "桃之夭夭，有蕡其实",
            "poemId": "poem_3"
        },
        {
            "line": "桃之夭夭，其叶蓁蓁",
            "poemId": "poem_3"
        },
        {
            "line": "桃花嫣然出篱笑，似开未开最有情",
            "poemId": "poem_142"
        }
    ],
    "之": [
        {
            "line": "之子于归，宜其室家",
            "poemId": "poem_3"
        },
        {
            "line": "之子于归，宜其家室",
            "poemId": "poem_3"
        },
        {
            "line": "之子于归，宜其家人",
            "poemId": "poem_3"
        },
        {
            "line": "之子期宿来，孤琴候萝径",
            "poemId": "poem_512"
        }
    ],
    "日": [
        {
            "line": "日出而作，日入而息",
            "poemId": "poem_4"
        },
        {
            "line": "日月之行，若出其中",
            "poemId": "poem_31"
        },
        {
            "line": "日暮平沙秋草乱，一双白鸟避人飞",
            "poemId": "poem_235"
        },
        {
            "line": "日暮东风怨啼鸟，落花犹似坠楼人",
            "poemId": "poem_330"
        },
        {
            "line": "日光斜照集灵台，红树花迎晓露开",
            "poemId": "poem_344"
        },
        {
            "line": "日夕凉风至，闻蝉但益悲",
            "poemId": "poem_405"
        },
        {
            "line": "日暮乡关何处是",
            "poemId": "poem_478"
        },
        {
            "line": "日出雾露馀，青松如膏沐",
            "poemId": "poem_509"
        },
        {
            "line": "日夕怀空意，人谁感至精",
            "poemId": "poem_527"
        },
        {
            "line": "日销月铄就埋没，六年西顾空吟哦",
            "poemId": "poem_551"
        },
        {
            "line": "日色欲尽花含烟，月明欲素愁不眠",
            "poemId": "poem_574"
        }
    ],
    "凿": [
        {
            "line": "凿井而饮，耕田而食",
            "poemId": "poem_4"
        }
    ],
    "帝": [
        {
            "line": "帝力于我何有哉",
            "poemId": "poem_4"
        },
        {
            "line": "帝乡明日到，犹自梦渔樵",
            "poemId": "poem_423"
        },
        {
            "line": "帝得圣相相曰度，贼斫不死神扶持",
            "poemId": "poem_536"
        },
        {
            "line": "帝曰汝度功第一，汝从事愈宜为辞",
            "poemId": "poem_536"
        }
    ],
    "投": [
        {
            "line": "投我以木瓜，报之以琼琚",
            "poemId": "poem_5"
        },
        {
            "line": "投我以木桃，报之以琼瑶",
            "poemId": "poem_5"
        },
        {
            "line": "投我以木李，报之以琼玖",
            "poemId": "poem_5"
        },
        {
            "line": "投荒万死鬓毛斑，生出瞿塘滟滪关",
            "poemId": "poem_129"
        }
    ],
    "匪": [
        {
            "line": "匪报也，永以为好也",
            "poemId": "poem_5"
        },
        {
            "line": "匪报也，永以为好也",
            "poemId": "poem_5"
        },
        {
            "line": "匪报也，永以为好也",
            "poemId": "poem_5"
        }
    ],
    "硕": [
        {
            "line": "硕鼠硕鼠，无食我黍",
            "poemId": "poem_6"
        },
        {
            "line": "硕鼠硕鼠，无食我麦",
            "poemId": "poem_6"
        },
        {
            "line": "硕鼠硕鼠，无食我苗",
            "poemId": "poem_6"
        }
    ],
    "三": [
        {
            "line": "三岁贯女，莫我肯顾",
            "poemId": "poem_6"
        },
        {
            "line": "三岁贯女，莫我肯德",
            "poemId": "poem_6"
        },
        {
            "line": "三岁贯女，莫我肯劳",
            "poemId": "poem_6"
        },
        {
            "line": "三千里兮家未归，恨难禁兮仰天悲",
            "poemId": "poem_58"
        },
        {
            "line": "三月残花落更开，小檐日日燕飞来",
            "poemId": "poem_118"
        },
        {
            "line": "三万里河东入海，五千仞岳上摩天",
            "poemId": "poem_165"
        },
        {
            "line": "三生定自陆天随，又向顺松作客归",
            "poemId": "poem_182"
        },
        {
            "line": "三年羁旅客，今日又南冠",
            "poemId": "poem_243"
        },
        {
            "line": "三日入厨下，洗手作羹汤",
            "poemId": "poem_282"
        },
        {
            "line": "三山半落青天外，二水中分白鹭洲",
            "poemId": "poem_448"
        },
        {
            "line": "三分割据纡筹策，万古云霄一羽毛",
            "poemId": "poem_465"
        },
        {
            "line": "三峡楼台淹日月，五溪衣服共云山",
            "poemId": "poem_469"
        },
        {
            "line": "三顾频烦天下计，两朝开济老臣心",
            "poemId": "poem_471"
        },
        {
            "line": "三晋云山皆北向，二陵风雨自东来",
            "poemId": "poem_477"
        },
        {
            "line": "三年谪宦此栖迟，万古惟留楚客悲",
            "poemId": "poem_485"
        },
        {
            "line": "三湘愁鬓逢秋色，万里归心对月明",
            "poemId": "poem_487"
        },
        {
            "line": "三夜频梦君，情亲见君意",
            "poemId": "poem_503"
        },
        {
            "line": "三月三日天气新，长安水边多丽人",
            "poemId": "poem_586"
        }
    ],
    "逝": [
        {
            "line": "逝将去女，适彼乐土",
            "poemId": "poem_6"
        },
        {
            "line": "逝将去女，适彼乐国",
            "poemId": "poem_6"
        },
        {
            "line": "逝将去女，适彼乐郊",
            "poemId": "poem_6"
        }
    ],
    "乐": [
        {
            "line": "乐土乐土，爰得我所",
            "poemId": "poem_6"
        },
        {
            "line": "乐国乐国，爰得我直",
            "poemId": "poem_6"
        },
        {
            "line": "乐郊乐郊，谁之永号",
            "poemId": "poem_6"
        },
        {
            "line": "乐幽心屡止，遵事迹犹遽",
            "poemId": "poem_517"
        }
    ],
    "(": [
        {
            "line": "(女 通 汝)",
            "poemId": "poem_6"
        },
        {
            "line": "(复还 一作：复反)探虎穴兮入蛟宫，仰天呼气兮成白虹",
            "poemId": "poem_17"
        },
        {
            "line": "(此句疑为后人补作)",
            "poemId": "poem_17"
        },
        {
            "line": "(腾 一作：螣)老骥伏枥，志在千里",
            "poemId": "poem_28"
        },
        {
            "line": "(谈讌 一作：谈宴)月明星稀，乌鹊南飞",
            "poemId": "poem_32"
        },
        {
            "line": "(海 一作：水)",
            "poemId": "poem_32"
        },
        {
            "line": "(鹄南翔 一作 雁南翔）念君客游思断肠，慊慊思归恋故乡，君何淹留寄他方",
            "poemId": "poem_36"
        },
        {
            "line": "(名编 一作：名在) ",
            "poemId": "poem_38"
        },
        {
            "line": "(辨 通：辩)",
            "poemId": "poem_44"
        },
        {
            "line": "(误落 一作：误入)羁鸟恋旧林，池鱼思故渊",
            "poemId": "poem_46"
        },
        {
            "line": "(颠 通 巅)户庭无尘杂，虚室有余闲",
            "poemId": "poem_46"
        },
        {
            "line": "(折花 一作：折梅)江南无所有，聊赠一枝春",
            "poemId": "poem_54"
        },
        {
            "line": "(金尊 通：樽)",
            "poemId": "poem_88"
        },
        {
            "line": "(夏席清 一作：夏簟清)树阴满地日当午，梦觉流莺时一声",
            "poemId": "poem_98"
        },
        {
            "line": "(飞来山 一作：飞来峰)不畏浮云遮望眼，只缘身在最高层",
            "poemId": "poem_104"
        },
        {
            "line": "(只缘 一作：自缘)",
            "poemId": "poem_104"
        },
        {
            "line": "(蒙 通：濛)欲把西湖比西子，淡妆浓抹总相宜",
            "poemId": "poem_122"
        },
        {
            "line": "(淡妆浓抹 一作：浓妆淡抹)",
            "poemId": "poem_122"
        },
        {
            "line": "(最是 一作：正是) ",
            "poemId": "poem_124"
        },
        {
            "line": "(那 通：哪)",
            "poemId": "poem_174"
        },
        {
            "line": "(版本一)我家洗砚池边树，朵朵花开淡墨痕",
            "poemId": "poem_205"
        },
        {
            "line": "(版本二)",
            "poemId": "poem_205"
        },
        {
            "line": "(一作：千锤万击出深山 / 千鎚万击出深山)(一作：粉骨碎身全不惜 / 粉身碎骨浑不怕 / 粉骨碎身全不怕)",
            "poemId": "poem_218"
        },
        {
            "line": "(边草 一作：边月)一年三百六十日，多是横戈马上行",
            "poemId": "poem_231"
        },
        {
            "line": "(河山 一作：山河)已知泉路近，欲别故乡难",
            "poemId": "poem_243"
        },
        {
            "line": "(坚劲 一作：韧)",
            "poemId": "poem_251"
        },
        {
            "line": "(版本一)望门投趾怜张俭，直谏陈书愧杜根",
            "poemId": "poem_273"
        },
        {
            "line": "(版本二)",
            "poemId": "poem_273"
        },
        {
            "line": "(明年 一作：年年)",
            "poemId": "poem_284"
        },
        {
            "line": "(蛾眉 一作：蹙)但见泪痕湿，不知心恨谁",
            "poemId": "poem_294"
        },
        {
            "line": "(斜阳 一作：夕阳)",
            "poemId": "poem_303"
        },
        {
            "line": "(七弦  一作：七丝)古调虽自爱，今人多不弹",
            "poemId": "poem_304"
        },
        {
            "line": "(唯 通：惟)",
            "poemId": "poem_316"
        },
        {
            "line": "(回乐 一作：回乐）不知何处吹芦管，一夜征人尽望乡",
            "poemId": "poem_318"
        },
        {
            "line": "(江南 一作：江湖",
            "poemId": "poem_329"
        },
        {
            "line": "(天阶 一作：天街",
            "poemId": "poem_332"
        },
        {
            "line": "(春闺 一作：深闺)",
            "poemId": "poem_346"
        },
        {
            "line": "(鬓毛衰 一作：鬓毛催)儿童相见不相识，笑问客从何处来",
            "poemId": "poem_348"
        },
        {
            "line": "(馀 一作 余)复值接舆醉，狂歌五柳前",
            "poemId": "poem_366"
        },
        {
            "line": "(青山外 一作：青山下)潮平两岸阔，风正一帆悬",
            "poemId": "poem_367"
        },
        {
            "line": "(挂帆 一作：去)",
            "poemId": "poem_376"
        },
        {
            "line": "(边秋 一作:秋边)露从今夜白，月是故乡明",
            "poemId": "poem_393"
        },
        {
            "line": "(孤帆 一作：归帆)迷津欲有问，平海夕漫漫",
            "poemId": "poem_401"
        },
        {
            "line": "(尚在 一作：字在)",
            "poemId": "poem_408"
        },
        {
            "line": "(版本一)清晨入古寺，初日照高林",
            "poemId": "poem_418"
        },
        {
            "line": "(版本二)清晨入古寺，初日照高林",
            "poemId": "poem_418"
        },
        {
            "line": "(版本三)清晨入古寺，初日照高林",
            "poemId": "poem_418"
        },
        {
            "line": "(版本四)",
            "poemId": "poem_418"
        },
        {
            "line": "(自堪悲 一作：正堪悲)路出寒云外，人归暮雪时",
            "poemId": "poem_431"
        },
        {
            "line": "(客思深 一作：客思侵)不堪玄鬓影，来对白头吟",
            "poemId": "poem_436"
        },
        {
            "line": "(不堪 一作：那堪)露重飞难进，风多响易沉",
            "poemId": "poem_436"
        },
        {
            "line": "(身后意 一作：身后事)衣裳已施行看尽，针线犹存未忍开",
            "poemId": "poem_437"
        },
        {
            "line": "(荩箧 一作：画箧)野蔬充膳甘长藿，落叶添薪仰古槐",
            "poemId": "poem_442"
        },
        {
            "line": "(二水 一作：一水)总为浮云能蔽日，长安不见使人愁",
            "poemId": "poem_448"
        },
        {
            "line": "(蓬山 一作：蓬莱)",
            "poemId": "poem_450"
        },
        {
            "line": "(色 一作：曙)莫见长安行乐处，空令岁月易蹉跎",
            "poemId": "poem_458"
        },
        {
            "line": "(夜月 一作：月夜 环 一作：环)千载琵琶作胡语，分明怨恨曲中论",
            "poemId": "poem_459"
        },
        {
            "line": "(版本一)岁暮阴阳催短景，天涯霜雪霁寒宵",
            "poemId": "poem_462"
        },
        {
            "line": "(版本二)",
            "poemId": "poem_462"
        },
        {
            "line": "(梁甫 一作：梁父)",
            "poemId": "poem_466"
        },
        {
            "line": "(惟 通：唯)跨马出郊时极目，不堪人事日萧条",
            "poemId": "poem_468"
        },
        {
            "line": "(频烦 一作：频频)出师未捷身先死，长使英雄泪满襟",
            "poemId": "poem_471"
        },
        {
            "line": "(馀 通：余)",
            "poemId": "poem_472"
        },
        {
            "line": "(层城 一作：秦城)机中锦字论长恨，楼上花枝笑独眠",
            "poemId": "poem_474"
        },
        {
            "line": "(笳鼓 一作：箫鼓)万里寒光生积雪，三边曙色动危旌",
            "poemId": "poem_480"
        },
        {
            "line": "(独 一作：“戍”)贾谊上书忧汉室，长沙谪去古今怜",
            "poemId": "poem_486"
        },
        {
            "line": "(斜 一作：光)野老念牧童，倚杖候荆扉",
            "poemId": "poem_493"
        },
        {
            "line": "(磐石 一作：盘石)",
            "poemId": "poem_494"
        },
        {
            "line": "(凑 一作：走",
            "poemId": "poem_497"
        },
        {
            "line": "(馆 一作：观)秋色从西来，苍然满关中",
            "poemId": "poem_497"
        },
        {
            "line": "(同交欢 一作：相交欢)永结无情游，相期邈云汉",
            "poemId": "poem_498"
        },
        {
            "line": "(版本一)死别已吞声，生别常恻恻",
            "poemId": "poem_501"
        },
        {
            "line": "(版本二)",
            "poemId": "poem_501"
        },
        {
            "line": "( 曾 通：层)会当凌绝顶，一览众山小",
            "poemId": "poem_504"
        },
        {
            "line": "(试 一作 始)愁因薄暮起，兴是清秋发",
            "poemId": "poem_510"
        },
        {
            "line": "(宵 一作：终)",
            "poemId": "poem_511"
        },
        {
            "line": "(花开日 一作：花开夜",
            "poemId": "poem_526"
        },
        {
            "line": "(阑 通：栏",
            "poemId": "poem_526"
        },
        {
            "line": "(暂歇 一作：渐歇)别有幽愁暗恨生，此时无声胜有声",
            "poemId": "poem_529"
        },
        {
            "line": "(银篦 一作：云篦)今年欢笑复明年，秋月春风等闲度",
            "poemId": "poem_529"
        },
        {
            "line": "(难着 一作：犹著)瀚海阑干百丈冰，愁云惨淡万里凝",
            "poemId": "poem_530"
        },
        {
            "line": "(雪片阔 一作：云片阔)亚相勤王甘苦辛，誓将报主静边尘",
            "poemId": "poem_532"
        },
        {
            "line": "(览 通：揽",
            "poemId": "poem_533"
        },
        {
            "line": "(销愁 一作 消愁）人生在世不称意，明朝散发弄扁舟",
            "poemId": "poem_533"
        },
        {
            "line": "(四万 一作：一万)我欲因之梦吴越，一夜飞度镜湖月",
            "poemId": "poem_534"
        },
        {
            "line": "(度 通：渡)湖月照我影，送我至剡溪",
            "poemId": "poem_534"
        },
        {
            "line": "(劝客 一作：唤客)金陵子弟来相送，欲行不行各尽觞",
            "poemId": "poem_535"
        },
        {
            "line": "(沈 通：沉)先拂商弦后角羽，四郊秋叶惊摵摵",
            "poemId": "poem_537"
        },
        {
            "line": "(鞿 一作：靰)嗟哉吾党二三子，安得至老不更归",
            "poemId": "poem_552"
        },
        {
            "line": "(一作：客舍依依杨柳春)劝君更尽一杯酒，西出阳关无故人",
            "poemId": "poem_559"
        },
        {
            "line": "(羞 通：馐",
            "poemId": "poem_566"
        },
        {
            "line": "(雪满山 一作：雪暗天)闲来垂钓碧溪上，忽复乘舟梦日边",
            "poemId": "poem_566"
        },
        {
            "line": "(碧 一作：坐)行路难",
            "poemId": "poem_566"
        },
        {
            "line": "(倾耳听 一作：侧耳听)钟鼓馔玉不足贵，但愿长醉不复醒",
            "poemId": "poem_570"
        },
        {
            "line": "(不足贵 一作：何足贵",
            "poemId": "poem_570"
        },
        {
            "line": "(古来 一作：自古",
            "poemId": "poem_570"
        },
        {
            "line": "(水晶 一作 水精) ",
            "poemId": "poem_571"
        },
        {
            "line": "(断肠 一作：肠断)",
            "poemId": "poem_574"
        },
        {
            "line": "(猿 一作：鸣)门前迟行迹，一一生绿苔",
            "poemId": "poem_575"
        },
        {
            "line": "(攀援 一作：攀缘)青泥何盘盘，百步九折萦岩峦",
            "poemId": "poem_576"
        },
        {
            "line": "(也若此 一作：也如此)剑阁峥嵘而崔嵬，一夫当关，万夫莫开",
            "poemId": "poem_576"
        },
        {
            "line": "(望边邑 一作：望边色)高楼当此夜，叹息未应闲",
            "poemId": "poem_581"
        },
        {
            "line": "(娘 一作：“爷”)牵衣顿足拦道哭，哭声直上干云霄",
            "poemId": "poem_583"
        },
        {
            "line": "(惜取 一作：须取)花开堪折直须折，莫待无花空折枝",
            "poemId": "poem_588"
        },
        {
            "line": "(花开 一作：有花)",
            "poemId": "poem_588"
        },
        {
            "line": "(古井水 一作：井中水)",
            "poemId": "poem_590"
        },
        {
            "line": "(常轻敌 一作：恒轻敌)铁衣远戍辛勤久，玉箸应啼别离后",
            "poemId": "poem_591"
        },
        {
            "line": "(飘飖 一作：飘飘)杀气三时作阵云，寒声一夜传刁斗",
            "poemId": "poem_591"
        }
    ],
    "七": [
        {
            "line": "七兮",
            "poemId": "poem_7"
        },
        {
            "line": "七月七日长生殿，夜半无人私语时",
            "poemId": "poem_526"
        }
    ],
    "六": [
        {
            "line": "六兮",
            "poemId": "poem_7"
        },
        {
            "line": "六军不发无奈何，宛转蛾眉马前死",
            "poemId": "poem_526"
        }
    ],
    "力": [
        {
            "line": "力拔山兮气盖世",
            "poemId": "poem_8"
        }
    ],
    "时": [
        {
            "line": "时不利兮骓不逝",
            "poemId": "poem_8"
        },
        {
            "line": "时不可再得，何为自愁恼",
            "poemId": "poem_40"
        },
        {
            "line": "时俗薄朱颜，谁为发皓齿",
            "poemId": "poem_43"
        },
        {
            "line": "时人不识余心乐，将谓偷闲学少年",
            "poemId": "poem_111"
        },
        {
            "line": "时有落花至，远随流水香",
            "poemId": "poem_432"
        },
        {
            "line": "时难年荒世业空，弟兄羁旅各西东",
            "poemId": "poem_444"
        },
        {
            "line": "时见归村人，沙行渡头歇",
            "poemId": "poem_510"
        }
    ],
    "骓": [
        {
            "line": "骓不逝兮可奈何",
            "poemId": "poem_8"
        }
    ],
    "虞": [
        {
            "line": "虞兮虞兮奈若何",
            "poemId": "poem_8"
        }
    ],
    "相": [
        {
            "line": "相鼠有皮，人而无仪",
            "poemId": "poem_9"
        },
        {
            "line": "相鼠有齿，人而无止",
            "poemId": "poem_9"
        },
        {
            "line": "相鼠有体，人而无礼，人而无礼",
            "poemId": "poem_9"
        },
        {
            "line": "相去万余里，各在天一涯",
            "poemId": "poem_22"
        },
        {
            "line": "相去日已远，衣带日已缓",
            "poemId": "poem_22"
        },
        {
            "line": "相去万余里，故人心尚尔",
            "poemId": "poem_27"
        },
        {
            "line": "相逢清露下，流影湿衣襟",
            "poemId": "poem_260"
        },
        {
            "line": "相送情无限，沾襟比散丝",
            "poemId": "poem_411"
        },
        {
            "line": "相见时难别亦难，东风无力百花残",
            "poemId": "poem_450"
        },
        {
            "line": "相携及田家，童稚开荆扉",
            "poemId": "poem_507"
        },
        {
            "line": "相望试登高，心随雁飞灭",
            "poemId": "poem_510"
        },
        {
            "line": "相迎不道远，直至长风沙",
            "poemId": "poem_575"
        },
        {
            "line": "相看白刃血纷纷，死节从来岂顾勋",
            "poemId": "poem_591"
        }
    ],
    "人": [
        {
            "line": "人而无仪，不死何为",
            "poemId": "poem_9"
        },
        {
            "line": "人而无止，不死何俟",
            "poemId": "poem_9"
        },
        {
            "line": "人生非金石，岂能长寿考",
            "poemId": "poem_26"
        },
        {
            "line": "人生一世间，忽若暮春草",
            "poemId": "poem_40"
        },
        {
            "line": "人离皆复会，君独无返期",
            "poemId": "poem_40"
        },
        {
            "line": "人靡不有初，想君能终之",
            "poemId": "poem_40"
        },
        {
            "line": "人生无根蒂，飘如陌上尘",
            "poemId": "poem_51"
        },
        {
            "line": "人生亦有命，安能行叹复坐愁",
            "poemId": "poem_57"
        },
        {
            "line": "人归落雁后，思发在花前",
            "poemId": "poem_79"
        },
        {
            "line": "人家在何许",
            "poemId": "poem_92"
        },
        {
            "line": "人言落日是天涯，望极天涯不见家",
            "poemId": "poem_109"
        },
        {
            "line": "人固已惧江海竭，天岂不惜河汉干",
            "poemId": "poem_116"
        },
        {
            "line": "人生到处知何似，应似飞鸿踏雪泥",
            "poemId": "poem_120"
        },
        {
            "line": "人生自古谁无死，留取丹心照汗青",
            "poemId": "poem_190"
        },
        {
            "line": "人生百年几今日，今日不为真可惜",
            "poemId": "poem_232"
        },
        {
            "line": "人事有代谢，往来成古今",
            "poemId": "poem_408"
        },
        {
            "line": "人世几回伤往事，山形依旧枕寒流",
            "poemId": "poem_483"
        },
        {
            "line": "人生不相见，动如参与商",
            "poemId": "poem_505"
        },
        {
            "line": "人随沙岸向江村，余亦乘舟归鹿门",
            "poemId": "poem_548"
        },
        {
            "line": "人生如此自可乐，岂必局束为人鞿",
            "poemId": "poem_552"
        },
        {
            "line": "人生得意须尽欢，莫使金樽空对月",
            "poemId": "poem_570"
        },
        {
            "line": "人生有情泪沾臆，江水江花岂终极",
            "poemId": "poem_587"
        }
    ],
    "胡": [
        {
            "line": "胡不遄死",
            "poemId": "poem_9"
        },
        {
            "line": "胡地多飚风，树木何修修",
            "poemId": "poem_21"
        },
        {
            "line": "胡马依北风，越鸟巢南枝",
            "poemId": "poem_22"
        },
        {
            "line": "胡笳千古恨，一片月临城",
            "poemId": "poem_240"
        },
        {
            "line": "胡人落泪沾边草，汉使断肠对归客",
            "poemId": "poem_537"
        },
        {
            "line": "胡雁哀鸣夜夜飞，胡儿眼泪双双落",
            "poemId": "poem_584"
        }
    ],
    "上": [
        {
            "line": "上邪，我欲与君相知，长命无绝衰",
            "poemId": "poem_10"
        },
        {
            "line": "上马不捉鞭，反折杨柳枝",
            "poemId": "poem_73"
        },
        {
            "line": "上国随缘住，来途若梦行",
            "poemId": "poem_433"
        },
        {
            "line": "上穷碧落下黄泉，两处茫茫皆不见",
            "poemId": "poem_526"
        },
        {
            "line": "上将拥旄西出征，平明吹笛大军行",
            "poemId": "poem_532"
        },
        {
            "line": "上有青冥之长天，下有渌水之波澜",
            "poemId": "poem_572"
        },
        {
            "line": "上蔡苍鹰何足道",
            "poemId": "poem_573"
        },
        {
            "line": "上有六龙回日之高标，下有冲波逆折之回川",
            "poemId": "poem_576"
        }
    ],
    "山": [
        {
            "line": "山无陵，江水为竭",
            "poemId": "poem_10"
        },
        {
            "line": "山不厌高，海不厌深",
            "poemId": "poem_32"
        },
        {
            "line": "山气日夕佳，飞鸟相与还",
            "poemId": "poem_44"
        },
        {
            "line": "山际见来烟，竹中窥落日",
            "poemId": "poem_66"
        },
        {
            "line": "山中何所有，岭上多白云",
            "poemId": "poem_67"
        },
        {
            "line": "山外青山楼外楼，西湖歌舞几时休",
            "poemId": "poem_173"
        },
        {
            "line": "山河破碎风飘絮，身世浮沉雨打萍",
            "poemId": "poem_190"
        },
        {
            "line": "山云吞吐翠微中，淡绿深青一万重",
            "poemId": "poem_199"
        },
        {
            "line": "山色江声共寂寥，十三陵树晚萧萧",
            "poemId": "poem_262"
        },
        {
            "line": "山中相送罢，日暮掩柴扉",
            "poemId": "poem_284"
        },
        {
            "line": "山中一夜雨，树杪百重泉",
            "poemId": "poem_356"
        },
        {
            "line": "山随平野尽，江入大荒流",
            "poemId": "poem_378"
        },
        {
            "line": "山暝闻猿愁，沧江急夜流",
            "poemId": "poem_400"
        },
        {
            "line": "山光悦鸟性，潭影空人心",
            "poemId": "poem_418"
        },
        {
            "line": "山光悦鸟性，潭影空人心",
            "poemId": "poem_418"
        },
        {
            "line": "山光悦鸟性，潭影空人心",
            "poemId": "poem_418"
        },
        {
            "line": "山光悦鸟性，潭影空人心",
            "poemId": "poem_418"
        },
        {
            "line": "山中习静观朝槿，松下清斋折露葵",
            "poemId": "poem_443"
        },
        {
            "line": "山色遥连秦树晚，砧声近报汉宫秋",
            "poemId": "poem_490"
        },
        {
            "line": "山光忽西落，池月渐东上",
            "poemId": "poem_511"
        },
        {
            "line": "山为樽，水为沼，酒徒历历坐洲岛",
            "poemId": "poem_528"
        },
        {
            "line": "山回路转不见君，雪上空留马行处",
            "poemId": "poem_530"
        },
        {
            "line": "山寺钟鸣昼已昏，渔梁渡头争渡喧",
            "poemId": "poem_548"
        },
        {
            "line": "山石荦确行径微，黄昏到寺蝙蝠飞",
            "poemId": "poem_552"
        },
        {
            "line": "山红涧碧纷烂漫，时见松枥皆十围",
            "poemId": "poem_552"
        },
        {
            "line": "山口潜行始隈隩，山开旷望旋平陆",
            "poemId": "poem_564"
        },
        {
            "line": "山川萧条极边土，胡骑凭陵杂风雨",
            "poemId": "poem_591"
        }
    ],
    "冬": [
        {
            "line": "冬雷震震，夏雨雪",
            "poemId": "poem_10"
        }
    ],
    "天": [
        {
            "line": "天地合，乃敢与君绝",
            "poemId": "poem_10"
        },
        {
            "line": "天似穹庐，笼盖四野",
            "poemId": "poem_76"
        },
        {
            "line": "天苍苍，野茫茫",
            "poemId": "poem_76"
        },
        {
            "line": "天寒水鸟自相依，十百为群戏落晖",
            "poemId": "poem_136"
        },
        {
            "line": "天缺西南江面清，纤云不动小滩横",
            "poemId": "poem_157"
        },
        {
            "line": "天地神灵扶庙社，京华父老望和銮",
            "poemId": "poem_164"
        },
        {
            "line": "天地寂寥山雨歇，几生修得到梅花",
            "poemId": "poem_198"
        },
        {
            "line": "天阶夜色凉如水，卧看牵牛织女星",
            "poemId": "poem_332"
        },
        {
            "line": "天涯占梦数，疑误有新知",
            "poemId": "poem_382"
        },
        {
            "line": "天地英雄气，千秋尚凛然",
            "poemId": "poem_430"
        },
        {
            "line": "天秋月又满，城阙夜千重",
            "poemId": "poem_438"
        },
        {
            "line": "天寒翠袖薄，日暮倚修竹",
            "poemId": "poem_506"
        },
        {
            "line": "天边树若荠，江畔洲如月",
            "poemId": "poem_510"
        },
        {
            "line": "天生丽质难自弃，一朝选在君王侧",
            "poemId": "poem_526"
        },
        {
            "line": "天旋地转回龙驭，到此踌躇不能去",
            "poemId": "poem_526"
        },
        {
            "line": "天长地久有时尽，此恨绵绵无绝期",
            "poemId": "poem_526"
        },
        {
            "line": "天姥连天向天横，势拔五岳掩赤城",
            "poemId": "poem_534"
        },
        {
            "line": "天台四万八千丈，对此欲倒东南倾",
            "poemId": "poem_534"
        },
        {
            "line": "天明独去无道路，出入高下穷烟霏",
            "poemId": "poem_552"
        },
        {
            "line": "天生我材必有用，千金散尽还复来",
            "poemId": "poem_570"
        },
        {
            "line": "天长路远魂飞苦，梦魂不到关山难",
            "poemId": "poem_572"
        }
    ],
    "北": [
        {
            "line": "北方有佳人",
            "poemId": "poem_11"
        },
        {
            "line": "北斗七星高，哥舒夜带刀",
            "poemId": "poem_307"
        },
        {
            "line": "北阙休上书，南山归敝庐",
            "poemId": "poem_403"
        },
        {
            "line": "北土非吾愿，东林怀我师",
            "poemId": "poem_405"
        },
        {
            "line": "北极朝廷终不改，西山寇盗莫相侵",
            "poemId": "poem_466"
        },
        {
            "line": "北山白云里，隐者自怡悦",
            "poemId": "poem_510"
        },
        {
            "line": "北风卷地白草折，胡天八月即飞雪",
            "poemId": "poem_530"
        }
    ],
    "绝": [
        {
            "line": "绝世而独立",
            "poemId": "poem_11"
        },
        {
            "line": "绝代有佳人，幽居在空谷",
            "poemId": "poem_506"
        },
        {
            "line": "绝顶一茅茨，直上三十里",
            "poemId": "poem_508"
        }
    ],
    "再": [
        {
            "line": "再顾倾人国",
            "poemId": "poem_11"
        }
    ],
    "宁": [
        {
            "line": "宁不知倾城与倾国",
            "poemId": "poem_11"
        },
        {
            "line": "宁饮建业水，不食武昌鱼",
            "poemId": "poem_41"
        },
        {
            "line": "宁还建业死，不止武昌居",
            "poemId": "poem_41"
        },
        {
            "line": "宁可枝头抱香死，何曾吹落北风中",
            "poemId": "poem_194"
        }
    ],
    "佳": [
        {
            "line": "佳人难再得",
            "poemId": "poem_11"
        },
        {
            "line": "佳期怅何许，泪下如流霰",
            "poemId": "poem_55"
        }
    ],
    "坎": [
        {
            "line": "坎坎伐檀兮，置之河之干兮",
            "poemId": "poem_12"
        },
        {
            "line": "坎坎伐辐兮，置之河之侧兮",
            "poemId": "poem_12"
        },
        {
            "line": "坎坎伐轮兮，置之河之漘兮",
            "poemId": "poem_12"
        }
    ],
    "河": [
        {
            "line": "河水清且涟猗",
            "poemId": "poem_12"
        },
        {
            "line": "河水清且直猗",
            "poemId": "poem_12"
        },
        {
            "line": "河水清且沦猗",
            "poemId": "poem_12"
        },
        {
            "line": "河汉清且浅，相去复几许",
            "poemId": "poem_23"
        },
        {
            "line": "河汉纵且横，北斗横复直",
            "poemId": "poem_62"
        },
        {
            "line": "河山北枕秦关险，驿路西连汉畤平",
            "poemId": "poem_479"
        }
    ],
    "江": [
        {
            "line": "江南可采莲，莲叶何田田，鱼戏莲叶间",
            "poemId": "poem_13"
        },
        {
            "line": "江南倦历览，江北旷周旋",
            "poemId": "poem_50"
        },
        {
            "line": "江干远树浮，天末孤烟起",
            "poemId": "poem_59"
        },
        {
            "line": "江天自如合，烟树还相似",
            "poemId": "poem_59"
        },
        {
            "line": "江东子弟今虽在，肯与君王卷土来",
            "poemId": "poem_110"
        },
        {
            "line": "江头落日照平沙，潮退渔船阁岸斜",
            "poemId": "poem_189"
        },
        {
            "line": "江水三千里，家书十五行",
            "poemId": "poem_226"
        },
        {
            "line": "江干多是钓人居，柳陌菱塘一带疏",
            "poemId": "poem_245"
        },
        {
            "line": "江干多是钓人居，柳陌菱塘一带疏",
            "poemId": "poem_246"
        },
        {
            "line": "江山代有才人出，各领风骚数百年",
            "poemId": "poem_263"
        },
        {
            "line": "江流天地外，山色有无中",
            "poemId": "poem_358"
        },
        {
            "line": "江村独归处，寂寞养残生",
            "poemId": "poem_388"
        },
        {
            "line": "江山留胜迹，我辈复登临",
            "poemId": "poem_408"
        },
        {
            "line": "江汉曾为客，相逢每醉还",
            "poemId": "poem_410"
        },
        {
            "line": "江山故宅空文藻，云雨荒台岂梦思",
            "poemId": "poem_464"
        },
        {
            "line": "江上月明胡雁过，淮南木落楚山多",
            "poemId": "poem_491"
        },
        {
            "line": "江淮度寒食，京洛缝春衣",
            "poemId": "poem_495"
        },
        {
            "line": "江南瘴疠地，逐客无消息",
            "poemId": "poem_501"
        },
        {
            "line": "江南瘴疠地，逐客无消息",
            "poemId": "poem_501"
        },
        {
            "line": "江湖多风波，舟楫恐失坠",
            "poemId": "poem_503"
        },
        {
            "line": "江南有丹橘，经冬犹绿林",
            "poemId": "poem_525"
        },
        {
            "line": "江州司马青衫湿",
            "poemId": "poem_529"
        },
        {
            "line": "江头宫殿锁千门，细柳新蒲为谁绿",
            "poemId": "poem_587"
        }
    ],
    "鱼": [
        {
            "line": "鱼戏莲叶东，鱼戏莲叶西，鱼戏莲叶南，鱼戏莲叶北",
            "poemId": "poem_13"
        }
    ],
    "秋": [
        {
            "line": "秋风起兮白云飞，草木黄落兮雁南归",
            "poemId": "poem_14"
        },
        {
            "line": "秋风萧萧愁杀人，出亦愁，入亦愁",
            "poemId": "poem_21"
        },
        {
            "line": "秋风萧瑟，洪波涌起",
            "poemId": "poem_31"
        },
        {
            "line": "秋风萧瑟天气凉，草木摇落露为霜，群燕辞归鹄南翔",
            "poemId": "poem_36"
        },
        {
            "line": "秋风起兮木叶飞，吴江水兮鲈正肥",
            "poemId": "poem_58"
        },
        {
            "line": "秋送新鸿哀破国，昼行饥虎齧空林",
            "poemId": "poem_192"
        },
        {
            "line": "秋夜访秋士，先闻水上音",
            "poemId": "poem_260"
        },
        {
            "line": "秋草独寻人去后，寒林空见日斜时",
            "poemId": "poem_485"
        },
        {
            "line": "秋风吹不尽，总是玉关情",
            "poemId": "poem_578"
        }
    ],
    "兰": [
        {
            "line": "兰有秀兮菊有芳，怀佳人兮不能忘",
            "poemId": "poem_14"
        },
        {
            "line": "兰叶春葳蕤，桂华秋皎洁",
            "poemId": "poem_523"
        }
    ],
    "泛": [
        {
            "line": "泛楼船兮济汾河，横中流兮扬素波",
            "poemId": "poem_14"
        }
    ],
    "箫": [
        {
            "line": "箫鼓鸣兮发棹歌，欢乐极兮哀情多",
            "poemId": "poem_14"
        },
        {
            "line": "箫鼓哀吟感鬼神，宾从杂遝实要津",
            "poemId": "poem_586"
        }
    ],
    "少": [
        {
            "line": "少壮几时兮奈老何",
            "poemId": "poem_14"
        },
        {
            "line": "少壮不努力，老大徒伤悲",
            "poemId": "poem_24"
        },
        {
            "line": "少无适俗韵，性本爱丘山",
            "poemId": "poem_46"
        },
        {
            "line": "少小知名翰墨场，十年心事只凄凉",
            "poemId": "poem_182"
        },
        {
            "line": "少小离家老大回，乡音无改鬓毛衰",
            "poemId": "poem_348"
        },
        {
            "line": "少妇今春意，良人昨夜情",
            "poemId": "poem_407"
        },
        {
            "line": "少孤为客早，多难识君迟",
            "poemId": "poem_431"
        },
        {
            "line": "少小虽非投笔吏，论功还欲请长缨",
            "poemId": "poem_480"
        },
        {
            "line": "少壮能几时",
            "poemId": "poem_505"
        },
        {
            "line": "少陵无人谪仙死，才薄将奈石鼓何",
            "poemId": "poem_551"
        },
        {
            "line": "少年十五二十时，步行夺得胡马骑",
            "poemId": "poem_561"
        },
        {
            "line": "少陵野老吞声哭，春日潜行曲江曲",
            "poemId": "poem_587"
        },
        {
            "line": "少妇城南欲断肠，征人蓟北空回首",
            "poemId": "poem_591"
        }
    ],
    "大": [
        {
            "line": "大风起兮云飞扬，威加海内兮归故乡，安得猛士兮守四方",
            "poemId": "poem_15"
        },
        {
            "line": "大艑珂峨头，何处发扬州",
            "poemId": "poem_64"
        },
        {
            "line": "大江一浩荡，离悲足几重",
            "poemId": "poem_70"
        },
        {
            "line": "大道青楼望不遮，年时系马醉流霞",
            "poemId": "poem_267"
        },
        {
            "line": "大弦嘈嘈如急雨，小弦切切如私语",
            "poemId": "poem_529"
        },
        {
            "line": "大厦如倾要梁栋，万牛回首丘山重",
            "poemId": "poem_541"
        },
        {
            "line": "大开明堂受朝贺，诸侯剑佩鸣相磨",
            "poemId": "poem_551"
        },
        {
            "line": "大厦深檐与盖覆，经历久远期无佗",
            "poemId": "poem_551"
        },
        {
            "line": "大道如青天，我独不得出",
            "poemId": "poem_567"
        },
        {
            "line": "大漠穷秋塞草腓，孤城落日斗兵稀",
            "poemId": "poem_591"
        }
    ],
    "谁": [
        {
            "line": "谁谓河广",
            "poemId": "poem_16"
        },
        {
            "line": "谁谓宋远",
            "poemId": "poem_16"
        },
        {
            "line": "谁谓河广",
            "poemId": "poem_16"
        },
        {
            "line": "谁谓宋远",
            "poemId": "poem_16"
        },
        {
            "line": "谁家玉笛吹春怨，看见鹅黄上柳条",
            "poemId": "poem_182"
        },
        {
            "line": "谁谓伤心画不成，画人心逐世人情",
            "poemId": "poem_338"
        },
        {
            "line": "谁能将旗鼓，一为取龙城",
            "poemId": "poem_407"
        },
        {
            "line": "谁见汀洲上，相思愁白蘋",
            "poemId": "poem_429"
        },
        {
            "line": "谁爱风流高格调，共怜时世俭梳妆",
            "poemId": "poem_476"
        },
        {
            "line": "谁解乘舟寻范蠡，五湖烟水独忘机",
            "poemId": "poem_481"
        },
        {
            "line": "谁能绝人命，以作时世贤",
            "poemId": "poem_502"
        },
        {
            "line": "谁知林栖者，闻风坐相悦",
            "poemId": "poem_523"
        },
        {
            "line": "谁怜越女颜如玉，贫贱江头自浣纱",
            "poemId": "poem_562"
        },
        {
            "line": "谁言寸草心，报得三春晖",
            "poemId": "poem_589"
        },
        {
            "line": "谁谓含愁独不见，更教明月照流黄",
            "poemId": "poem_593"
        }
    ],
    "跂": [
        {
            "line": "跂予望之",
            "poemId": "poem_16"
        }
    ],
    "曾": [
        {
            "line": "曾不容刀",
            "poemId": "poem_16"
        },
        {
            "line": "曾不崇朝",
            "poemId": "poem_16"
        },
        {
            "line": "曾是洛阳花下客，野芳虽晚不须嗟",
            "poemId": "poem_101"
        },
        {
            "line": "曾奉龙旗典邦礼，岁穷祠祀少休闲",
            "poemId": "poem_132"
        },
        {
            "line": "曾是寂寥金烬暗，断无消息石榴红",
            "poemId": "poem_451"
        },
        {
            "line": "曾貌先帝照夜白，龙池十日飞霹雳",
            "poemId": "poem_547"
        }
    ],
    "风": [
        {
            "line": "风萧萧兮易水寒，壮士一去兮不复还",
            "poemId": "poem_17"
        },
        {
            "line": "风声一何盛，松枝一何劲",
            "poemId": "poem_33"
        },
        {
            "line": "风吹草低见牛羊",
            "poemId": "poem_76"
        },
        {
            "line": "风蒲猎猎弄清柔，欲立蜻蜓不自由",
            "poemId": "poem_131"
        },
        {
            "line": "风翻蛛网开三面，雷动蜂窠趁两衙",
            "poemId": "poem_137"
        },
        {
            "line": "风卷江湖雨暗村，四山声作海涛翻",
            "poemId": "poem_162"
        },
        {
            "line": "风日晴和人意好，夕阳箫鼓几船归",
            "poemId": "poem_207"
        },
        {
            "line": "风前带是同心结，杯底人如解语花",
            "poemId": "poem_267"
        },
        {
            "line": "风鸣两岸叶，月照一孤舟",
            "poemId": "poem_400"
        },
        {
            "line": "风波不信菱枝弱，月露谁教桂叶香",
            "poemId": "poem_449"
        },
        {
            "line": "风尘荏苒音书绝，关塞萧条行路难",
            "poemId": "poem_463"
        },
        {
            "line": "风急天高猿啸哀，渚清沙白鸟飞回",
            "poemId": "poem_473"
        },
        {
            "line": "风吹仙袂飘飘举，犹似霓裳羽衣舞",
            "poemId": "poem_526"
        },
        {
            "line": "风吹柳花满店香，吴姬压酒唤客尝",
            "poemId": "poem_535"
        }
    ],
    "十": [
        {
            "line": "十五从军征，八十始得归",
            "poemId": "poem_18"
        },
        {
            "line": "十指不沾泥，鳞鳞居大厦",
            "poemId": "poem_94"
        },
        {
            "line": "十年勾践亡吴计，七日包胥哭楚心",
            "poemId": "poem_192"
        },
        {
            "line": "十年无梦得还家，独立青峰野水涯",
            "poemId": "poem_198"
        },
        {
            "line": "十二峰头秋草荒，冷烟寒月过瞿塘",
            "poemId": "poem_225"
        },
        {
            "line": "十丈黄尘千尺雪，可知俱不似江南",
            "poemId": "poem_239"
        },
        {
            "line": "十里崎岖半里平，一峰才送一峰迎",
            "poemId": "poem_256"
        },
        {
            "line": "十年离乱后，长大一相逢",
            "poemId": "poem_379"
        },
        {
            "line": "十二楼中尽晓妆，望仙楼上望君王",
            "poemId": "poem_489"
        },
        {
            "line": "十觞亦不醉，感子故意长",
            "poemId": "poem_505"
        },
        {
            "line": "十三学得琵琶成，名属教坊第一部",
            "poemId": "poem_529"
        },
        {
            "line": "十生九死到官所，幽居默默如藏逃",
            "poemId": "poem_554"
        },
        {
            "line": "十五始展眉，愿同尘与灰",
            "poemId": "poem_575"
        },
        {
            "line": "十六君远行，瞿塘滟滪堆",
            "poemId": "poem_575"
        }
    ],
    "道": [
        {
            "line": "道逢乡里人：“家中有阿谁",
            "poemId": "poem_18"
        },
        {
            "line": "道路阻且长，会面安可知",
            "poemId": "poem_22"
        },
        {
            "line": "道狭草木长，夕露沾我衣",
            "poemId": "poem_47"
        },
        {
            "line": "道由白云尽，春与青溪长",
            "poemId": "poem_432"
        },
        {
            "line": "道人庭宇静，苔色连深竹",
            "poemId": "poem_509"
        },
        {
            "line": "道旁过者问行人，行人但云点行频",
            "poemId": "poem_583"
        }
    ],
    "”": [
        {
            "line": "”“遥看是君家，松柏冢累累",
            "poemId": "poem_18"
        },
        {
            "line": "”(遥看 一作：遥望)兔从狗窦入，雉从梁上飞",
            "poemId": "poem_18"
        },
        {
            "line": "”驱马弃之去，不忍听此言",
            "poemId": "poem_39"
        }
    ],
    "中": [
        {
            "line": "中庭生旅谷，井上生旅葵",
            "poemId": "poem_18"
        },
        {
            "line": "中庭多杂树，偏为梅咨嗟",
            "poemId": "poem_52"
        },
        {
            "line": "中原事业如江左，芳草何须怨六朝",
            "poemId": "poem_262"
        },
        {
            "line": "中岁颇好道，晚家南山陲",
            "poemId": "poem_362"
        },
        {
            "line": "中有一人字太真，雪肤花貌参差是",
            "poemId": "poem_526"
        },
        {
            "line": "中军置酒饮归客，胡琴琵琶与羌笛",
            "poemId": "poem_530"
        },
        {
            "line": "中朝大官老于事，讵肯感激徒媕娿",
            "poemId": "poem_551"
        }
    ],
    "舂": [
        {
            "line": "舂谷持作饭，采葵持作羹",
            "poemId": "poem_18"
        }
    ],
    "羹": [
        {
            "line": "羹饭一时熟，不知贻阿谁",
            "poemId": "poem_18"
        }
    ],
    "出": [
        {
            "line": "出门东向看，泪落沾我衣",
            "poemId": "poem_18"
        },
        {
            "line": "出户独彷徨，愁思当告谁",
            "poemId": "poem_19"
        },
        {
            "line": "出门无所见，白骨蔽平原",
            "poemId": "poem_39"
        },
        {
            "line": "出入擐郎臂，蹀座郎膝边",
            "poemId": "poem_73"
        },
        {
            "line": "出师一表真名世，千载谁堪伯仲间",
            "poemId": "poem_163"
        },
        {
            "line": "出师一表通今古，夜半挑灯更细看",
            "poemId": "poem_164"
        },
        {
            "line": "出门搔白首，若负平生志",
            "poemId": "poem_503"
        },
        {
            "line": "出塞入塞寒，处处黄芦草",
            "poemId": "poem_557"
        },
        {
            "line": "出洞无论隔山水，辞家终拟长游衍",
            "poemId": "poem_564"
        }
    ],
    "明": [
        {
            "line": "明月何皎皎，照我罗床帏",
            "poemId": "poem_19"
        },
        {
            "line": "明明如月，何时可掇",
            "poemId": "poem_32"
        },
        {
            "line": "明月皎皎照我床，星汉西流夜未央",
            "poemId": "poem_36"
        },
        {
            "line": "明月松间照，清泉石上流",
            "poemId": "poem_364"
        },
        {
            "line": "明朝望乡处，应见陇头梅",
            "poemId": "poem_374"
        },
        {
            "line": "明朝挂帆席，枫叶落纷纷",
            "poemId": "poem_376"
        },
        {
            "line": "明日巴陵道，秋山又几重",
            "poemId": "poem_379"
        },
        {
            "line": "明朝有封事，数问夜如何",
            "poemId": "poem_399"
        },
        {
            "line": "明日隔山岳，世事两茫茫",
            "poemId": "poem_505"
        },
        {
            "line": "明月 一作：日月)抽刀断水水更流，举杯销愁愁更愁",
            "poemId": "poem_533"
        },
        {
            "line": "明朝驿使发，一夜絮征袍",
            "poemId": "poem_580"
        },
        {
            "line": "明月出天山，苍茫云海间",
            "poemId": "poem_581"
        },
        {
            "line": "明眸皓齿今何在",
            "poemId": "poem_587"
        }
    ],
    "客": [
        {
            "line": "客行虽云乐，不如早旋归",
            "poemId": "poem_19"
        },
        {
            "line": "客从远方来，遗我一端绮",
            "poemId": "poem_27"
        },
        {
            "line": "客舟系缆柳阴旁，湖影侵篷夜气凉",
            "poemId": "poem_204"
        },
        {
            "line": "客路青山外，行舟绿水前",
            "poemId": "poem_367"
        },
        {
            "line": "客去波平槛，蝉休露满枝",
            "poemId": "poem_382"
        },
        {
            "line": "客从东方来，衣上灞陵雨",
            "poemId": "poem_514"
        }
    ],
    "引": [
        {
            "line": "引领还入房，泪下沾裳衣",
            "poemId": "poem_19"
        }
    ],
    "东": [
        {
            "line": "东城高且长，逶迤自相属",
            "poemId": "poem_20"
        },
        {
            "line": "东临碣石，以观沧海",
            "poemId": "poem_31"
        },
        {
            "line": "东风忽起垂杨舞，更作荷心万点声",
            "poemId": "poem_114"
        },
        {
            "line": "东风袅袅泛崇光，香雾空蒙月转廊",
            "poemId": "poem_125"
        },
        {
            "line": "东园载酒西园醉，摘尽枇杷一树金",
            "poemId": "poem_185"
        },
        {
            "line": "东风谬掌花权柄，却忌孤高不主张",
            "poemId": "poem_186"
        },
        {
            "line": "东风不与周郎便，铜雀春深锁二乔",
            "poemId": "poem_334"
        },
        {
            "line": "东船西舫悄无言，唯见江心秋月白",
            "poemId": "poem_529"
        },
        {
            "line": "东门酤酒饮我曹，心轻万事如鸿毛",
            "poemId": "poem_543"
        }
    ],
    "回": [
        {
            "line": "回风动地起，秋草萋已绿",
            "poemId": "poem_20"
        },
        {
            "line": "回车驾言迈，悠悠涉长道",
            "poemId": "poem_26"
        },
        {
            "line": "回乐峰前沙似雪，受降城外月如霜",
            "poemId": "poem_318"
        },
        {
            "line": "回日楼台非甲帐，去时冠剑是丁年",
            "poemId": "poem_484"
        },
        {
            "line": "回眸一笑百媚生，六宫粉黛无颜色",
            "poemId": "poem_526"
        },
        {
            "line": "回头下望人寰处，不见长安见尘雾",
            "poemId": "poem_526"
        },
        {
            "line": "回看天际下中流，岩上无心云相逐",
            "poemId": "poem_549"
        },
        {
            "line": "回舟不待月，归去越王家",
            "poemId": "poem_577"
        }
    ],
    "四": [
        {
            "line": "四时更变化，岁暮一何速",
            "poemId": "poem_20"
        },
        {
            "line": "四顾何茫茫，东风摇百草",
            "poemId": "poem_26"
        },
        {
            "line": "四顾山光接水光，凭栏十里芰荷香",
            "poemId": "poem_140"
        },
        {
            "line": "四百万人同一哭，去年今日割台湾",
            "poemId": "poem_274"
        },
        {
            "line": "四角碍白日，七层摩苍穹",
            "poemId": "poem_497"
        },
        {
            "line": "四边伐鼓雪海涌，三军大呼阴山动",
            "poemId": "poem_532"
        },
        {
            "line": "四月南风大麦黄，枣花未落桐叶长",
            "poemId": "poem_543"
        }
    ],
    "晨": [
        {
            "line": "晨风怀苦心，蟋蟀伤局促",
            "poemId": "poem_20"
        },
        {
            "line": "晨兴理荒秽，带月荷锄归",
            "poemId": "poem_47"
        },
        {
            "line": "晨起开门雪满山，雪晴云淡日光寒",
            "poemId": "poem_252"
        },
        {
            "line": "晨摇玉佩趋金殿，夕奉天书拜琐闱",
            "poemId": "poem_440"
        }
    ],
    "荡": [
        {
            "line": "荡涤放情志，何为自结束",
            "poemId": "poem_20"
        },
        {
            "line": "荡胸生曾云，决眦入归鸟",
            "poemId": "poem_504"
        }
    ],
    "燕": [
        {
            "line": "燕赵多佳人，美者颜如玉",
            "poemId": "poem_20"
        },
        {
            "line": "燕丹善养士，志在报强嬴",
            "poemId": "poem_48"
        },
        {
            "line": "燕台一望客心惊，笳鼓喧喧汉将营",
            "poemId": "poem_480"
        },
        {
            "line": "燕草如碧丝，秦桑低绿枝",
            "poemId": "poem_499"
        }
    ],
    "被": [
        {
            "line": "被服罗裳衣，当户理清曲",
            "poemId": "poem_20"
        }
    ],
    "音": [
        {
            "line": "音响一何悲",
            "poemId": "poem_20"
        }
    ],
    "弦": [
        {
            "line": "弦急知柱促",
            "poemId": "poem_20"
        },
        {
            "line": "弦弦掩抑声声思，似诉平生不得志",
            "poemId": "poem_529"
        }
    ],
    "驰": [
        {
            "line": "驰情整巾带，沉吟聊踯躅",
            "poemId": "poem_20"
        }
    ],
    "思": [
        {
            "line": "思为双飞燕，衔泥巢君屋",
            "poemId": "poem_20"
        },
        {
            "line": "思君令人老，岁月忽已晚",
            "poemId": "poem_22"
        },
        {
            "line": "思君如流水，何有穷已时",
            "poemId": "poem_40"
        },
        {
            "line": "思君见巾栉，以益我劳勤",
            "poemId": "poem_40"
        },
        {
            "line": "思妇高楼上，当窗应未眠",
            "poemId": "poem_74"
        },
        {
            "line": "思欲委符节，引竿自刺船",
            "poemId": "poem_502"
        }
    ],
    "座": [
        {
            "line": "座中何人，谁不怀忧",
            "poemId": "poem_21"
        },
        {
            "line": "座中泣下谁最多",
            "poemId": "poem_529"
        }
    ],
    "令": [
        {
            "line": "令我白头",
            "poemId": "poem_21"
        }
    ],
    "离": [
        {
            "line": "离家日趋远，衣带日趋缓",
            "poemId": "poem_21"
        },
        {
            "line": "离离原上草，一岁一枯荣",
            "poemId": "poem_370"
        }
    ],
    "心": [
        {
            "line": "心思不能言，肠中车轮转",
            "poemId": "poem_21"
        },
        {
            "line": "心远地自偏",
            "poemId": "poem_44"
        },
        {
            "line": "心知去不归，且有后世名",
            "poemId": "poem_48"
        },
        {
            "line": "心非木石岂无感",
            "poemId": "poem_57"
        },
        {
            "line": "心逐南云逝，形随北雁来",
            "poemId": "poem_77"
        },
        {
            "line": "心同流水净，身与白云轻",
            "poemId": "poem_234"
        },
        {
            "line": "心断新丰酒，销愁斗几千",
            "poemId": "poem_385"
        }
    ],
    "行": [
        {
            "line": "行行重行行，与君生别离",
            "poemId": "poem_22"
        },
        {
            "line": "行到东溪看水时，坐临孤屿发船迟",
            "poemId": "poem_93"
        },
        {
            "line": "行人日暮少，风雪乱山深",
            "poemId": "poem_127"
        },
        {
            "line": "行行无别语，只道早还乡",
            "poemId": "poem_226"
        },
        {
            "line": "行人便觉须眉绿，一路蝉声过许州",
            "poemId": "poem_249"
        },
        {
            "line": "行到水穷处，坐看云起时",
            "poemId": "poem_362"
        },
        {
            "line": "行当浮桂棹，未几拂荆扉",
            "poemId": "poem_495"
        },
        {
            "line": "行宫见月伤心色，夜雨闻铃肠断声",
            "poemId": "poem_526"
        },
        {
            "line": "行路难",
            "poemId": "poem_566"
        },
        {
            "line": "行路难，归去来",
            "poemId": "poem_567"
        },
        {
            "line": "行人刁斗风沙暗，公主琵琶幽怨多",
            "poemId": "poem_584"
        }
    ],
    "浮": [
        {
            "line": "浮云蔽白日，游子不顾返",
            "poemId": "poem_22"
        },
        {
            "line": "浮云何洋洋，愿因通我词",
            "poemId": "poem_40"
        },
        {
            "line": "浮云游子意，落日故人情",
            "poemId": "poem_381"
        },
        {
            "line": "浮云一别后，流水十年间",
            "poemId": "poem_410"
        },
        {
            "line": "浮天沧海远，去世法舟轻",
            "poemId": "poem_433"
        },
        {
            "line": "浮云终日行，游子久不至",
            "poemId": "poem_503"
        }
    ],
    "弃": [
        {
            "line": "弃捐勿复道，努力加餐饭",
            "poemId": "poem_22"
        },
        {
            "line": "弃身锋刃端，性命安可怀",
            "poemId": "poem_38"
        },
        {
            "line": "弃置罢官去，还家自休息",
            "poemId": "poem_53"
        },
        {
            "line": "弃我去者，昨日之日不可留",
            "poemId": "poem_533"
        }
    ],
    "迢": [
        {
            "line": "迢迢牵牛星，皎皎河汉女",
            "poemId": "poem_23"
        },
        {
            "line": "迢迢天汉西南落，喔喔邻鸡一再鸣",
            "poemId": "poem_165"
        },
        {
            "line": "迢递嵩高下，归来且闭关",
            "poemId": "poem_365"
        },
        {
            "line": "迢递三巴路，羁危万里身",
            "poemId": "poem_416"
        }
    ],
    "纤": [
        {
            "line": "纤纤擢素手，札札弄机杼",
            "poemId": "poem_23"
        },
        {
            "line": "纤细 一作：肠断)十年一觉扬州梦，赢得青楼薄幸名",
            "poemId": "poem_329"
        },
        {
            "line": "纤云四卷天无河，清风吹空月舒波",
            "poemId": "poem_554"
        }
    ],
    "终": [
        {
            "line": "终日不成章，泣涕零如雨",
            "poemId": "poem_23"
        },
        {
            "line": "终南阴岭秀，积雪浮云端",
            "poemId": "poem_298"
        },
        {
            "line": "终是圣明天子事，景阳宫井又何人",
            "poemId": "poem_355"
        },
        {
            "line": "终罢斯结庐，慕陶直可庶",
            "poemId": "poem_517"
        }
    ],
    "盈": [
        {
            "line": "盈盈一水间，脉脉不得语",
            "poemId": "poem_23"
        },
        {
            "line": "盈缩之期，不但在天",
            "poemId": "poem_28"
        }
    ],
    "青": [
        {
            "line": "青青园中葵，朝露待日晞",
            "poemId": "poem_24"
        },
        {
            "line": "青青子衿，悠悠我心",
            "poemId": "poem_32"
        },
        {
            "line": "青苔满地初晴后，绿树无人昼梦余",
            "poemId": "poem_117"
        },
        {
            "line": "青墩溪畔龙钟客，独立东风看牡丹",
            "poemId": "poem_152"
        },
        {
            "line": "青枫江上孤舟客，不听猿啼亦断肠",
            "poemId": "poem_225"
        },
        {
            "line": "青山似茧将人裹，不信前头有路行",
            "poemId": "poem_256"
        },
        {
            "line": "青山隐隐水迢迢，秋尽江南草未凋",
            "poemId": "poem_328"
        },
        {
            "line": "青山横北郭，白水绕东城",
            "poemId": "poem_381"
        },
        {
            "line": "青枫江上秋帆远，白帝城边古木疏",
            "poemId": "poem_482"
        },
        {
            "line": "青冥浩荡不见底，日月照耀金银台",
            "poemId": "poem_534"
        },
        {
            "line": "青山朝别暮还见，嘶马出门思旧乡",
            "poemId": "poem_543"
        }
    ],
    "阳": [
        {
            "line": "阳春布德泽，万物生光辉",
            "poemId": "poem_24"
        },
        {
            "line": "阳月南飞雁，传闻至此回",
            "poemId": "poem_374"
        },
        {
            "line": "阳和不散穷途恨，霄汉长怀捧日心",
            "poemId": "poem_488"
        }
    ],
    "常": [
        {
            "line": "常恐秋节至，焜黄华叶衰",
            "poemId": "poem_24"
        },
        {
            "line": "常存抱柱信，岂上望夫台",
            "poemId": "poem_575"
        }
    ],
    "百": [
        {
            "line": "百川东到海，何时复西归",
            "poemId": "poem_24"
        },
        {
            "line": "百啭千声随意移，山花红紫树高低",
            "poemId": "poem_99"
        },
        {
            "line": "百战疲劳壮士哀，中原一败势难回",
            "poemId": "poem_110"
        },
        {
            "line": "百里西风禾黍香，鸣泉落窦谷登场",
            "poemId": "poem_126"
        },
        {
            "line": "百年草草都寒夜，自琢春词剪烛看",
            "poemId": "poem_182"
        },
        {
            "line": "百金买骏马，千金买美人",
            "poemId": "poem_255"
        }
    ],
    "涉": [
        {
            "line": "涉江采芙蓉，兰泽多芳草",
            "poemId": "poem_25"
        }
    ],
    "还": [
        {
            "line": "还顾望旧乡，长路漫浩浩",
            "poemId": "poem_25"
        },
        {
            "line": "还将两行泪，遥寄海西头",
            "poemId": "poem_400"
        },
        {
            "line": "还作江南会，翻疑梦里逢",
            "poemId": "poem_438"
        }
    ],
    "同": [
        {
            "line": "同心而离居，忧伤以终老",
            "poemId": "poem_25"
        },
        {
            "line": "同物既无虑，化去不复悔",
            "poemId": "poem_49"
        },
        {
            "line": "同穴窅冥何所望，他生缘会更难期",
            "poemId": "poem_439"
        },
        {
            "line": "同是天涯沦落人，相逢何必曾相识",
            "poemId": "poem_529"
        },
        {
            "line": "同时辈流多上道，天路幽险难追攀",
            "poemId": "poem_554"
        },
        {
            "line": "同居长干里，两小无嫌猜，十四为君妇，羞颜未尝开",
            "poemId": "poem_575"
        },
        {
            "line": "同是长干人，生小不相识",
            "poemId": "poem_594"
        }
    ],
    "盛": [
        {
            "line": "盛衰各有时，立身苦不早",
            "poemId": "poem_26"
        },
        {
            "line": "盛年不重来，一日难再晨",
            "poemId": "poem_51"
        }
    ],
    "奄": [
        {
            "line": "奄忽随物化，荣名以为宝",
            "poemId": "poem_26"
        }
    ],
    "文": [
        {
            "line": "文采双鸳鸯，裁为合欢被",
            "poemId": "poem_27"
        },
        {
            "line": "文翁翻教授，不敢倚先贤",
            "poemId": "poem_356"
        },
        {
            "line": "文章憎命达，魑魅喜人过",
            "poemId": "poem_390"
        },
        {
            "line": "文成破体书在纸，清晨再拜铺丹墀",
            "poemId": "poem_536"
        }
    ],
    "著": [
        {
            "line": "著以长相思，缘以结不解",
            "poemId": "poem_27"
        }
    ],
    "以": [
        {
            "line": "以胶投漆中，谁能别离此",
            "poemId": "poem_27"
        },
        {
            "line": "以彼径寸茎，荫此百尺条",
            "poemId": "poem_45"
        },
        {
            "line": "以我独沉久，愧君相见频",
            "poemId": "poem_372"
        }
    ],
    "神": [
        {
            "line": "神龟虽寿，犹有竟时",
            "poemId": "poem_28"
        },
        {
            "line": "神女生涯原是梦，小姑居处本无郎",
            "poemId": "poem_449"
        },
        {
            "line": "神欢体自轻，意欲凌风翔",
            "poemId": "poem_518"
        }
    ],
    "腾": [
        {
            "line": "腾蛇乘雾，终为土灰",
            "poemId": "poem_28"
        },
        {
            "line": "腾骧磊落三万匹，皆与此图筋骨同",
            "poemId": "poem_547"
        }
    ],
    "烈": [
        {
            "line": "烈士暮年，壮心不已",
            "poemId": "poem_28"
        }
    ],
    "养": [
        {
            "line": "养怡之福，可得永年",
            "poemId": "poem_28"
        }
    ],
    "幸": [
        {
            "line": "幸甚至哉，歌以咏志",
            "poemId": "poem_28"
        },
        {
            "line": "幸甚至哉，歌以咏志",
            "poemId": "poem_31"
        },
        {
            "line": "幸有微吟可相狎，不须檀板共金尊",
            "poemId": "poem_88"
        }
    ],
    "凛": [
        {
            "line": "凛凛岁云暮，蝼蛄夕鸣悲",
            "poemId": "poem_29"
        }
    ],
    "凉": [
        {
            "line": "凉风率已厉，游子寒无衣",
            "poemId": "poem_29"
        },
        {
            "line": "凉风起天末，君子意如何",
            "poemId": "poem_390"
        }
    ],
    "锦": [
        {
            "line": "锦衾遗洛浦，同袍与我违",
            "poemId": "poem_29"
        },
        {
            "line": "锦瑟无端五十弦，一弦一柱思华年",
            "poemId": "poem_454"
        },
        {
            "line": "锦江春色来天地，玉垒浮云变古今",
            "poemId": "poem_466"
        },
        {
            "line": "锦城虽云乐，不如早还家",
            "poemId": "poem_576"
        }
    ],
    "独": [
        {
            "line": "独宿累长夜，梦想见容辉",
            "poemId": "poem_29"
        },
        {
            "line": "独下千行泪，开君万里书",
            "poemId": "poem_72"
        },
        {
            "line": "独坐幽篁里，弹琴复长啸",
            "poemId": "poem_287"
        },
        {
            "line": "独在异乡为异客，每逢佳节倍思亲",
            "poemId": "poem_310"
        },
        {
            "line": "独怜幽草涧边生，上有黄鹂深树鸣",
            "poemId": "poem_339"
        },
        {
            "line": "独有宦游人，偏惊物候新",
            "poemId": "poem_398"
        },
        {
            "line": "独立三边静，轻生一剑知",
            "poemId": "poem_435"
        },
        {
            "line": "独有凤凰池上客，阳春一曲和皆难",
            "poemId": "poem_445"
        },
        {
            "line": "独夜忆秦关，听钟未眠客",
            "poemId": "poem_516"
        },
        {
            "line": "独立扬新令，千营共一呼",
            "poemId": "poem_592"
        }
    ],
    "良": [
        {
            "line": "良人惟古欢，枉驾惠前绥",
            "poemId": "poem_29"
        },
        {
            "line": "良会未有期，中心摧且伤",
            "poemId": "poem_40"
        },
        {
            "line": "良相头上进贤冠，猛将腰间大羽箭",
            "poemId": "poem_544"
        },
        {
            "line": "良人玉勒乘骢马，侍女金盘脍鲤鱼",
            "poemId": "poem_562"
        }
    ],
    "愿": [
        {
            "line": "愿得常巧笑，携手同车归",
            "poemId": "poem_29"
        },
        {
            "line": "愿教青帝常为主，莫遣纷纷点翠苔",
            "poemId": "poem_139"
        },
        {
            "line": "愿君多采撷，此物最相思",
            "poemId": "poem_283"
        },
        {
            "line": "愿书万本诵万遍，口角流沫右手胝",
            "poemId": "poem_536"
        },
        {
            "line": "愿得燕弓射大将，耻令越甲鸣吾军",
            "poemId": "poem_561"
        }
    ],
    "既": [
        {
            "line": "既来不须臾，又不处重闱",
            "poemId": "poem_29"
        },
        {
            "line": "既厚不为薄，想君时见思",
            "poemId": "poem_40"
        },
        {
            "line": "既至金门远，孰云吾道非",
            "poemId": "poem_495"
        }
    ],
    "亮": [
        {
            "line": "亮无晨风翼，焉能凌风飞",
            "poemId": "poem_29"
        }
    ],
    "眄": [
        {
            "line": "眄睐以适意，引领遥相睎",
            "poemId": "poem_29"
        }
    ],
    "徙": [
        {
            "line": "徙倚怀感伤，垂涕沾双扉",
            "poemId": "poem_29"
        }
    ],
    "初": [
        {
            "line": "初期会盟津，乃心在咸阳",
            "poemId": "poem_30"
        },
        {
            "line": "初发扬州时，船出平津泊",
            "poemId": "poem_64"
        },
        {
            "line": "初因避地去人间，及至成仙遂不还",
            "poemId": "poem_564"
        }
    ],
    "军": [
        {
            "line": "军合力不齐，踌躇而雁行",
            "poemId": "poem_30"
        }
    ],
    "势": [
        {
            "line": "势利使人争，嗣还自相戕",
            "poemId": "poem_30"
        },
        {
            "line": "势分三足鼎，业复五铢钱",
            "poemId": "poem_430"
        }
    ],
    "淮": [
        {
            "line": "淮南弟称号，刻玺於北方",
            "poemId": "poem_30"
        },
        {
            "line": "淮上有秋山",
            "poemId": "poem_410"
        },
        {
            "line": "淮南一叶下，自觉洞庭波",
            "poemId": "poem_427"
        },
        {
            "line": "淮西有贼五十载，封狼生貙貙生罴",
            "poemId": "poem_536"
        },
        {
            "line": "淮阴市井笑韩信，汉朝公卿忌贾生",
            "poemId": "poem_567"
        }
    ],
    "铠": [
        {
            "line": "铠甲生虮虱，万姓以死亡",
            "poemId": "poem_30"
        }
    ],
    "白": [
        {
            "line": "白骨露於野，千里无鸡鸣",
            "poemId": "poem_30"
        },
        {
            "line": "白马饰金羁，连翩西北驰",
            "poemId": "poem_38"
        },
        {
            "line": "白日丽飞甍，参差皆可见",
            "poemId": "poem_55"
        },
        {
            "line": "白云满鄣来，黄尘暗天起",
            "poemId": "poem_87"
        },
        {
            "line": "白鸟一双临水立，见人惊起入芦花",
            "poemId": "poem_189"
        },
        {
            "line": "白鹭忽飞来，点破秧针绿",
            "poemId": "poem_224"
        },
        {
            "line": "白羽如霜出塞寒，胡烽不断接长安",
            "poemId": "poem_229"
        },
        {
            "line": "白头宫女在，闲坐说玄宗",
            "poemId": "poem_279"
        },
        {
            "line": "白日依山尽，黄河入海流",
            "poemId": "poem_286"
        },
        {
            "line": "白云回望合，青霭入看无",
            "poemId": "poem_360"
        },
        {
            "line": "白头搔更短，浑欲不胜簪",
            "poemId": "poem_395"
        },
        {
            "line": "白云依静渚，春草闭闲门",
            "poemId": "poem_424"
        },
        {
            "line": "白日放歌须纵酒，青春作伴好还乡",
            "poemId": "poem_467"
        },
        {
            "line": "白露堂中细草迹，红罗帐里不胜情",
            "poemId": "poem_563"
        },
        {
            "line": "白日登山望烽火，黄昏饮马傍交河",
            "poemId": "poem_584"
        },
        {
            "line": "白狼河北音书断，丹凤城南秋夜长",
            "poemId": "poem_593"
        }
    ],
    "生": [
        {
            "line": "生民百遗一，念之断人肠",
            "poemId": "poem_30"
        },
        {
            "line": "生当作人杰，死亦为鬼雄",
            "poemId": "poem_145"
        },
        {
            "line": "生平未报国，留作忠魂补",
            "poemId": "poem_230"
        },
        {
            "line": "生涯岂料承优诏，世事空知学醉歌",
            "poemId": "poem_491"
        },
        {
            "line": "生事且弥漫，愿为持竿叟",
            "poemId": "poem_524"
        },
        {
            "line": "生女犹得嫁比邻，生男埋没随百草",
            "poemId": "poem_583"
        }
    ],
    "水": [
        {
            "line": "水何澹澹，山岛竦峙",
            "poemId": "poem_31"
        },
        {
            "line": "水绕陂田竹绕篱，榆钱落尽槿花稀",
            "poemId": "poem_112"
        },
        {
            "line": "水光潋滟晴方好，山色空蒙雨亦奇",
            "poemId": "poem_122"
        },
        {
            "line": "水满田畴稻叶齐，日光穿树晓烟低",
            "poemId": "poem_180"
        },
        {
            "line": "水落鱼梁浅，天寒梦泽深",
            "poemId": "poem_408"
        },
        {
            "line": "水月通禅寂，鱼龙听梵声",
            "poemId": "poem_433"
        },
        {
            "line": "水深波浪阔，无使蛟龙得",
            "poemId": "poem_501"
        },
        {
            "line": "水深波浪阔，无使蛟龙得",
            "poemId": "poem_501"
        }
    ],
    "树": [
        {
            "line": "树木丛生，百草丰茂",
            "poemId": "poem_31"
        }
    ],
    "星": [
        {
            "line": "星汉灿烂，若出其里",
            "poemId": "poem_31"
        },
        {
            "line": "星汉空如此，宁知心有忆",
            "poemId": "poem_62"
        },
        {
            "line": "星旗映疏勒，云阵上祁连",
            "poemId": "poem_74"
        },
        {
            "line": "星垂平野阔，月涌大江流",
            "poemId": "poem_391"
        },
        {
            "line": "星临万户动，月傍九霄多",
            "poemId": "poem_399"
        },
        {
            "line": "星河秋一雁，砧杵夜千家",
            "poemId": "poem_441"
        },
        {
            "line": "星宫之君醉琼浆，羽人稀少不在旁",
            "poemId": "poem_546"
        }
    ],
    "对": [
        {
            "line": "对酒当歌，人生几何",
            "poemId": "poem_32"
        },
        {
            "line": "对案不能食，拔剑击柱长叹息",
            "poemId": "poem_53"
        },
        {
            "line": "对此结中肠，义往难复留",
            "poemId": "poem_515"
        }
    ],
    "譬": [
        {
            "line": "譬如朝露，去日苦多",
            "poemId": "poem_32"
        }
    ],
    "慨": [
        {
            "line": "慨当以慷，忧思难忘",
            "poemId": "poem_32"
        }
    ],
    "何": [
        {
            "line": "何以解忧",
            "poemId": "poem_32"
        },
        {
            "line": "何言一不见，复会无因缘",
            "poemId": "poem_40"
        },
        {
            "line": "何惜微躯尽，缠绵自有时",
            "poemId": "poem_71"
        },
        {
            "line": "何事吟余忽惆怅，村桥原树似吾乡",
            "poemId": "poem_82"
        },
        {
            "line": "何事春风容不得",
            "poemId": "poem_85"
        },
        {
            "line": "何方可化身千亿，一树梅花一放翁",
            "poemId": "poem_160"
        },
        {
            "line": "何处它年寄此生，山中江上总关情",
            "poemId": "poem_215"
        },
        {
            "line": "何时倚虚幌，双照泪痕干",
            "poemId": "poem_389"
        },
        {
            "line": "何因不归去",
            "poemId": "poem_410"
        },
        {
            "line": "何当重相见，尊酒慰离颜",
            "poemId": "poem_425"
        },
        {
            "line": "何用别寻方外去，人间亦自有丹丘",
            "poemId": "poem_490"
        },
        {
            "line": "何当载酒来，共醉重阳节",
            "poemId": "poem_510"
        },
        {
            "line": "何日平胡虏，良人罢远征",
            "poemId": "poem_578"
        }
    ],
    "唯": [
        {
            "line": "唯有杜康",
            "poemId": "poem_32"
        },
        {
            "line": "唯有南风旧相识，偷开门户又翻书",
            "poemId": "poem_117"
        },
        {
            "line": "唯见林花落，莺啼送客闻",
            "poemId": "poem_394"
        }
    ],
    "但": [
        {
            "line": "但为君故，沉吟至今",
            "poemId": "poem_32"
        },
        {
            "line": "但得众生皆得饱，不辞羸病卧残阳",
            "poemId": "poem_158"
        },
        {
            "line": "但得明年少行役，只裁白伫作春衫",
            "poemId": "poem_182"
        },
        {
            "line": "但去莫复问，白云无尽时",
            "poemId": "poem_500"
        },
        {
            "line": "但见新人笑，那闻旧人哭",
            "poemId": "poem_506"
        },
        {
            "line": "但教心似金钿坚，天上人间会相见",
            "poemId": "poem_526"
        },
        {
            "line": "但看古来盛名下，终日坎壈缠其身",
            "poemId": "poem_544"
        },
        {
            "line": "但使龙城飞将在，不教胡马度阴山",
            "poemId": "poem_556"
        },
        {
            "line": "但见悲鸟号古木，雄飞雌从绕林间",
            "poemId": "poem_576"
        }
    ],
    "呦": [
        {
            "line": "呦呦鹿鸣，食野之苹",
            "poemId": "poem_32"
        }
    ],
    "越": [
        {
            "line": "越陌度阡，枉用相存",
            "poemId": "poem_32"
        },
        {
            "line": "越人语天姥，云霞明灭或可睹",
            "poemId": "poem_534"
        }
    ],
    "契": [
        {
            "line": "契阔谈讌，心念旧恩",
            "poemId": "poem_32"
        }
    ],
    "绕": [
        {
            "line": "绕树三匝，何枝可依",
            "poemId": "poem_32"
        }
    ],
    "周": [
        {
            "line": "周公吐哺，天下归心",
            "poemId": "poem_32"
        },
        {
            "line": "周南留滞古所惜，南极老人应寿昌",
            "poemId": "poem_546"
        },
        {
            "line": "周纲凌迟四海沸，宣王愤起挥天戈",
            "poemId": "poem_551"
        }
    ],
    "亭": [
        {
            "line": "亭亭山上松，瑟瑟谷中风",
            "poemId": "poem_33"
        },
        {
            "line": "亭亭画舸系春潭，直到行人酒半酣",
            "poemId": "poem_81"
        }
    ],
    "冰": [
        {
            "line": "冰霜正惨凄，终岁常端正",
            "poemId": "poem_33"
        },
        {
            "line": "冰簟银床梦不成，碧天如水夜云轻",
            "poemId": "poem_352"
        },
        {
            "line": "冰泉冷涩弦凝绝，凝绝不通声暂歇",
            "poemId": "poem_529"
        }
    ],
    "举": [
        {
            "line": "举秀才，不知书",
            "poemId": "poem_34"
        },
        {
            "line": "举孝廉，父别居",
            "poemId": "poem_34"
        },
        {
            "line": "举头望明月，低头思故乡",
            "poemId": "poem_291"
        },
        {
            "line": "举杯邀明月，对影成三人",
            "poemId": "poem_498"
        }
    ],
    "寒": [
        {
            "line": "寒素清白浊如泥，高第良将怯如鸡",
            "poemId": "poem_34"
        },
        {
            "line": "寒不能语，舌卷入喉",
            "poemId": "poem_78"
        },
        {
            "line": "寒夜客来茶当酒，竹炉汤沸火初红",
            "poemId": "poem_197"
        },
        {
            "line": "寒衣针线密，家信墨痕新",
            "poemId": "poem_257"
        },
        {
            "line": "寒雨连江夜入吴，平明送客楚山孤",
            "poemId": "poem_305"
        },
        {
            "line": "寒山转苍翠，秋水日潺湲",
            "poemId": "poem_366"
        },
        {
            "line": "寒禽与衰草，处处伴愁颜",
            "poemId": "poem_373"
        },
        {
            "line": "寒灯思旧事，断雁警愁眠",
            "poemId": "poem_396"
        }
    ],
    "煮": [
        {
            "line": "煮豆燃豆萁，豆在釜中泣",
            "poemId": "poem_35"
        }
    ],
    "本": [
        {
            "line": "本是同根生，相煎何太急",
            "poemId": "poem_35"
        },
        {
            "line": "本自同根生，相煎何太急",
            "poemId": "poem_35"
        },
        {
            "line": "本以高难饱，徒劳恨费声",
            "poemId": "poem_384"
        }
    ],
    "（": [
        {
            "line": "（版本一）煮豆持作羹，漉菽以为汁",
            "poemId": "poem_35"
        },
        {
            "line": "（版本二）",
            "poemId": "poem_35"
        },
        {
            "line": "（名成 一作：名高）江流石不转，遗恨失吞吴",
            "poemId": "poem_290"
        },
        {
            "line": "（不得志 一作：不得意）低眉信手续续弹，说尽心中无限事",
            "poemId": "poem_529"
        }
    ],
    "萁": [
        {
            "line": "萁在釜下燃，豆在釜中泣",
            "poemId": "poem_35"
        }
    ],
    "贱": [
        {
            "line": "贱妾茕茕守空房，忧来思君不敢忘，不觉泪下沾衣裳",
            "poemId": "poem_36"
        },
        {
            "line": "贱日岂殊众，贵来方悟稀",
            "poemId": "poem_496"
        }
    ],
    "援": [
        {
            "line": "援琴鸣弦发清商，短歌微吟不能长",
            "poemId": "poem_36"
        }
    ],
    "牵": [
        {
            "line": "牵牛织女遥相望，尔独何辜限河梁",
            "poemId": "poem_36"
        }
    ],
    "夜": [
        {
            "line": "夜中不能寐，起坐弹鸣琴",
            "poemId": "poem_37"
        },
        {
            "line": "夜深江月弄清辉，水上人歌月下归",
            "poemId": "poem_96"
        },
        {
            "line": "夜雨连明春水生，娇云浓暖弄阴晴",
            "poemId": "poem_97"
        },
        {
            "line": "夜闻归雁生乡思，病入新年感物华",
            "poemId": "poem_101"
        },
        {
            "line": "夜阑卧听风吹雨，铁马冰河入梦来",
            "poemId": "poem_162"
        },
        {
            "line": "夜寒香界白，涧曲寺门通",
            "poemId": "poem_253"
        },
        {
            "line": "夜来风雨声，花落知多少",
            "poemId": "poem_292"
        },
        {
            "line": "夜雨剪春韭，新炊间黄粱",
            "poemId": "poem_505"
        },
        {
            "line": "夜深忽梦少年事，梦啼妆泪红阑干",
            "poemId": "poem_529"
        },
        {
            "line": "夜深静卧百虫绝，清月出岭光入扉",
            "poemId": "poem_552"
        },
        {
            "line": "夜投佛寺上高阁，星月掩映云曈昽",
            "poemId": "poem_553"
        }
    ],
    "薄": [
        {
            "line": "薄帷鉴明月，清风吹我襟",
            "poemId": "poem_37"
        },
        {
            "line": "薄暮空潭曲，安禅制毒龙",
            "poemId": "poem_369"
        }
    ],
    "孤": [
        {
            "line": "孤鸿号外野，翔鸟鸣北林",
            "poemId": "poem_37"
        },
        {
            "line": "孤灯暧不明，寒机晓犹织",
            "poemId": "poem_62"
        },
        {
            "line": "孤舟蓑笠翁，独钓寒江雪",
            "poemId": "poem_295"
        },
        {
            "line": "孤云将野鹤，岂向人间住",
            "poemId": "poem_312"
        },
        {
            "line": "孤帆远影碧空尽，唯见长江天际流",
            "poemId": "poem_316"
        },
        {
            "line": "孤灯寒照雨，深竹暗浮烟",
            "poemId": "poem_371"
        },
        {
            "line": "孤灯闻楚角，残月下章台",
            "poemId": "poem_409"
        },
        {
            "line": "孤城背岭寒吹角，独树临江夜泊船",
            "poemId": "poem_486"
        },
        {
            "line": "孤鸿海上来，池潢不敢顾",
            "poemId": "poem_521"
        },
        {
            "line": "孤灯不明思欲绝，卷帷望月空长叹",
            "poemId": "poem_572"
        }
    ],
    "徘": [
        {
            "line": "徘徊将何见",
            "poemId": "poem_37"
        }
    ],
    "借": [
        {
            "line": "借问谁家子，幽并游侠儿",
            "poemId": "poem_38"
        },
        {
            "line": "借问艑上郎，见侬所欢不",
            "poemId": "poem_64"
        },
        {
            "line": "借问路傍名利客，无如此处学长生",
            "poemId": "poem_479"
        },
        {
            "line": "借问苦心爱者谁，后有韦讽前支遁",
            "poemId": "poem_547"
        },
        {
            "line": "借问汉宫谁得似，可怜飞燕倚新妆",
            "poemId": "poem_569"
        }
    ],
    "宿": [
        {
            "line": "宿昔秉良弓，楛矢何参差",
            "poemId": "poem_38"
        }
    ],
    "控": [
        {
            "line": "控弦破左的，右发摧月支",
            "poemId": "poem_38"
        }
    ],
    "仰": [
        {
            "line": "仰手接飞猱，俯身散马蹄",
            "poemId": "poem_38"
        }
    ],
    "狡": [
        {
            "line": "狡捷过猴猿，勇剽若豹螭",
            "poemId": "poem_38"
        }
    ],
    "边": [
        {
            "line": "边城多警急，虏骑数迁移",
            "poemId": "poem_38"
        },
        {
            "line": "边筹自古无中下，朝论于今有是非",
            "poemId": "poem_235"
        },
        {
            "line": "边庭流血成海水，武皇开边意未已",
            "poemId": "poem_583"
        },
        {
            "line": "边庭飘飖那可度，绝域苍茫更何有",
            "poemId": "poem_591"
        }
    ],
    "羽": [
        {
            "line": "羽檄从北来，厉马登高堤",
            "poemId": "poem_38"
        },
        {
            "line": "羽书昨夜过渠黎，单于已在金山西",
            "poemId": "poem_532"
        }
    ],
    "长": [
        {
            "line": "长驱蹈匈奴，左顾凌鲜卑",
            "poemId": "poem_38"
        },
        {
            "line": "长条别有风流处，密映钱塘苏小家",
            "poemId": "poem_83"
        },
        {
            "line": "长桥寂寞春寒放，只有诗人一舸归",
            "poemId": "poem_182"
        },
        {
            "line": "长乐宫连上苑春，玉楼金殿艳歌新",
            "poemId": "poem_357"
        },
        {
            "line": "长江一帆远，落日五湖春",
            "poemId": "poem_429"
        },
        {
            "line": "长簟迎风早，空城澹月华",
            "poemId": "poem_441"
        },
        {
            "line": "长乐钟声花外尽，龙池柳色雨中深",
            "poemId": "poem_488"
        },
        {
            "line": "长歌吟松风，曲尽河星稀",
            "poemId": "poem_507"
        },
        {
            "line": "长风连日作大浪，不能废人运酒舫",
            "poemId": "poem_528"
        },
        {
            "line": "长风万里送秋雁，对此可以酣高楼",
            "poemId": "poem_533"
        },
        {
            "line": "长绳百尺拽碑倒，粗砂大石相磨治",
            "poemId": "poem_536"
        },
        {
            "line": "长安城连东掖垣，凤凰池对青琐门",
            "poemId": "poem_537"
        },
        {
            "line": "长河浪头连天黑，津口停舟渡不得",
            "poemId": "poem_543"
        },
        {
            "line": "长信宫中秋月明，昭阳殿下捣衣声",
            "poemId": "poem_563"
        },
        {
            "line": "长风破浪会有时，直挂云帆济沧海",
            "poemId": "poem_566"
        },
        {
            "line": "长相思，在长安",
            "poemId": "poem_572"
        },
        {
            "line": "长相思，摧心肝",
            "poemId": "poem_572"
        },
        {
            "line": "长安一片月，万户捣衣声",
            "poemId": "poem_578"
        },
        {
            "line": "长风几万里，吹度玉门关",
            "poemId": "poem_581"
        },
        {
            "line": "长者虽有问，役夫敢申恨",
            "poemId": "poem_583"
        },
        {
            "line": "长安城头头白乌，夜飞延秋门上呼",
            "poemId": "poem_585"
        }
    ],
    "父": [
        {
            "line": "父母且不顾，何言子与妻",
            "poemId": "poem_38"
        }
    ],
    "名": [
        {
            "line": "名编壮士籍，不得中顾私",
            "poemId": "poem_38"
        },
        {
            "line": "名岂文章著，官应老病休",
            "poemId": "poem_391"
        },
        {
            "line": "名花倾国两相欢，常得君王带笑看",
            "poemId": "poem_565"
        }
    ],
    "捐": [
        {
            "line": "捐躯赴国难，视死忽如归",
            "poemId": "poem_38"
        }
    ],
    "西": [
        {
            "line": "西京乱无象，豺虎方遘患",
            "poemId": "poem_39"
        },
        {
            "line": "西北天低五顶高，茫茫松海露灵鳌",
            "poemId": "poem_199"
        },
        {
            "line": "西陆蝉声唱，南冠客思深",
            "poemId": "poem_436"
        },
        {
            "line": "西山白雪三城戍，南浦清江万里桥",
            "poemId": "poem_468"
        },
        {
            "line": "西宫南内多秋草，落叶满阶红不扫",
            "poemId": "poem_526"
        },
        {
            "line": "西当太白有鸟道，可以横绝峨眉巅",
            "poemId": "poem_576"
        }
    ],
    "复": [
        {
            "line": "复弃中国去，委身适荆蛮",
            "poemId": "poem_39"
        },
        {
            "line": "复楚情何极，亡秦气未平",
            "poemId": "poem_240"
        }
    ],
    "亲": [
        {
            "line": "亲戚对我悲，朋友相追攀",
            "poemId": "poem_39"
        },
        {
            "line": "亲朋无一字，老病有孤舟",
            "poemId": "poem_386"
        }
    ],
    "路": [
        {
            "line": "路有饥妇人，抱子弃草间",
            "poemId": "poem_39"
        },
        {
            "line": "路旁时卖故侯瓜，门前学种先生柳",
            "poemId": "poem_561"
        }
    ],
    "顾": [
        {
            "line": "顾闻号泣声，挥涕独不还",
            "poemId": "poem_39"
        },
        {
            "line": "顾我无衣搜荩箧，泥他沽酒拔金钗",
            "poemId": "poem_442"
        }
    ],
    "“": [
        {
            "line": "“未知身死处，何能两相完",
            "poemId": "poem_39"
        }
    ],
    "南": [
        {
            "line": "南登霸陵岸，回首望长安，悟彼下泉人，喟然伤心肝",
            "poemId": "poem_39"
        },
        {
            "line": "南国有佳人，容华若桃李",
            "poemId": "poem_43"
        },
        {
            "line": "南浦春来绿一川，石桥朱塔两依然",
            "poemId": "poem_177"
        },
        {
            "line": "南北驱驰报主情，江花边草笑平生",
            "poemId": "poem_231"
        },
        {
            "line": "南内 一作：南苑)梨园弟子白发新，椒房阿监青娥老",
            "poemId": "poem_526"
        },
        {
            "line": "南山截竹为觱篥，此乐本自龟兹出",
            "poemId": "poem_538"
        }
    ],
    "沉": [
        {
            "line": "沉阴结愁忧，愁忧为谁兴",
            "poemId": "poem_40"
        },
        {
            "line": "沉吟放拨插弦中，整顿衣裳起敛容",
            "poemId": "poem_529"
        }
    ],
    "念": [
        {
            "line": "念与君相别，各在天一方",
            "poemId": "poem_40"
        },
        {
            "line": "念其霜中能作花，露中能作实",
            "poemId": "poem_52"
        },
        {
            "line": "念吾一身，飘然旷野",
            "poemId": "poem_78"
        },
        {
            "line": "念天地之悠悠，独怆然而涕下",
            "poemId": "poem_550"
        }
    ],
    "端": [
        {
            "line": "端坐而无为，仿佛君容光",
            "poemId": "poem_40"
        }
    ],
    "峨": [
        {
            "line": "峨峨高山首，悠悠万里道",
            "poemId": "poem_40"
        },
        {
            "line": "峨嵋山下少人行，旌旗无光日色薄",
            "poemId": "poem_526"
        }
    ],
    "每": [
        {
            "line": "每诵昔鸿恩，贱躯焉足保",
            "poemId": "poem_40"
        }
    ],
    "飘": [
        {
            "line": "飘摇不可寄，徙倚徒相思",
            "poemId": "poem_40"
        },
        {
            "line": "飘如迁客来过岭，坠似骚人去赴湘",
            "poemId": "poem_186"
        },
        {
            "line": "飘飘何所似，天地一沙鸥",
            "poemId": "poem_391"
        },
        {
            "line": "飘飘 一作：飘飖)含情凝睇谢君王，一别音容两渺茫",
            "poemId": "poem_526"
        }
    ],
    "自": [
        {
            "line": "自君之出矣，明镜暗不治",
            "poemId": "poem_40"
        },
        {
            "line": "自恨志不遂，泣涕如涌泉",
            "poemId": "poem_40"
        },
        {
            "line": "自古圣贤尽贫贱，何况我辈孤且直",
            "poemId": "poem_53"
        },
        {
            "line": "自作新词韵最娇，小红低唱我吹箫",
            "poemId": "poem_178"
        },
        {
            "line": "自顾无长策，空知返旧林",
            "poemId": "poem_363"
        },
        {
            "line": "自云良家子，零落依草木",
            "poemId": "poem_506"
        },
        {
            "line": "自小阙内训，事姑贻我忧",
            "poemId": "poem_515"
        },
        {
            "line": "自惭居处崇，未睹斯民康",
            "poemId": "poem_518"
        },
        {
            "line": "自有岁寒心",
            "poemId": "poem_525"
        },
        {
            "line": "自言本是京城女，家在虾蟆陵下住",
            "poemId": "poem_529"
        },
        {
            "line": "自从献宝朝河宗，无复射蛟江水中",
            "poemId": "poem_547"
        },
        {
            "line": "自从弃置便衰朽，世事蹉跎成白首",
            "poemId": "poem_561"
        },
        {
            "line": "自怜碧玉亲教舞，不惜珊瑚持与人",
            "poemId": "poem_562"
        },
        {
            "line": "自谓经过旧不迷，安知峰壑今来变",
            "poemId": "poem_564"
        }
    ],
    "惨": [
        {
            "line": "惨惨时节尽，兰叶复凋零",
            "poemId": "poem_40"
        },
        {
            "line": "惨澹龙蛇日斗争，干戈直欲尽生灵",
            "poemId": "poem_200"
        },
        {
            "line": "惨惨柴门风雪夜，此时有子不如无",
            "poemId": "poem_264"
        }
    ],
    "喟": [
        {
            "line": "喟然长叹息，君期慰我情",
            "poemId": "poem_40"
        }
    ],
    "辗": [
        {
            "line": "辗转不能寐，长夜何绵绵",
            "poemId": "poem_40"
        }
    ],
    "蹑": [
        {
            "line": "蹑履起出户，仰观三星连",
            "poemId": "poem_40"
        }
    ],
    "安": [
        {
            "line": "安得鸿鸾羽，觏此心中人",
            "poemId": "poem_40"
        },
        {
            "line": "安能蹀躞垂羽翼",
            "poemId": "poem_53"
        },
        {
            "line": "安能摧眉折腰事权贵，使我不得开心颜!",
            "poemId": "poem_534"
        },
        {
            "line": "安能以此尚论列，愿借辩口如悬河",
            "poemId": "poem_551"
        }
    ],
    "诚": [
        {
            "line": "诚心亮不遂，搔首立悁悁",
            "poemId": "poem_40"
        },
        {
            "line": "诚知此恨人人有，贫贱夫妻百事哀",
            "poemId": "poem_437"
        }
    ],
    "故": [
        {
            "line": "故如比目鱼，今隔如参辰",
            "poemId": "poem_40"
        },
        {
            "line": "故乡篱下菊，今日几花开",
            "poemId": "poem_77"
        },
        {
            "line": "故旧凭君休更说，老怀容易便沾襟",
            "poemId": "poem_242"
        },
        {
            "line": "故国三千里，深宫二十年",
            "poemId": "poem_299"
        },
        {
            "line": "故人西辞黄鹤楼，烟花三月下扬州",
            "poemId": "poem_316"
        },
        {
            "line": "故园东望路漫漫，双袖龙钟泪不干",
            "poemId": "poem_319"
        },
        {
            "line": "故人江海别，几度隔山川",
            "poemId": "poem_371"
        },
        {
            "line": "故人具鸡黍，邀我至田家",
            "poemId": "poem_404"
        },
        {
            "line": "故关衰草遍，离别自堪悲",
            "poemId": "poem_431"
        },
        {
            "line": "故人入我梦，明我长相忆",
            "poemId": "poem_501"
        },
        {
            "line": "故人入我梦，明我长相忆",
            "poemId": "poem_501"
        },
        {
            "line": "故人从军在右辅，为我度量掘臼科",
            "poemId": "poem_551"
        }
    ],
    "别": [
        {
            "line": "别来历年岁，旧恩何可期",
            "poemId": "poem_40"
        },
        {
            "line": "别院深深夏席清，石榴开遍透帘明",
            "poemId": "poem_98"
        },
        {
            "line": "别后相思空一水，重来回首已三生",
            "poemId": "poem_267"
        },
        {
            "line": "别梦依依到谢家，小廊回合曲阑斜",
            "poemId": "poem_341"
        },
        {
            "line": "别来沧海事，语罢暮天钟",
            "poemId": "poem_379"
        },
        {
            "line": "别离在今晨，见尔当何秋",
            "poemId": "poem_515"
        },
        {
            "line": "别君去兮何时还",
            "poemId": "poem_534"
        }
    ],
    "重": [
        {
            "line": "重新而忘故，君子所尤讥",
            "poemId": "poem_40"
        },
        {
            "line": "重以桑梓念，凄其江汉情",
            "poemId": "poem_222"
        },
        {
            "line": "重帏深下莫愁堂，卧后清宵细细长",
            "poemId": "poem_449"
        }
    ],
    "寄": [
        {
            "line": "寄身虽在远，岂忘君须臾",
            "poemId": "poem_40"
        },
        {
            "line": "寄书长不达，况乃未休兵",
            "poemId": "poem_393"
        },
        {
            "line": "寄卧郊扉久，何年致此身",
            "poemId": "poem_413"
        },
        {
            "line": "寄身且喜沧洲近，顾影无如白发何",
            "poemId": "poem_491"
        }
    ],
    "息": [
        {
            "line": "息徒兰圃，秣马华山",
            "poemId": "poem_42"
        }
    ],
    "流": [
        {
            "line": "流磻平皋，垂纶长川",
            "poemId": "poem_42"
        },
        {
            "line": "流水如有意，暮禽相与还",
            "poemId": "poem_365"
        },
        {
            "line": "流落征南将，曾驱十万师",
            "poemId": "poem_435"
        },
        {
            "line": "流传汉地曲转奇， 凉州胡人为我吹",
            "poemId": "poem_538"
        }
    ],
    "目": [
        {
            "line": "目送归鸿，手挥五弦",
            "poemId": "poem_42"
        }
    ],
    "俯": [
        {
            "line": "俯仰自得，游心太玄",
            "poemId": "poem_42"
        },
        {
            "line": "俯仰岁将暮，荣耀难久恃",
            "poemId": "poem_43"
        },
        {
            "line": "俯饮一杯酒，仰聆金玉章",
            "poemId": "poem_518"
        }
    ],
    "嘉": [
        {
            "line": "嘉彼钓翁，得鱼忘筌",
            "poemId": "poem_42"
        }
    ],
    "郢": [
        {
            "line": "郢人逝矣，谁与尽言",
            "poemId": "poem_42"
        }
    ],
    "朝": [
        {
            "line": "朝游江北岸，夕宿潇湘沚",
            "poemId": "poem_43"
        },
        {
            "line": "朝出与亲辞，暮还在亲侧",
            "poemId": "poem_53"
        },
        {
            "line": "朝洒长门泣，夕驻临邛杯",
            "poemId": "poem_60"
        },
        {
            "line": "朝发欣城，暮宿陇头",
            "poemId": "poem_78"
        },
        {
            "line": "朝求升，暮求合，近来贫汉难存活",
            "poemId": "poem_237"
        },
        {
            "line": "朝辞白帝彩云间，千里江陵一日还",
            "poemId": "poem_317"
        },
        {
            "line": "朝罢香烟携满袖，诗成珠玉在挥毫",
            "poemId": "poem_446"
        },
        {
            "line": "朝闻游子唱离歌，昨夜微霜初渡河",
            "poemId": "poem_458"
        },
        {
            "line": "朝为越溪女，暮作吴宫妃",
            "poemId": "poem_496"
        },
        {
            "line": "朝避猛虎，夕避长蛇",
            "poemId": "poem_576"
        }
    ],
    "结": [
        {
            "line": "结庐在人境，而无车马喧",
            "poemId": "poem_44"
        }
    ],
    "问": [
        {
            "line": "问君何能尔",
            "poemId": "poem_44"
        },
        {
            "line": "问君何独然",
            "poemId": "poem_52"
        },
        {
            "line": "问渠那得清如许",
            "poemId": "poem_174"
        },
        {
            "line": "问姓惊初见，称名忆旧容",
            "poemId": "poem_379"
        },
        {
            "line": "问答未及已，驱儿罗酒浆",
            "poemId": "poem_505"
        },
        {
            "line": "问客何为来，采山因买斧",
            "poemId": "poem_514"
        },
        {
            "line": "问君西游何时还",
            "poemId": "poem_576"
        },
        {
            "line": "问之不肯道姓名，但道困苦乞为奴",
            "poemId": "poem_585"
        }
    ],
    "此": [
        {
            "line": "此中有真意，欲辨已忘言",
            "poemId": "poem_44"
        },
        {
            "line": "此地动归念，长年悲倦游",
            "poemId": "poem_68"
        },
        {
            "line": "此身合是诗人未",
            "poemId": "poem_159"
        },
        {
            "line": "此景只应天上有，岂知身在妙高峰",
            "poemId": "poem_199"
        },
        {
            "line": "此地一为别，孤蓬万里征",
            "poemId": "poem_381"
        },
        {
            "line": "此道昔归顺，西郊胡正繁",
            "poemId": "poem_392"
        },
        {
            "line": "此情可待成追忆，只是当时已惘然",
            "poemId": "poem_454"
        },
        {
            "line": "此皆骑战一敌万，缟素漠漠开风沙",
            "poemId": "poem_547"
        },
        {
            "line": "此曲有意无人传，愿随春风寄燕然",
            "poemId": "poem_574"
        }
    ],
    "郁": [
        {
            "line": "郁郁涧底松，离离山上苗",
            "poemId": "poem_45"
        }
    ],
    "世": [
        {
            "line": "世胄蹑高位，英俊沉下僚",
            "poemId": "poem_45"
        },
        {
            "line": "世味年来薄似纱，谁令骑马客京华",
            "poemId": "poem_154"
        },
        {
            "line": "世乱同南去，时清独北还",
            "poemId": "poem_373"
        },
        {
            "line": "世界微尘里，吾宁爱与憎",
            "poemId": "poem_383"
        },
        {
            "line": "世事茫茫难自料，春愁黯黯独成眠",
            "poemId": "poem_475"
        },
        {
            "line": "世情恶衰歇，万事随转烛",
            "poemId": "poem_506"
        },
        {
            "line": "世事波上舟，沿洄安得住",
            "poemId": "poem_520"
        },
        {
            "line": "世间行乐亦如此，古来万事东流水",
            "poemId": "poem_534"
        }
    ],
    "地": [
        {
            "line": "地势使之然，由来非一朝",
            "poemId": "poem_45"
        },
        {
            "line": "地犹鄹氏邑，宅即鲁王宫",
            "poemId": "poem_412"
        },
        {
            "line": "地下若逢陈后主，岂宜重问后庭花",
            "poemId": "poem_460"
        },
        {
            "line": "地崩山摧壮士死，然后天梯石栈相钩连",
            "poemId": "poem_576"
        }
    ],
    "金": [
        {
            "line": "金张藉旧业，七叶珥汉貂",
            "poemId": "poem_45"
        },
        {
            "line": "金炉香烬漏声残，剪剪轻风阵阵寒",
            "poemId": "poem_107"
        },
        {
            "line": "金粉东南十五州，万重恩怨属名流",
            "poemId": "poem_268"
        },
        {
            "line": "金陵津渡小山楼，一宿行人自可愁",
            "poemId": "poem_342"
        },
        {
            "line": "金阙晓钟开万户，玉阶仙仗拥千官",
            "poemId": "poem_445"
        },
        {
            "line": "金蟾啮锁烧香入，玉虎牵丝汲井回",
            "poemId": "poem_452"
        },
        {
            "line": "金屋妆成娇侍夜，玉楼宴罢醉和春",
            "poemId": "poem_526"
        },
        {
            "line": "金阙西厢叩玉扃，转教小玉报双成",
            "poemId": "poem_526"
        },
        {
            "line": "金粟堆前木已拱，瞿唐石城草萧瑟",
            "poemId": "poem_542"
        },
        {
            "line": "金绳铁索锁钮壮，古鼎跃水龙腾梭",
            "poemId": "poem_551"
        },
        {
            "line": "金井梧桐秋叶黄，珠帘不卷夜来霜",
            "poemId": "poem_563"
        },
        {
            "line": "金樽清酒斗十千，玉盘珍羞直万钱",
            "poemId": "poem_566"
        },
        {
            "line": "金鞭断折九马死，骨肉不得同驰驱",
            "poemId": "poem_585"
        }
    ],
    "冯": [
        {
            "line": "冯公岂不伟，白首不见招",
            "poemId": "poem_45"
        }
    ],
    "误": [
        {
            "line": "误落尘网中，一去三十年",
            "poemId": "poem_46"
        }
    ],
    "开": [
        {
            "line": "开荒南野际，守拙归园田",
            "poemId": "poem_46"
        },
        {
            "line": "开轩面场圃，把酒话桑麻",
            "poemId": "poem_404"
        },
        {
            "line": "开元之中常引见，承恩数上南薰殿",
            "poemId": "poem_544"
        }
    ],
    "方": [
        {
            "line": "方宅十余亩，草屋八九间",
            "poemId": "poem_46"
        },
        {
            "line": "方知大藩地，岂曰财赋强",
            "poemId": "poem_518"
        },
        {
            "line": "方今太平日无事，柄任儒术崇丘轲",
            "poemId": "poem_551"
        }
    ],
    "榆": [
        {
            "line": "榆柳荫后檐，桃李罗堂前",
            "poemId": "poem_46"
        }
    ],
    "暧": [
        {
            "line": "暧暧远人村，依依墟里烟",
            "poemId": "poem_46"
        }
    ],
    "狗": [
        {
            "line": "狗吠深巷中，鸡鸣桑树颠",
            "poemId": "poem_46"
        }
    ],
    "久": [
        {
            "line": "久在樊笼里，复得返自然",
            "poemId": "poem_46"
        },
        {
            "line": "久为簪组累，幸此南夷谪",
            "poemId": "poem_513"
        }
    ],
    "种": [
        {
            "line": "种豆南山下，草盛豆苗稀",
            "poemId": "poem_47"
        }
    ],
    "衣": [
        {
            "line": "衣沾不足惜，但使愿无违",
            "poemId": "poem_47"
        },
        {
            "line": "衣上征尘杂酒痕，远游无处不消魂",
            "poemId": "poem_159"
        }
    ],
    "招": [
        {
            "line": "招集百夫良，岁暮得荆卿",
            "poemId": "poem_48"
        }
    ],
    "素": [
        {
            "line": "素骥鸣广陌，慷慨送我行",
            "poemId": "poem_48"
        },
        {
            "line": "素衣莫起风尘叹，犹及清明可到家",
            "poemId": "poem_154"
        },
        {
            "line": "素手青条上，红妆白日鲜",
            "poemId": "poem_579"
        },
        {
            "line": "素手抽针冷，那堪把剪刀",
            "poemId": "poem_580"
        }
    ],
    "雄": [
        {
            "line": "雄发指危冠，猛气冲长缨",
            "poemId": "poem_48"
        },
        {
            "line": "雄风清角劲，落日大旗明",
            "poemId": "poem_240"
        }
    ],
    "饮": [
        {
            "line": "饮饯易水上，四座列群英",
            "poemId": "poem_48"
        },
        {
            "line": "饮马渡秋水，水寒风似刀",
            "poemId": "poem_558"
        }
    ],
    "渐": [
        {
            "line": "渐离击悲筑，宋意唱高声",
            "poemId": "poem_48"
        },
        {
            "line": "渐与骨肉远，转于僮仆亲",
            "poemId": "poem_416"
        }
    ],
    "萧": [
        {
            "line": "萧萧哀风逝，淡淡寒波生",
            "poemId": "poem_48"
        },
        {
            "line": "萧萧远树疏林外，一半秋山带夕阳",
            "poemId": "poem_86"
        }
    ],
    "商": [
        {
            "line": "商音更流涕，羽奏壮士惊",
            "poemId": "poem_48"
        },
        {
            "line": "商女不知亡国恨，隔江犹唱后庭花",
            "poemId": "poem_335"
        },
        {
            "line": "商人重利轻别离，前月浮梁买茶去",
            "poemId": "poem_529"
        }
    ],
    "登": [
        {
            "line": "登车何时顾，飞盖入秦庭",
            "poemId": "poem_48"
        },
        {
            "line": "登舟望秋月，空忆谢将军",
            "poemId": "poem_376"
        },
        {
            "line": "登临出世界，磴道盘虚空",
            "poemId": "poem_497"
        },
        {
            "line": "登高壮观天地间，大江茫茫去不还",
            "poemId": "poem_540"
        }
    ],
    "凌": [
        {
            "line": "凌厉越万里，逶迤过千城",
            "poemId": "poem_48"
        },
        {
            "line": "凌烟功臣少颜色，将军下笔开生面",
            "poemId": "poem_544"
        }
    ],
    "图": [
        {
            "line": "图穷事自至，豪主正怔营",
            "poemId": "poem_48"
        }
    ],
    "惜": [
        {
            "line": "惜哉剑术疏，奇功遂不成",
            "poemId": "poem_48"
        }
    ],
    "其": [
        {
            "line": "其人虽已没，千载有馀情",
            "poemId": "poem_48"
        },
        {
            "line": "其间旦暮闻何物",
            "poemId": "poem_529"
        },
        {
            "line": "其余七匹亦殊绝，迥若寒空动烟雪",
            "poemId": "poem_547"
        },
        {
            "line": "其险也如此，嗟尔远道之人胡为乎来哉",
            "poemId": "poem_576"
        }
    ],
    "精": [
        {
            "line": "精卫衔微木，将以填沧海",
            "poemId": "poem_49"
        },
        {
            "line": "精卫有冤填瀚海，包胥无泪哭秦庭",
            "poemId": "poem_200"
        }
    ],
    "刑": [
        {
            "line": "刑天舞干戚，猛志固常在",
            "poemId": "poem_49"
        }
    ],
    "徒": [
        {
            "line": "徒设在昔心，良辰讵可待",
            "poemId": "poem_49"
        },
        {
            "line": "徒令上将挥神笔，终见降王走传车",
            "poemId": "poem_456"
        },
        {
            "line": "徒言树桃李，此木岂无阴",
            "poemId": "poem_525"
        }
    ],
    "怀": [
        {
            "line": "怀新道转迥，寻异景不延",
            "poemId": "poem_50"
        },
        {
            "line": "怀君属秋夜，散步咏凉天",
            "poemId": "poem_297"
        }
    ],
    "乱": [
        {
            "line": "乱流趋正绝，孤屿媚中川",
            "poemId": "poem_50"
        },
        {
            "line": "乱条犹未变初黄，倚得东风势便狂",
            "poemId": "poem_113"
        },
        {
            "line": "乱点莓苔多莫数，偶粘衣袖久犹香",
            "poemId": "poem_186"
        },
        {
            "line": "乱山残雪夜，孤烛异乡人",
            "poemId": "poem_416"
        },
        {
            "line": "乱我心者，今日之日多烦忧",
            "poemId": "poem_533"
        }
    ],
    "云": [
        {
            "line": "云日相晖映，空水共澄鲜",
            "poemId": "poem_50"
        },
        {
            "line": "云外一声鸡",
            "poemId": "poem_92"
        },
        {
            "line": "云淡风轻近午天，傍花随柳过前川",
            "poemId": "poem_111"
        },
        {
            "line": "云阶月地依然在，细逐空香百遍行",
            "poemId": "poem_267"
        },
        {
            "line": "云母屏风烛影深，长河渐落晓星沉",
            "poemId": "poem_323"
        },
        {
            "line": "云霞出海曙，梅柳渡江春",
            "poemId": "poem_398"
        },
        {
            "line": "云中君不见，竟夕自悲秋",
            "poemId": "poem_414"
        },
        {
            "line": "云里帝城双凤阙，雨中春树万人家",
            "poemId": "poem_447"
        },
        {
            "line": "云边雁断胡天月，陇上羊归塞草烟",
            "poemId": "poem_484"
        },
        {
            "line": "云开远见汉阳城，犹是孤帆一日程",
            "poemId": "poem_487"
        },
        {
            "line": "云髻罢梳还对镜，罗衣欲换更添香",
            "poemId": "poem_489"
        },
        {
            "line": "云鬓花颜金步摇，芙蓉帐暖度春宵",
            "poemId": "poem_526"
        },
        {
            "line": "云鬓半偏新睡觉，花冠不整下堂来",
            "poemId": "poem_526"
        },
        {
            "line": "云青青兮欲雨，水澹澹兮生烟",
            "poemId": "poem_534"
        },
        {
            "line": "云来气接巫峡长，月出寒通雪山白",
            "poemId": "poem_541"
        },
        {
            "line": "云想衣裳花想容，春风拂槛露华浓",
            "poemId": "poem_568"
        }
    ],
    "表": [
        {
            "line": "表灵物莫赏，蕴真谁为传",
            "poemId": "poem_50"
        },
        {
            "line": "表曰臣愈昧死上，咏神圣功书之碑",
            "poemId": "poem_536"
        }
    ],
    "想": [
        {
            "line": "想象昆山姿，缅邈区中缘",
            "poemId": "poem_50"
        }
    ],
    "始": [
        {
            "line": "始信安期术，得尽养生年",
            "poemId": "poem_50"
        },
        {
            "line": "始知锁向金笼听，不及林间自在啼",
            "poemId": "poem_99"
        }
    ],
    "分": [
        {
            "line": "分散逐风转，此已非常身",
            "poemId": "poem_51"
        },
        {
            "line": "分明旧泊江南岸，舟尾春风飐客灯",
            "poemId": "poem_182"
        }
    ],
    "落": [
        {
            "line": "落地为兄弟，何必骨肉亲",
            "poemId": "poem_51"
        },
        {
            "line": "落木千山天远大，澄江一道月分明",
            "poemId": "poem_138"
        },
        {
            "line": "落红不是无情物，化作春泥更护花",
            "poemId": "poem_269"
        },
        {
            "line": "落魄江南载酒行，楚腰纤细掌中轻",
            "poemId": "poem_329"
        },
        {
            "line": "落叶人何在，寒云路几层",
            "poemId": "poem_383"
        },
        {
            "line": "落叶他乡树，寒灯独夜人",
            "poemId": "poem_413"
        },
        {
            "line": "落月满屋梁，犹疑照颜色",
            "poemId": "poem_501"
        },
        {
            "line": "落月满屋梁，犹疑照颜色",
            "poemId": "poem_501"
        },
        {
            "line": "落帆逗淮镇，停舫临孤驿",
            "poemId": "poem_516"
        },
        {
            "line": "落叶满空山，何处寻行迹",
            "poemId": "poem_519"
        },
        {
            "line": "落落盘踞虽得地，冥冥孤高多烈风",
            "poemId": "poem_541"
        }
    ],
    "得": [
        {
            "line": "得欢当作乐，斗酒聚比邻",
            "poemId": "poem_51"
        }
    ],
    "及": [
        {
            "line": "及时当勉励，岁月不待人",
            "poemId": "poem_51"
        },
        {
            "line": "及兹契幽绝，自足荡心耳",
            "poemId": "poem_508"
        }
    ],
    "摇": [
        {
            "line": "摇荡春风媚春日，念尔零落逐风飚，徒有霜华无霜质",
            "poemId": "poem_52"
        },
        {
            "line": "摇落深知宋玉悲，风流儒雅亦吾师",
            "poemId": "poem_464"
        }
    ],
    "丈": [
        {
            "line": "丈夫生世会几时",
            "poemId": "poem_53"
        },
        {
            "line": "丈夫五十功未立，提刀独立顾八荒",
            "poemId": "poem_156"
        }
    ],
    "弄": [
        {
            "line": "弄儿床前戏，看妇机中织",
            "poemId": "poem_53"
        }
    ],
    "折": [
        {
            "line": "折花逢驿使，寄与陇头人",
            "poemId": "poem_54"
        },
        {
            "line": "折戟沉沙铁未销，自将磨洗认前朝",
            "poemId": "poem_334"
        }
    ],
    "灞": [
        {
            "line": "灞涘望长安，河阳视京县",
            "poemId": "poem_55"
        },
        {
            "line": "灞原风雨定，晚见雁行频",
            "poemId": "poem_413"
        }
    ],
    "余": [
        {
            "line": "余霞散成绮，澄江静如练",
            "poemId": "poem_55"
        },
        {
            "line": "余亦能高咏，斯人不可闻",
            "poemId": "poem_376"
        },
        {
            "line": "余亦谢时去，西山鸾鹤群",
            "poemId": "poem_522"
        }
    ],
    "喧": [
        {
            "line": "喧鸟覆春洲，杂英满芳甸",
            "poemId": "poem_55"
        }
    ],
    "去": [
        {
            "line": "去矣方滞淫，怀哉罢欢宴",
            "poemId": "poem_55"
        },
        {
            "line": "去远即相忘，归近不可忍",
            "poemId": "poem_144"
        },
        {
            "line": "去年花里逢君别，今日花开已一年",
            "poemId": "poem_475"
        },
        {
            "line": "去来江口守空船，绕船月明江水寒",
            "poemId": "poem_529"
        },
        {
            "line": "去时里正与裹头，归来头白还戍边",
            "poemId": "poem_583"
        }
    ],
    "有": [
        {
            "line": "有情知望乡，谁能鬒不变",
            "poemId": "poem_55"
        },
        {
            "line": "有信数寄书，无信心相忆",
            "poemId": "poem_64"
        },
        {
            "line": "有情芍药含春泪，无力蔷薇卧晓枝",
            "poemId": "poem_134"
        },
        {
            "line": "有约不来过夜半，闲敲棋子落灯花",
            "poemId": "poem_179"
        },
        {
            "line": "有弟皆分散，无家问死生",
            "poemId": "poem_393"
        },
        {
            "line": "有酒不饮奈明何",
            "poemId": "poem_554"
        },
        {
            "line": "有耳莫洗颍川水，有口莫食首阳蕨",
            "poemId": "poem_573"
        }
    ],
    "绿": [
        {
            "line": "绿草蔓如丝，杂树红英发",
            "poemId": "poem_56"
        },
        {
            "line": "绿阴不减来时路，添得黄鹂四五声",
            "poemId": "poem_150"
        },
        {
            "line": "绿遍山原白满川，子规声里雨如烟",
            "poemId": "poem_181"
        },
        {
            "line": "绿池芳草满晴波，春色都从雨里过",
            "poemId": "poem_213"
        },
        {
            "line": "绿蚁新醅酒，红泥小火炉",
            "poemId": "poem_285"
        },
        {
            "line": "绿树村边合，青山郭外斜",
            "poemId": "poem_404"
        },
        {
            "line": "绿竹入幽径，青萝拂行衣",
            "poemId": "poem_507"
        }
    ],
    "无": [
        {
            "line": "无论君不归，君归芳已歇",
            "poemId": "poem_56"
        },
        {
            "line": "无田似我犹欣舞，何况田间望岁心",
            "poemId": "poem_149"
        },
        {
            "line": "无端绕屋长松树，尽把风声作雨声",
            "poemId": "poem_215"
        },
        {
            "line": "无限河山泪，谁言天地宽",
            "poemId": "poem_243"
        },
        {
            "line": "无为在歧路，儿女共沾巾",
            "poemId": "poem_354"
        },
        {
            "line": "无才日衰老，驻马望千门",
            "poemId": "poem_392"
        },
        {
            "line": "无人信高洁，谁为表予心",
            "poemId": "poem_436"
        },
        {
            "line": "无边落木萧萧下，不尽长江滚滚来",
            "poemId": "poem_473"
        }
    ],
    "泻": [
        {
            "line": "泻水置平地，各自东西南北流",
            "poemId": "poem_57"
        }
    ],
    "酌": [
        {
            "line": "酌酒以自宽，举杯断绝歌路难",
            "poemId": "poem_57"
        }
    ],
    "吞": [
        {
            "line": "吞声踯躅不敢言",
            "poemId": "poem_57"
        }
    ],
    "沧": [
        {
            "line": "沧流未可源，高帆去何已",
            "poemId": "poem_59"
        },
        {
            "line": "沧海客归珠有泪，章台人去骨遗香",
            "poemId": "poem_89"
        },
        {
            "line": "沧江好烟月，门系钓鱼船",
            "poemId": "poem_396"
        },
        {
            "line": "沧海月明珠有泪，蓝田日暖玉生烟",
            "poemId": "poem_454"
        }
    ],
    "兔": [
        {
            "line": "兔园标物序，惊时最是梅",
            "poemId": "poem_60"
        }
    ],
    "衔": [
        {
            "line": "衔霜当路发，映雪拟寒开",
            "poemId": "poem_60"
        }
    ],
    "枝": [
        {
            "line": "枝横却月观，花绕凌风台",
            "poemId": "poem_60"
        },
        {
            "line": "枝间新绿一重重， 小蕾深藏数点红",
            "poemId": "poem_201"
        }
    ],
    "应": [
        {
            "line": "应知早飘落，故逐上春来",
            "poemId": "poem_60"
        },
        {
            "line": "应是不眠非守岁，小客春意入灯花",
            "poemId": "poem_182"
        },
        {
            "line": "应怜屐齿印苍苔，小扣柴扉久不开",
            "poemId": "poem_183"
        },
        {
            "line": "应共冤魂语，投诗赠汨罗",
            "poemId": "poem_390"
        }
    ],
    "孟": [
        {
            "line": "孟夏草木长，绕屋树扶疏",
            "poemId": "poem_61"
        }
    ],
    " ": [
        {
            "line": " ",
            "poemId": "poem_61"
        },
        {
            "line": " ",
            "poemId": "poem_196"
        },
        {
            "line": " ",
            "poemId": "poem_201"
        },
        {
            "line": "  ",
            "poemId": "poem_528"
        },
        {
            "line": " ",
            "poemId": "poem_565"
        }
    ],
    "零": [
        {
            "line": "零泪向谁道，鸡鸣徒叹息",
            "poemId": "poem_62"
        }
    ],
    "古": [
        {
            "line": "古人云此水，一歃怀千金",
            "poemId": "poem_63"
        },
        {
            "line": "古木阴中系短篷，杖藜扶我过桥东",
            "poemId": "poem_188"
        },
        {
            "line": "古木无人径，深山何处钟",
            "poemId": "poem_369"
        },
        {
            "line": "古台摇落后，秋日望乡心",
            "poemId": "poem_426"
        },
        {
            "line": "古庙杉松巢水鹤，岁时伏腊走村翁",
            "poemId": "poem_461"
        },
        {
            "line": "古来青史谁不见，今见功名胜古人",
            "poemId": "poem_532"
        },
        {
            "line": "古者世称大手笔，此事不系于职司",
            "poemId": "poem_536"
        },
        {
            "line": "古戍苍苍烽火寒，大荒沈沈飞雪白",
            "poemId": "poem_537"
        }
    ],
    "试": [
        {
            "line": "试使夷齐饮，终当不易心",
            "poemId": "poem_63"
        },
        {
            "line": "试说途中景，方知别后心",
            "poemId": "poem_127"
        },
        {
            "line": "试拂铁衣如雪色，聊持宝剑动星文",
            "poemId": "poem_561"
        }
    ],
    "郎": [
        {
            "line": "郎作十里行，侬作九里送",
            "poemId": "poem_64"
        },
        {
            "line": "郎骑竹马来，绕床弄青梅",
            "poemId": "poem_575"
        }
    ],
    "拔": [
        {
            "line": "拔侬头上钗，与郎资路用",
            "poemId": "poem_64"
        },
        {
            "line": "拔来湿苇烧难着，晒在垂杨古岸边",
            "poemId": "poem_254"
        }
    ],
    "莫": [
        {
            "line": "莫作瓶落井，一去无消息",
            "poemId": "poem_64"
        },
        {
            "line": "莫道春来便归去，江南虽好是他乡",
            "poemId": "poem_216"
        },
        {
            "line": "莫将画竹论难易，刚道繁难简更难",
            "poemId": "poem_220"
        },
        {
            "line": "莫唱当年长恨歌，人间亦自有银河",
            "poemId": "poem_272"
        },
        {
            "line": "莫学武陵人，暂游桃源里",
            "poemId": "poem_302"
        },
        {
            "line": "莫买沃洲山，时人已知处",
            "poemId": "poem_312"
        },
        {
            "line": "莫辞更坐弹一曲，为君翻作《琵琶行》",
            "poemId": "poem_529"
        },
        {
            "line": "莫学游侠儿，矜夸紫骝好",
            "poemId": "poem_557"
        },
        {
            "line": "莫嫌旧日云中守，犹堪一战取功勋",
            "poemId": "poem_561"
        }
    ],
    "五": [
        {
            "line": "五两如竹林，何处相寻博",
            "poemId": "poem_64"
        },
        {
            "line": "五月临平山下路，藕花无数满汀州",
            "poemId": "poem_131"
        },
        {
            "line": "五更疏欲断，一树碧无情",
            "poemId": "poem_384"
        },
        {
            "line": "五夜漏声催晓箭，九重春色醉仙桃",
            "poemId": "poem_446"
        },
        {
            "line": "五更鼓角声悲壮，三峡星河影动摇",
            "poemId": "poem_462"
        },
        {
            "line": "五更鼓角声悲壮，三峡星河影动摇",
            "poemId": "poem_462"
        },
        {
            "line": "五陵北原上，万古青濛濛",
            "poemId": "poem_497"
        },
        {
            "line": "五陵年少争缠头，一曲红绡不知数",
            "poemId": "poem_529"
        },
        {
            "line": "五岳寻仙不辞远，一生好入名山游",
            "poemId": "poem_540"
        },
        {
            "line": "五十年间似反掌，风尘倾动昏王室",
            "poemId": "poem_542"
        },
        {
            "line": "五岳祭秩皆三公，四方环镇嵩当中",
            "poemId": "poem_553"
        },
        {
            "line": "五花马，千金裘，呼儿将出换美酒，与尔同销万古愁",
            "poemId": "poem_570"
        },
        {
            "line": "五月不可触，猿声天上哀",
            "poemId": "poem_575"
        },
        {
            "line": "五月西施采，人看隘若耶",
            "poemId": "poem_577"
        }
    ],
    "柳": [
        {
            "line": "柳黄未吐叶，水绿半含苔",
            "poemId": "poem_65"
        },
        {
            "line": "柳梢听得黄鹂语，此是春来第一声",
            "poemId": "poem_206"
        }
    ],
    "春": [
        {
            "line": "春色边城动，客思故乡来",
            "poemId": "poem_65"
        },
        {
            "line": "春蚕不应老，昼夜常怀丝",
            "poemId": "poem_71"
        },
        {
            "line": "春风疑不到天涯，二月山城未见花",
            "poemId": "poem_101"
        },
        {
            "line": "春云浓淡日微光，双阙重门耸建章",
            "poemId": "poem_102"
        },
        {
            "line": "春风又绿江南岸，明月何时照我还",
            "poemId": "poem_106"
        },
        {
            "line": "春色恼人眠不得，月移花影上栏杆",
            "poemId": "poem_107"
        },
        {
            "line": "春宵一刻值千金，花有清香月有阴",
            "poemId": "poem_121"
        },
        {
            "line": "春雨断桥人不度，小舟撑出柳阴来",
            "poemId": "poem_148"
        },
        {
            "line": "春色满园关不住，一枝红杏出墙来",
            "poemId": "poem_183"
        },
        {
            "line": "春草细还生，春雏养渐成",
            "poemId": "poem_209"
        },
        {
            "line": "春风江上路，不觉到君家",
            "poemId": "poem_214"
        },
        {
            "line": "春风一夜到衡阳，楚水燕山万里长",
            "poemId": "poem_216"
        },
        {
            "line": "春去花还在，人来鸟不惊",
            "poemId": "poem_271"
        },
        {
            "line": "春愁难遣强看山，往事惊心泪欲潸",
            "poemId": "poem_274"
        },
        {
            "line": "春草明年绿，王孙归不归",
            "poemId": "poem_284"
        },
        {
            "line": "春眠不觉晓，处处闻啼鸟",
            "poemId": "poem_292"
        },
        {
            "line": "春风十里扬州路，卷上珠帘总不如",
            "poemId": "poem_331"
        },
        {
            "line": "春城无处不飞花，寒食东风御柳斜",
            "poemId": "poem_353"
        },
        {
            "line": "春风对青冢，白日落梁州",
            "poemId": "poem_420"
        },
        {
            "line": "春蚕到死丝方尽，蜡炬成灰泪始干",
            "poemId": "poem_450"
        },
        {
            "line": "春心莫共花争发，一寸相思一寸灰",
            "poemId": "poem_452"
        },
        {
            "line": "春寒赐浴华清池，温泉水滑洗凝脂",
            "poemId": "poem_526"
        },
        {
            "line": "春宵苦短日高起，从此君王不早朝",
            "poemId": "poem_526"
        },
        {
            "line": "春风桃李花开日，秋雨梧桐叶落时",
            "poemId": "poem_526"
        },
        {
            "line": "春江花朝秋月夜，往往取酒还独倾",
            "poemId": "poem_529"
        },
        {
            "line": "春窗曙灭九微火，九微片片飞花琐",
            "poemId": "poem_562"
        },
        {
            "line": "春来遍是桃花水，不辨仙源何处寻",
            "poemId": "poem_564"
        }
    ],
    "鸟": [
        {
            "line": "鸟向檐上飞，云从窗里出",
            "poemId": "poem_66"
        }
    ],
    "只": [
        {
            "line": "只可自怡悦，不堪持赠君",
            "poemId": "poem_67"
        },
        {
            "line": "只为来时晚，花开不及春",
            "poemId": "poem_80"
        },
        {
            "line": "只恐夜深花睡去，故烧高烛照红妆",
            "poemId": "poem_125"
        },
        {
            "line": "只余鸥鹭无拘管，北去南来自在飞",
            "poemId": "poem_184"
        },
        {
            "line": "只在此山中，云深不知处",
            "poemId": "poem_301"
        },
        {
            "line": "只应守寂寞，还掩故园扉",
            "poemId": "poem_402"
        }
    ],
    "艅": [
        {
            "line": "艅艎何泛泛，空水共悠悠",
            "poemId": "poem_68"
        }
    ],
    "阴": [
        {
            "line": "阴霞生远岫，阳景逐回流",
            "poemId": "poem_68"
        },
        {
            "line": "阴阴溪曲绿交加，小雨翻萍上浅沙",
            "poemId": "poem_135"
        }
    ],
    "蝉": [
        {
            "line": "蝉噪林逾静，鸟鸣山更幽",
            "poemId": "poem_68"
        },
        {
            "line": "蝉鸣空桑林，八月萧关道",
            "poemId": "poem_557"
        }
    ],
    "建": [
        {
            "line": "建平督邮道，鱼复永安宫",
            "poemId": "poem_69"
        }
    ],
    "若": [
        {
            "line": "若奏巴渝曲，时当君思中",
            "poemId": "poem_69"
        },
        {
            "line": "若教鲍老当筵舞，转更郎当舞袖长",
            "poemId": "poem_91"
        },
        {
            "line": "若言姑待明朝至，明朝又有明朝事",
            "poemId": "poem_232"
        }
    ],
    "潮": [
        {
            "line": "潮落犹如盖，云昏不作峰",
            "poemId": "poem_70"
        }
    ],
    "远": [
        {
            "line": "远戍唯闻鼓，寒山但见松",
            "poemId": "poem_70"
        },
        {
            "line": "远看山有色，近听水无声",
            "poemId": "poem_271"
        },
        {
            "line": "远芳侵古道，晴翠接荒城",
            "poemId": "poem_370"
        },
        {
            "line": "远送从此别，青山空复情",
            "poemId": "poem_388"
        },
        {
            "line": "远梦归侵晓，家书到隔年",
            "poemId": "poem_396"
        },
        {
            "line": "远路应悲春晼晚，残霄犹得梦依稀",
            "poemId": "poem_457"
        },
        {
            "line": "远树带行客，孤城当落晖",
            "poemId": "poem_495"
        }
    ],
    "九": [
        {
            "line": "九十方称半，归途讵有踪",
            "poemId": "poem_70"
        },
        {
            "line": "九州生气恃风雷，万马齐喑究可哀",
            "poemId": "poem_266"
        },
        {
            "line": "九重城阙烟尘生，千乘万骑西南行",
            "poemId": "poem_526"
        },
        {
            "line": "九月寒砧催木叶，十年征戍忆辽阳",
            "poemId": "poem_593"
        }
    ],
    "玉": [
        {
            "line": "玉关道路远，金陵信使疏",
            "poemId": "poem_72"
        },
        {
            "line": "玉珰缄札何由达，万里云罗一雁飞",
            "poemId": "poem_457"
        },
        {
            "line": "玉玺不缘归日角，锦帆应是到天涯",
            "poemId": "poem_460"
        },
        {
            "line": "玉容寂寞泪阑干，梨花一枝春带雨",
            "poemId": "poem_526"
        },
        {
            "line": "玉花却在御榻上，榻上庭前屹相向",
            "poemId": "poem_544"
        },
        {
            "line": "玉京群帝集北斗，或骑麒麟翳凤凰",
            "poemId": "poem_546"
        },
        {
            "line": "玉颜不及寒鸦色，犹带昭阳日影来",
            "poemId": "poem_563"
        },
        {
            "line": "玉阶生白露，夜久侵罗袜",
            "poemId": "poem_571"
        }
    ],
    "蹀": [
        {
            "line": "蹀座吹长笛，愁杀行客儿",
            "poemId": "poem_73"
        }
    ],
    "腹": [
        {
            "line": "腹中愁不乐，愿作郎马鞭",
            "poemId": "poem_73"
        },
        {
            "line": "腹中贮书一万卷，不肯低头在草莽",
            "poemId": "poem_543"
        }
    ],
    "放": [
        {
            "line": "放马两泉泽，忘不著连羁",
            "poemId": "poem_73"
        }
    ],
    "担": [
        {
            "line": "担鞍逐马走，何见得马骑",
            "poemId": "poem_73"
        }
    ],
    "遥": [
        {
            "line": "遥看孟津河，杨柳郁婆娑",
            "poemId": "poem_73"
        },
        {
            "line": "遥望秦川，心肝断绝",
            "poemId": "poem_78"
        },
        {
            "line": "遥知不是雪，为有暗香来",
            "poemId": "poem_105"
        },
        {
            "line": "遥知朔漠多风雪，更待江南半月春",
            "poemId": "poem_119"
        },
        {
            "line": "遥知兄弟登高处，遍插茱萸少一人",
            "poemId": "poem_310"
        },
        {
            "line": "遥怜小儿女，未解忆长安",
            "poemId": "poem_389"
        },
        {
            "line": "遥夜泛清瑟，西风生翠萝",
            "poemId": "poem_427"
        },
        {
            "line": "遥窥正殿帘开处，袍袴宫人扫御床",
            "poemId": "poem_489"
        },
        {
            "line": "遥见仙人彩云里，手把芙蓉朝玉京",
            "poemId": "poem_540"
        },
        {
            "line": "遥看一处攒云树，近入千家散花竹",
            "poemId": "poem_564"
        }
    ],
    "健": [
        {
            "line": "健儿须快马，快马须健儿",
            "poemId": "poem_73"
        }
    ],
    "跸": [
        {
            "line": "跸跋黄尘下，然后别雄雌",
            "poemId": "poem_73"
        }
    ],
    "战": [
        {
            "line": "战气今如此，从军复几年",
            "poemId": "poem_74"
        },
        {
            "line": "战士军前半死生，美人帐下犹歌舞",
            "poemId": "poem_591"
        }
    ],
    "巫": [
        {
            "line": "巫山七百里，巴水三回曲",
            "poemId": "poem_75"
        },
        {
            "line": "巫峡啼猿数行泪，衡阳归雁几封书",
            "poemId": "poem_482"
        }
    ],
    "笛": [
        {
            "line": "笛声下复高，猿啼断还续",
            "poemId": "poem_75"
        }
    ],
    "敕": [
        {
            "line": "敕勒川，阴山下",
            "poemId": "poem_76"
        }
    ],
    "陇": [
        {
            "line": "陇头流水，流离山下",
            "poemId": "poem_78"
        },
        {
            "line": "陇头流水，鸣声呜咽",
            "poemId": "poem_78"
        }
    ],
    "入": [
        {
            "line": "入春才七日，离家已二年",
            "poemId": "poem_79"
        },
        {
            "line": "入蔡缚贼献太庙，功无与让恩不訾",
            "poemId": "poem_536"
        }
    ],
    "可": [
        {
            "line": "可惜庭中树，移根逐汉臣",
            "poemId": "poem_80"
        },
        {
            "line": "可能无意传双蝶，尽付芳心与蜜房",
            "poemId": "poem_89"
        },
        {
            "line": "可惜不当湖水面，银山堆里看青山",
            "poemId": "poem_129"
        },
        {
            "line": "可怜今夜月，不肯下西厢",
            "poemId": "poem_196"
        },
        {
            "line": "可怜夜半虚前席，不问苍生问鬼神",
            "poemId": "poem_320"
        },
        {
            "line": "可怜无定河边骨，犹是春闺梦里人",
            "poemId": "poem_346"
        },
        {
            "line": "可怜闺里月，长在汉家营",
            "poemId": "poem_407"
        },
        {
            "line": "可怜后主还祠庙，日暮聊为《梁甫吟》",
            "poemId": "poem_466"
        },
        {
            "line": "可以荐嘉客，奈何阻重深",
            "poemId": "poem_525"
        },
        {
            "line": "可怜九马争神骏，顾视清高气深稳",
            "poemId": "poem_547"
        }
    ],
    "马": [
        {
            "line": "马穿山径菊初黄，信马悠悠野兴长",
            "poemId": "poem_82"
        },
        {
            "line": "马蹄踏水乱明霞，醉袖迎风受落花",
            "poemId": "poem_210"
        },
        {
            "line": "马嵬坡下泥土中，不见玉颜空死处",
            "poemId": "poem_526"
        }
    ],
    "万": [
        {
            "line": "万壑有声含晚籁，数峰无语立斜阳",
            "poemId": "poem_82"
        },
        {
            "line": "万里归船弄长笛，此心吾与白鸥盟",
            "poemId": "poem_138"
        },
        {
            "line": "万壑千岩位置雄，偶从天巧见神功",
            "poemId": "poem_199"
        },
        {
            "line": "万金买高爵，何处买青春",
            "poemId": "poem_255"
        },
        {
            "line": "万壑树参天，千山响杜鹃",
            "poemId": "poem_356"
        },
        {
            "line": "万籁此都寂，但余钟磬音",
            "poemId": "poem_418"
        },
        {
            "line": "万籁此俱寂，惟余钟磬音",
            "poemId": "poem_418"
        },
        {
            "line": "万籁此俱寂，但余钟磬音",
            "poemId": "poem_418"
        },
        {
            "line": "万籁此俱寂，但余钟磬音",
            "poemId": "poem_418"
        },
        {
            "line": "万里悲秋常作客，百年多病独登台",
            "poemId": "poem_473"
        }
    ],
    "棠": [
        {
            "line": "棠梨叶落胭脂色，荞麦花开白雪香",
            "poemId": "poem_82"
        }
    ],
    "晓": [
        {
            "line": "晓带轻烟间杏花，晚凝深翠拂平沙",
            "poemId": "poem_83"
        },
        {
            "line": "晓随天仗入，暮惹御香归",
            "poemId": "poem_380"
        },
        {
            "line": "晓镜但愁云鬓改，夜吟应觉月光寒",
            "poemId": "poem_450"
        }
    ],
    "鸣": [
        {
            "line": "鸣骹直上一千尺，天静无风声更干",
            "poemId": "poem_84"
        },
        {
            "line": "鸣筝金粟柱，素手玉房前",
            "poemId": "poem_288"
        }
    ],
    "碧": [
        {
            "line": "碧眼胡儿三百骑，尽提金勒向云看",
            "poemId": "poem_84"
        },
        {
            "line": "碧水丹山映杖藜，夕阳犹在小桥西",
            "poemId": "poem_219"
        },
        {
            "line": "碧阑干外绣帘垂，猩血屏风画折枝",
            "poemId": "poem_368"
        }
    ],
    "两": [
        {
            "line": "两株桃杏映篱斜，妆点商州副使家",
            "poemId": "poem_85"
        },
        {
            "line": "两两归鸿欲破群，依依还似北归人",
            "poemId": "poem_119"
        },
        {
            "line": "两岸舟船各背驰，波痕交涉亦难为",
            "poemId": "poem_184"
        },
        {
            "line": "两岸猿声啼不住，轻舟已过万重山",
            "poemId": "poem_317"
        }
    ],
    "和": [
        {
            "line": "和莺吹折数枝花",
            "poemId": "poem_85"
        },
        {
            "line": "和雨还穿户，经风忽过墙",
            "poemId": "poem_250"
        }
    ],
    "岸": [
        {
            "line": "岸阔樯稀波渺茫，独凭危槛思何长",
            "poemId": "poem_86"
        },
        {
            "line": "岸蓼疏红水荇青，茨菰花白小如蓱",
            "poemId": "poem_227"
        }
    ],
    "众": [
        {
            "line": "众芳摇落独暄妍，占尽风情向小园",
            "poemId": "poem_88"
        }
    ],
    "疏": [
        {
            "line": "疏影横斜水清浅，暗香浮动月黄昏",
            "poemId": "poem_88"
        },
        {
            "line": "疏松影落空坛静，细草香闲小洞幽",
            "poemId": "poem_490"
        }
    ],
    "霜": [
        {
            "line": "霜禽欲下先偷眼，粉蝶如知合断魂",
            "poemId": "poem_88"
        },
        {
            "line": "霜落熊升树，林空鹿饮溪",
            "poemId": "poem_92"
        },
        {
            "line": "霜皮溜雨四十围，黛色参天二千尺",
            "poemId": "poem_541"
        },
        {
            "line": "霜蹄蹴踏长楸间，马官厮养森成列",
            "poemId": "poem_547"
        }
    ],
    "坠": [
        {
            "line": "坠素翻红各自伤，青楼烟雨忍相忘",
            "poemId": "poem_89"
        }
    ],
    "将": [
        {
            "line": "将飞更作回风舞，已落犹成半面妆",
            "poemId": "poem_89"
        },
        {
            "line": "将家就鱼麦，归老江湖边",
            "poemId": "poem_502"
        },
        {
            "line": "将军角弓不得控，都护铁衣冷难着",
            "poemId": "poem_530"
        },
        {
            "line": "将军魏武之子孙，于今为庶为清门",
            "poemId": "poem_544"
        },
        {
            "line": "将军画善盖有神，必逢佳士亦写真",
            "poemId": "poem_544"
        },
        {
            "line": "将军得名三十载，人间又见真乘黄",
            "poemId": "poem_547"
        }
    ],
    "枕": [
        {
            "line": "枕中云气千峰近，床底松声万壑哀",
            "poemId": "poem_90"
        }
    ],
    "要": [
        {
            "line": "要看银山拍天浪，开窗放入大江来",
            "poemId": "poem_90"
        }
    ],
    "鲍": [
        {
            "line": "鲍老当筵笑郭郎，笑他舞袖太郎当",
            "poemId": "poem_91"
        }
    ],
    "适": [
        {
            "line": "适与野情惬，千山高复低",
            "poemId": "poem_92"
        }
    ],
    "好": [
        {
            "line": "好峰随处改，幽径独行迷",
            "poemId": "poem_92"
        },
        {
            "line": "好水好山看不足，马蹄催趁月明归",
            "poemId": "poem_153"
        },
        {
            "line": "好是日斜风定后，半江红树卖鲈鱼",
            "poemId": "poem_245"
        },
        {
            "line": "好是日斜风定后，半江红树卖鲈鱼",
            "poemId": "poem_246"
        },
        {
            "line": "好为庐山谣，兴因庐山发",
            "poemId": "poem_540"
        }
    ],
    "野": [
        {
            "line": "野凫眠岸有闲意，老树着花无丑枝",
            "poemId": "poem_93"
        },
        {
            "line": "野田春水碧于镜，人影渡傍鸥不惊",
            "poemId": "poem_142"
        },
        {
            "line": "野店桃花红粉姿，陌头杨柳绿烟丝",
            "poemId": "poem_203"
        },
        {
            "line": "野旷天低树，江清月近人",
            "poemId": "poem_296"
        },
        {
            "line": "野火烧不尽，春风吹又生",
            "poemId": "poem_370"
        },
        {
            "line": "野寺人来少，云峰水隔深",
            "poemId": "poem_426"
        },
        {
            "line": "野老与人争席罢，海鸥何事更相疑",
            "poemId": "poem_443"
        },
        {
            "line": "野哭几家闻战伐，夷歌数处起渔樵",
            "poemId": "poem_462"
        },
        {
            "line": "野哭千家闻战伐，夷歌数处起渔樵",
            "poemId": "poem_462"
        },
        {
            "line": "野云万里无城郭，雨雪纷纷连大漠",
            "poemId": "poem_584"
        },
        {
            "line": "野幕敞琼筵，羌戎贺劳旋",
            "poemId": "poem_597"
        }
    ],
    "短": [
        {
            "line": "短短蒲耳齐似剪，平平沙石净于筛",
            "poemId": "poem_93"
        }
    ],
    "情": [
        {
            "line": "情虽不厌住不得，薄暮归来车马疲",
            "poemId": "poem_93"
        },
        {
            "line": "情知非江湖，梦寐亦风浪",
            "poemId": "poem_258"
        },
        {
            "line": "情人怨遥夜，竟夕起相思",
            "poemId": "poem_419"
        }
    ],
    "陶": [
        {
            "line": "陶尽门前土，屋上无片瓦",
            "poemId": "poem_94"
        }
    ],
    "红": [
        {
            "line": "红树青山日欲斜，长郊草色绿无涯",
            "poemId": "poem_95"
        },
        {
            "line": "红豆生南国，春来发几枝",
            "poemId": "poem_283"
        },
        {
            "line": "红颜弃轩冕，白首卧松云",
            "poemId": "poem_377"
        },
        {
            "line": "红叶晚萧萧，长亭酒一瓢",
            "poemId": "poem_423"
        },
        {
            "line": "红楼隔雨相望冷，珠箔飘灯独自归",
            "poemId": "poem_457"
        }
    ],
    "游": [
        {
            "line": "游人不管春将老，来往亭前踏落花",
            "poemId": "poem_95"
        },
        {
            "line": "游子春衫已试单，桃花飞尽野梅酸",
            "poemId": "poem_143"
        }
    ],
    "卧": [
        {
            "line": "卧闻岳阳城里钟，系舟岳阳城下树",
            "poemId": "poem_96"
        },
        {
            "line": "卧看满天云不动，不知云与我俱东",
            "poemId": "poem_151"
        },
        {
            "line": "卧看 一作：坐看)",
            "poemId": "poem_332"
        },
        {
            "line": "卧龙跃马终黄土，人事依依漫寂寥",
            "poemId": "poem_462"
        },
        {
            "line": "卧龙跃马终黄土，人事音书漫寂寥",
            "poemId": "poem_462"
        }
    ],
    "正": [
        {
            "line": "正见空江明月来，云水苍茫失江路",
            "poemId": "poem_96"
        }
    ],
    "帘": [
        {
            "line": "帘虚日薄花竹静，时有乳鸠相对鸣",
            "poemId": "poem_97"
        }
    ],
    "昨": [
        {
            "line": "昨日入城市，归来泪满巾",
            "poemId": "poem_100"
        },
        {
            "line": "昨夜裙带解，今朝蟢子飞",
            "poemId": "poem_306"
        },
        {
            "line": "昨夜风开露井桃，未央前殿月轮高",
            "poemId": "poem_309"
        },
        {
            "line": "昨夜星辰昨夜风，画楼西畔桂堂东",
            "poemId": "poem_455"
        },
        {
            "line": "昨别今已春，鬓丝生几缕",
            "poemId": "poem_514"
        },
        {
            "line": "昨者州前捶大鼓，嗣皇继圣登夔皋",
            "poemId": "poem_554"
        },
        {
            "line": "昨夜东风吹血腥，东来橐驼满旧都",
            "poemId": "poem_585"
        }
    ],
    "遍": [
        {
            "line": "遍身罗绮者，不是养蚕人",
            "poemId": "poem_100"
        },
        {
            "line": "遍地关山行不得，为谁辛苦尽情啼",
            "poemId": "poem_241"
        }
    ],
    "残": [
        {
            "line": "残雪压枝犹有桔，冻雷惊笋欲抽芽",
            "poemId": "poem_101"
        },
        {
            "line": "残雪未融青草死，苦无麋鹿过姑苏",
            "poemId": "poem_182"
        },
        {
            "line": "残阳西入崦，茅屋访孤僧",
            "poemId": "poem_383"
        },
        {
            "line": "残云归太华，疏雨过中条",
            "poemId": "poem_423"
        },
        {
            "line": "残萤栖玉露，早雁拂金河",
            "poemId": "poem_427"
        }
    ],
    "爆": [
        {
            "line": "爆竹声中一岁除，春风送暖入屠苏",
            "poemId": "poem_103"
        }
    ],
    "千": [
        {
            "line": "千门万户曈曈日，总把新桃换旧符",
            "poemId": "poem_103"
        },
        {
            "line": "千里稻花应秀色，五更桐叶最佳音",
            "poemId": "poem_149"
        },
        {
            "line": "千年史册耻无名，一片丹心报天子",
            "poemId": "poem_156"
        },
        {
            "line": "千门列炬散林鸦，儿女相思未到家",
            "poemId": "poem_182"
        },
        {
            "line": "千锤万凿出深山，烈火焚烧若等闲",
            "poemId": "poem_218"
        },
        {
            "line": "千磨万击还坚劲，任尔东西南北风",
            "poemId": "poem_251"
        },
        {
            "line": "千层石树遥行路，一带山田放水声",
            "poemId": "poem_265"
        },
        {
            "line": "千山鸟飞绝，万径人踪灭",
            "poemId": "poem_295"
        },
        {
            "line": "千寻铁锁沉江底，一片降幡出石头",
            "poemId": "poem_483"
        },
        {
            "line": "千里共如何，微风吹兰杜",
            "poemId": "poem_492"
        },
        {
            "line": "千秋万岁名，寂寞身后事",
            "poemId": "poem_503"
        },
        {
            "line": "千呼万唤始出来，犹抱琵琶半遮面",
            "poemId": "poem_529"
        },
        {
            "line": "千岩万转路不定，迷花倚石忽已暝",
            "poemId": "poem_534"
        }
    ],
    "飞": [
        {
            "line": "飞来山上千寻塔，闻说鸡鸣见日升",
            "poemId": "poem_104"
        },
        {
            "line": "飞花两岸照船红，百里榆堤半日风",
            "poemId": "poem_151"
        },
        {
            "line": "飞鸟没何处，青山空向人",
            "poemId": "poem_429"
        },
        {
            "line": "飞沈理自隔，何所慰吾诚?",
            "poemId": "poem_527"
        },
        {
            "line": "飞湍瀑流争喧豗，砯崖转石万壑雷",
            "poemId": "poem_576"
        }
    ],
    "墙": [
        {
            "line": "墙角数枝梅，凌寒独自开",
            "poemId": "poem_105"
        },
        {
            "line": "墙头语鹊衣犹湿，楼外残雷气未平",
            "poemId": "poem_157"
        }
    ],
    "京": [
        {
            "line": "京口瓜洲一水间，钟山只隔数重山",
            "poemId": "poem_106"
        },
        {
            "line": "京华结交尽奇士，意气相期共生死",
            "poemId": "poem_156"
        }
    ],
    "花": [
        {
            "line": "花光浓烂柳轻明，酌酒花前送我行",
            "poemId": "poem_108"
        },
        {
            "line": "花开不并百花丛，独立疏篱趣未穷",
            "poemId": "poem_194"
        },
        {
            "line": "花开红树乱莺啼，草长平湖白鹭飞",
            "poemId": "poem_207"
        },
        {
            "line": "花隐掖垣暮，啾啾栖鸟过",
            "poemId": "poem_399"
        },
        {
            "line": "花迎剑珮星初落，柳拂旌旗露未干",
            "poemId": "poem_445"
        },
        {
            "line": "花近高楼伤客心，万方多难此登临",
            "poemId": "poem_466"
        },
        {
            "line": "花径不曾缘客扫，蓬门今始为君开",
            "poemId": "poem_472"
        },
        {
            "line": "花间一壶酒，独酌无相亲",
            "poemId": "poem_498"
        },
        {
            "line": "花钿委地无人收，翠翘金雀玉搔头",
            "poemId": "poem_526"
        },
        {
            "line": "花门剺面请雪耻，慎勿出口他人狙",
            "poemId": "poem_585"
        }
    ],
    "已": [
        {
            "line": "已恨碧山相阻隔，碧山还被暮云遮",
            "poemId": "poem_109"
        },
        {
            "line": "已拚新年舟上过，倩人和雪洗片衣",
            "poemId": "poem_182"
        },
        {
            "line": "已似长沙傅，从今又几年",
            "poemId": "poem_422"
        },
        {
            "line": "已忍伶俜十年事，强移栖息一枝安",
            "poemId": "poem_463"
        },
        {
            "line": "已经百日窜荆棘，身上无有完肌肤",
            "poemId": "poem_585"
        }
    ],
    "夕": [
        {
            "line": "夕阳牛背无人卧，带得寒鸦两两归",
            "poemId": "poem_112"
        },
        {
            "line": "夕阳无限好，只是近黄昏",
            "poemId": "poem_289"
        },
        {
            "line": "夕阳依旧垒，寒磬满空林",
            "poemId": "poem_426"
        },
        {
            "line": "夕阳度西岭，群壑倏已暝",
            "poemId": "poem_512"
        },
        {
            "line": "夕殿萤飞思悄然，孤灯挑尽未成眠",
            "poemId": "poem_526"
        }
    ],
    "解": [
        {
            "line": "解把飞花蒙日月，不知天地有清霜",
            "poemId": "poem_113"
        },
        {
            "line": "解识幽人意，请今聊处囊",
            "poemId": "poem_250"
        },
        {
            "line": "解释春风无限恨，沉香亭北倚栏杆",
            "poemId": "poem_565"
        }
    ],
    "雨": [
        {
            "line": "雨过横塘水满堤，乱山高下路东西",
            "poemId": "poem_115"
        },
        {
            "line": "雨雪自飞千嶂外，榆林只隔数峰西",
            "poemId": "poem_244"
        },
        {
            "line": "雨中黄叶树，灯下白头人",
            "poemId": "poem_372"
        },
        {
            "line": "雨淋日灸野火燎，鬼物守护烦撝呵",
            "poemId": "poem_551"
        }
    ],
    "清": [
        {
            "line": "清风无力屠得热，落日着翅飞上山",
            "poemId": "poem_116"
        },
        {
            "line": "清风明月无人管，并作南楼一味凉",
            "poemId": "poem_140"
        },
        {
            "line": "清时有味是无能，闲爱孤云静爱僧",
            "poemId": "poem_333"
        },
        {
            "line": "清川带长薄，车马去闲闲",
            "poemId": "poem_365"
        },
        {
            "line": "清瑟怨遥夜，绕弦风雨哀",
            "poemId": "poem_409"
        },
        {
            "line": "清晨入古寺，初日照高林",
            "poemId": "poem_418"
        },
        {
            "line": "清秋幕府井梧寒，独宿江城蜡炬残",
            "poemId": "poem_463"
        },
        {
            "line": "清辉澹水木，演漾在窗户",
            "poemId": "poem_492"
        },
        {
            "line": "清溪深不测，隐处唯孤云",
            "poemId": "poem_522"
        },
        {
            "line": "清淮奉使千馀里，敢告云山从此始",
            "poemId": "poem_539"
        },
        {
            "line": "清渭东流剑阁深，去住彼此无消息",
            "poemId": "poem_587"
        }
    ],
    "昆": [
        {
            "line": "昆仑之高有积雪，蓬莱之远常遗寒",
            "poemId": "poem_116"
        }
    ],
    "子": [
        {
            "line": "子规夜半犹啼血，不信东风唤不回",
            "poemId": "poem_118"
        },
        {
            "line": "子胥既弃吴江上，屈原终投湘水滨",
            "poemId": "poem_573"
        }
    ],
    "竹": [
        {
            "line": "竹外桃花三两枝，春江水暖鸭先知",
            "poemId": "poem_119"
        },
        {
            "line": "竹影和诗瘦，梅花入梦香",
            "poemId": "poem_196"
        },
        {
            "line": "竹喧归浣女，莲动下渔舟",
            "poemId": "poem_364"
        },
        {
            "line": "竹径通幽处，禅房花木深",
            "poemId": "poem_418"
        },
        {
            "line": "竹径通幽处，禅房花木深",
            "poemId": "poem_418"
        },
        {
            "line": "竹怜新雨后，山爱夕阳时",
            "poemId": "poem_434"
        }
    ],
    "蒌": [
        {
            "line": "蒌蒿满地芦芽短，正是河豚欲上时",
            "poemId": "poem_119"
        }
    ],
    "泥": [
        {
            "line": "泥上偶然留指爪，鸿飞那复计东西",
            "poemId": "poem_120"
        }
    ],
    "老": [
        {
            "line": "老僧已死成新塔，坏壁无由见旧题",
            "poemId": "poem_120"
        },
        {
            "line": "老牛粗了耕耘债，啮草坡头卧夕阳",
            "poemId": "poem_126"
        },
        {
            "line": "老至居人下，春归在客先",
            "poemId": "poem_422"
        },
        {
            "line": "老夫不知其所往，足茧荒山转愁疾",
            "poemId": "poem_542"
        }
    ],
    "往": [
        {
            "line": "往日崎岖还记否，路长人困蹇驴嘶",
            "poemId": "poem_120"
        }
    ],
    "歌": [
        {
            "line": "歌管楼台声细细，秋千院落夜沉沉",
            "poemId": "poem_121"
        }
    ],
    "横": [
        {
            "line": "横看成岭侧成峰，远近高低各不同",
            "poemId": "poem_123"
        }
    ],
    "荷": [
        {
            "line": "荷尽已无擎雨盖，菊残犹有傲霜枝",
            "poemId": "poem_124"
        },
        {
            "line": "荷笠带斜阳，青山独归远",
            "poemId": "poem_303"
        },
        {
            "line": "荷风送香气，竹露滴清响",
            "poemId": "poem_511"
        }
    ],
    "骑": [
        {
            "line": "骑牛远远过前村，短笛横吹隔陇闻",
            "poemId": "poem_128"
        }
    ],
    "多": [
        {
            "line": "多少长安名利客，机关用尽不如君",
            "poemId": "poem_128"
        },
        {
            "line": "多缘刺史无坚约，岂视萧郎作路人",
            "poemId": "poem_267"
        },
        {
            "line": "多情却似总无情，唯觉樽前笑不成",
            "poemId": "poem_331"
        },
        {
            "line": "多情却似总无情，唯觉樽前笑不成",
            "poemId": "poem_337"
        },
        {
            "line": "多情只有春庭月，犹为离人照落花",
            "poemId": "poem_341"
        },
        {
            "line": "多歧路，今安在",
            "poemId": "poem_566"
        }
    ],
    "未": [
        {
            "line": "未到江南先一笑，岳阳楼上对君山",
            "poemId": "poem_129"
        },
        {
            "line": "未谙姑食性，先遣小姑尝",
            "poemId": "poem_282"
        },
        {
            "line": "未必逢矰缴，孤飞自可疑",
            "poemId": "poem_417"
        }
    ],
    "满": [
        {
            "line": "满川风雨独凭栏，绾结湘娥十二鬟",
            "poemId": "poem_129"
        }
    ],
    "庭": [
        {
            "line": "庭户无人秋月明，夜霜欲落气先清",
            "poemId": "poem_130"
        }
    ],
    "梧": [
        {
            "line": "梧桐真不甘衰谢，数叶迎风尚有声",
            "poemId": "poem_130"
        },
        {
            "line": "梧桐相待老，鸳鸯会双死",
            "poemId": "poem_590"
        }
    ],
    "如": [
        {
            "line": "如丝苣甲饤春盘，韭叶金黄雪未干",
            "poemId": "poem_132"
        },
        {
            "line": "如何十二金人外，犹有人间铁未销",
            "poemId": "poem_208"
        }
    ],
    "旅": [
        {
            "line": "旅饭二年无此味，故园千里几时还",
            "poemId": "poem_132"
        },
        {
            "line": "旅馆无良伴，凝情自悄然",
            "poemId": "poem_396"
        }
    ],
    "异": [
        {
            "line": "异方时节三巵酒，残岁风烟一惨颜",
            "poemId": "poem_132"
        }
    ],
    "携": [
        {
            "line": "携扙来追柳外凉，画桥南畔倚胡床",
            "poemId": "poem_133"
        }
    ],
    "月": [
        {
            "line": "月明船笛参差起，风定池莲自在香",
            "poemId": "poem_133"
        },
        {
            "line": "月儿弯弯照九州，几家欢乐几家愁",
            "poemId": "poem_202"
        },
        {
            "line": "月黑见渔灯，孤光一点萤",
            "poemId": "poem_248"
        },
        {
            "line": "月在众峰顶，泉流乱叶中",
            "poemId": "poem_253"
        },
        {
            "line": "月落乌啼霜满天，江枫渔火对愁眠",
            "poemId": "poem_350"
        },
        {
            "line": "月下飞天镜，云生结海楼",
            "poemId": "poem_378"
        },
        {
            "line": "月既不解饮，影徒随我身",
            "poemId": "poem_498"
        },
        {
            "line": "月照城头乌半飞，霜凄万树风入衣",
            "poemId": "poem_539"
        },
        {
            "line": "月明松下房栊静，日出云中鸡犬喧",
            "poemId": "poem_564"
        },
        {
            "line": "月黑雁飞高，单于夜遁逃",
            "poemId": "poem_596"
        }
    ],
    "鹅": [
        {
            "line": "鹅鸭不知春去尽，争随流水趁桃花",
            "poemId": "poem_135"
        }
    ],
    "过": [
        {
            "line": "过尽行人都不起，忽闻水响一齐飞",
            "poemId": "poem_136"
        }
    ],
    "断": [
        {
            "line": "断墙着雨蜗成字，老屋无僧燕作家，剩欲出门追语笑，却嫌归鬓著尘沙",
            "poemId": "poem_137"
        }
    ],
    "屡": [
        {
            "line": "屡失南邻春事约，只今容有未开花",
            "poemId": "poem_137"
        }
    ],
    "痴": [
        {
            "line": "痴儿了却公家事，快阁东西倚晚晴",
            "poemId": "poem_138"
        }
    ],
    "朱": [
        {
            "line": "朱弦已为佳人绝，青眼聊因美酒横",
            "poemId": "poem_138"
        },
        {
            "line": "朱雀桥边野草花，乌衣巷口夕阳斜",
            "poemId": "poem_349"
        }
    ],
    "连": [
        {
            "line": "连理枝头花正开，妒花风雨便相催",
            "poemId": "poem_139"
        },
        {
            "line": "连山若波涛，奔凑似朝东",
            "poemId": "poem_497"
        },
        {
            "line": "连峰去天不盈尺，枯松倒挂倚绝壁",
            "poemId": "poem_576"
        }
    ],
    "女": [
        {
            "line": "女子弄文诚可罪，那堪咏月更吟风",
            "poemId": "poem_141"
        },
        {
            "line": "女子今有行，大江溯轻舟",
            "poemId": "poem_515"
        }
    ],
    "磨": [
        {
            "line": "磨穿铁砚非吾事，绣折金针却有功",
            "poemId": "poem_141"
        },
        {
            "line": "磨牙吮血，杀人如麻",
            "poemId": "poem_576"
        }
    ],
    "闷": [
        {
            "line": "闷无消遣只看诗，不见诗中话别离",
            "poemId": "poem_141"
        }
    ],
    "添": [
        {
            "line": "添得情怀转萧索，始知伶俐不如痴",
            "poemId": "poem_141"
        }
    ],
    "茅": [
        {
            "line": "茅茨烟暝客衣湿，破梦午鸡啼一声",
            "poemId": "poem_142"
        }
    ],
    "怪": [
        {
            "line": "怪来一夜蛙声歇，又作东风十日寒",
            "poemId": "poem_143"
        },
        {
            "line": "怪生无雨都张伞，不是遮头是使风",
            "poemId": "poem_171"
        },
        {
            "line": "怪见溪童出门望，雀声先我到山家",
            "poemId": "poem_210"
        }
    ],
    "儿": [
        {
            "line": "儿女已在眼，眉目略不省",
            "poemId": "poem_144"
        },
        {
            "line": "儿女不知来避地，强言风物胜江南",
            "poemId": "poem_147"
        },
        {
            "line": "儿童急走追黄蝶，飞入菜花无处寻",
            "poemId": "poem_172"
        },
        {
            "line": "儿童散学归来早，忙趁东风放纸鸢",
            "poemId": "poem_270"
        }
    ],
    "喜": [
        {
            "line": "喜极不得语，泪尽方一哂",
            "poemId": "poem_144"
        }
    ],
    "了": [
        {
            "line": "了知不是梦，忽忽心未稳",
            "poemId": "poem_144"
        }
    ],
    "至": [
        {
            "line": "至今思项羽，不肯过江东",
            "poemId": "poem_145"
        },
        {
            "line": "至今窥牧马，不敢过临洮",
            "poemId": "poem_307"
        },
        {
            "line": "至今残破胆，应有未招魂",
            "poemId": "poem_392"
        },
        {
            "line": "至尊含笑催赐金，圉人太仆皆惆怅",
            "poemId": "poem_544"
        }
    ],
    "辇": [
        {
            "line": "辇毂繁华事可伤，师师垂老过湖湘",
            "poemId": "poem_146"
        },
        {
            "line": "辇前才人带弓箭，白马嚼啮黄金勒",
            "poemId": "poem_587"
        }
    ],
    "缕": [
        {
            "line": "缕衣檀板无颜色，一曲当时动帝王",
            "poemId": "poem_146"
        }
    ],
    "稍": [
        {
            "line": "稍离烟瘴近湘潭，疾病衰颓已不堪",
            "poemId": "poem_147"
        }
    ],
    "双": [
        {
            "line": "双飞燕子几时回",
            "poemId": "poem_148"
        },
        {
            "line": "双鬟短袖惭人见，背立船头自采菱",
            "poemId": "poem_227"
        }
    ],
    "夹": [
        {
            "line": "夹岸桃花蘸水开",
            "poemId": "poem_148"
        }
    ],
    "苏": [
        {
            "line": "苏秀道中，自七月二十五日夜大雨三日，秋苗以苏，喜而有作",
            "poemId": "poem_149"
        },
        {
            "line": "苏武魂销汉使前，古祠高树两茫然",
            "poemId": "poem_484"
        }
    ],
    "梅": [
        {
            "line": "梅子黄时日日晴，小溪泛尽却山行",
            "poemId": "poem_150"
        },
        {
            "line": "梅雪争春未肯降，骚人搁笔费评章",
            "poemId": "poem_195"
        },
        {
            "line": "梅须逊雪三分白，雪却输梅一段香",
            "poemId": "poem_195"
        }
    ],
    "经": [
        {
            "line": "经年尘土满征衣，特特寻芳上翠微",
            "poemId": "poem_153"
        }
    ],
    "小": [
        {
            "line": "小楼一夜听春雨，深巷明朝卖杏花",
            "poemId": "poem_154"
        },
        {
            "line": "小荷才露尖尖角，早有蜻蜓立上头",
            "poemId": "poem_166"
        },
        {
            "line": "小桃无主自开花，烟草茫茫带晚鸦",
            "poemId": "poem_193"
        }
    ],
    "矮": [
        {
            "line": "矮纸斜行闲作草，晴窗细乳戏分茶",
            "poemId": "poem_154"
        }
    ],
    "归": [
        {
            "line": "归来涧底磨刀斧，又作全家明日谋",
            "poemId": "poem_155"
        },
        {
            "line": "归路畏逢虎，况闻岩下风",
            "poemId": "poem_253"
        },
        {
            "line": "归山深浅去，须尽丘壑美",
            "poemId": "poem_302"
        },
        {
            "line": "归雁洛阳边",
            "poemId": "poem_367"
        },
        {
            "line": "归来视幼女，零泪缘缨流",
            "poemId": "poem_515"
        },
        {
            "line": "归棹洛阳人，残钟广陵树",
            "poemId": "poem_520"
        },
        {
            "line": "归来池苑皆依旧，太液芙蓉未央柳",
            "poemId": "poem_526"
        }
    ],
    "黄": [
        {
            "line": "黄金错刀白玉装，夜穿窗扉出光芒",
            "poemId": "poem_156"
        },
        {
            "line": "黄梅时节家家雨，青草池塘处处蛙",
            "poemId": "poem_179"
        },
        {
            "line": "黄莺也爱新凉好，飞过青山影里啼",
            "poemId": "poem_180"
        },
        {
            "line": "黄帽传呼睡不成，投稿细细激流冰",
            "poemId": "poem_182"
        },
        {
            "line": "黄花古渡接芦溪，行过萍乡路渐低",
            "poemId": "poem_247"
        },
        {
            "line": "黄叶仍风雨，青楼自管弦",
            "poemId": "poem_385"
        },
        {
            "line": "黄金燃桂尽，壮志逐年衰",
            "poemId": "poem_405"
        },
        {
            "line": "黄鹤一去不复返，白云千载空悠悠",
            "poemId": "poem_478"
        },
        {
            "line": "黄埃散漫风萧索，云栈萦纡登剑阁",
            "poemId": "poem_526"
        },
        {
            "line": "黄云万里动风色，白波九道流雪山",
            "poemId": "poem_540"
        },
        {
            "line": "黄云陇底白云飞，未得报恩不能归",
            "poemId": "poem_545"
        },
        {
            "line": "黄河远上白云间，一片孤城万仞山",
            "poemId": "poem_555"
        },
        {
            "line": "黄尘足今古，白骨乱蓬蒿",
            "poemId": "poem_558"
        },
        {
            "line": "黄鹤之飞尚不得过，猿猱欲度愁攀援",
            "poemId": "poem_576"
        },
        {
            "line": "黄门飞鞚不动尘，御厨络绎送八珍",
            "poemId": "poem_586"
        },
        {
            "line": "黄昏胡骑尘满城，欲往城南望城北",
            "poemId": "poem_587"
        }
    ],
    "尔": [
        {
            "line": "尔来从军天汉滨，南山晓雪玉嶙峋",
            "poemId": "poem_156"
        },
        {
            "line": "尔辈苦无恃，抚念益慈柔",
            "poemId": "poem_515"
        },
        {
            "line": "尔来四万八千岁，不与秦塞通人烟",
            "poemId": "poem_576"
        }
    ],
    "呜": [
        {
            "line": "呜呼",
            "poemId": "poem_156"
        },
        {
            "line": "呜呼圣王及圣相，相与烜赫流淳熙",
            "poemId": "poem_536"
        }
    ],
    "楚": [
        {
            "line": "楚虽三户能亡秦，岂有堂堂中国空无人",
            "poemId": "poem_156"
        },
        {
            "line": "楚塞三湘接，荆门九派通",
            "poemId": "poem_358"
        },
        {
            "line": "楚江微雨里，建业暮钟时",
            "poemId": "poem_411"
        }
    ],
    "尽": [
        {
            "line": "尽取微凉供稳睡，急搜奇句报新晴",
            "poemId": "poem_157"
        }
    ],
    "耕": [
        {
            "line": "耕犁千亩实千箱，力尽筋疲谁复伤",
            "poemId": "poem_158"
        }
    ],
    "细": [
        {
            "line": "细雨骑驴入剑门",
            "poemId": "poem_159"
        },
        {
            "line": "细雨茸茸湿楝花，南风树树熟枇杷",
            "poemId": "poem_212"
        },
        {
            "line": "细草微风岸，危樯独夜舟",
            "poemId": "poem_391"
        }
    ],
    "闻": [
        {
            "line": "闻道梅花坼晓风，雪堆遍满四山中",
            "poemId": "poem_160"
        },
        {
            "line": "闻道黄龙戍，频年不解兵",
            "poemId": "poem_407"
        },
        {
            "line": "闻道欲来相问讯，西楼望月几回圆",
            "poemId": "poem_475"
        },
        {
            "line": "闻道汉家天子使，九华帐里梦魂惊",
            "poemId": "poem_526"
        },
        {
            "line": "闻道故林相识多，罢官昨日今如何",
            "poemId": "poem_543"
        },
        {
            "line": "闻道玉门犹被遮，应将性命逐轻车",
            "poemId": "poem_584"
        }
    ],
    "死": [
        {
            "line": "死去元知万事空，但悲不见九州同",
            "poemId": "poem_161"
        },
        {
            "line": "死别已吞声，生别常恻恻",
            "poemId": "poem_501"
        }
    ],
    "王": [
        {
            "line": "王师北定中原日，家祭无忘告乃翁",
            "poemId": "poem_161"
        },
        {
            "line": "王濬楼船下益州，金陵王气黯然收",
            "poemId": "poem_483"
        }
    ],
    "溪": [
        {
            "line": "溪柴火软蛮毡暖，我与狸奴不出门",
            "poemId": "poem_162"
        },
        {
            "line": "溪水将桥不复回，小舟犹倚短篙开",
            "poemId": "poem_170"
        },
        {
            "line": "溪花与禅意，相对亦忘言",
            "poemId": "poem_424"
        }
    ],
    "僵": [
        {
            "line": "僵卧孤村不自哀，尚思为国戍轮台",
            "poemId": "poem_162"
        }
    ],
    "早": [
        {
            "line": "早岁那知世事艰，中原北望气如山",
            "poemId": "poem_163"
        },
        {
            "line": "早早开门拜闯王，管教大小都欢悦",
            "poemId": "poem_237"
        },
        {
            "line": "早被婵娟误，欲妆临镜慵",
            "poemId": "poem_397"
        },
        {
            "line": "早服还丹无世情，琴心三叠道初成",
            "poemId": "poem_540"
        },
        {
            "line": "早晚下三巴，预将书报家",
            "poemId": "poem_575"
        },
        {
            "line": "早知潮有信，嫁与弄潮儿",
            "poemId": "poem_582"
        }
    ],
    "楼": [
        {
            "line": "楼船夜雪瓜洲渡，铁马秋风大散关",
            "poemId": "poem_163"
        },
        {
            "line": "楼阁玲珑五云起，其中绰约多仙子",
            "poemId": "poem_526"
        }
    ],
    "塞": [
        {
            "line": "塞上长城空自许，镜中衰鬓已先斑",
            "poemId": "poem_163"
        }
    ],
    "病": [
        {
            "line": "病骨支离纱帽宽，孤臣万里客江干",
            "poemId": "poem_164"
        }
    ],
    "位": [
        {
            "line": "位卑未敢忘忧国，事定犹须待阖棺",
            "poemId": "poem_164"
        }
    ],
    "壮": [
        {
            "line": "壮志病来消欲尽，出门搔首怆平生",
            "poemId": "poem_165"
        }
    ],
    "遗": [
        {
            "line": "遗民泪尽胡尘里，南望王师又一年",
            "poemId": "poem_165"
        },
        {
            "line": "遗言冀可冥，缮性何由熟",
            "poemId": "poem_509"
        }
    ],
    "泉": [
        {
            "line": "泉眼无声惜细流，树阴照水爱晴柔",
            "poemId": "poem_166"
        },
        {
            "line": "泉声咽危石，日色冷青松",
            "poemId": "poem_369"
        },
        {
            "line": "泉壑带茅茨，云霞生薜帷",
            "poemId": "poem_434"
        },
        {
            "line": "泉源在庭户，洞壑当门前",
            "poemId": "poem_502"
        }
    ],
    "毕": [
        {
            "line": "毕竟西湖六月中，风光不与四时同",
            "poemId": "poem_167"
        }
    ],
    "接": [
        {
            "line": "接天莲叶无穷碧，映日荷花别样红",
            "poemId": "poem_167"
        }
    ],
    "州": [
        {
            "line": "州桥南北是天街，父老年年等驾回",
            "poemId": "poem_168"
        },
        {
            "line": "州家申名使家抑，坎轲只得移荆蛮",
            "poemId": "poem_554"
        }
    ],
    "忍": [
        {
            "line": "忍泪失声询使者，\"几时真有六军来",
            "poemId": "poem_168"
        }
    ],
    "\"": [
        {
            "line": "\" ",
            "poemId": "poem_168"
        }
    ],
    "昼": [
        {
            "line": "昼出耘田夜绩麻，村庄儿女各当家",
            "poemId": "poem_169"
        }
    ],
    "童": [
        {
            "line": "童孙未解供耕织，也傍桑阴学种瓜",
            "poemId": "poem_169"
        },
        {
            "line": "童颜若可驻，何惜醉流霞",
            "poemId": "poem_415"
        }
    ],
    "交": [
        {
            "line": "交情得似山溪渡，不管风波去又来",
            "poemId": "poem_170"
        }
    ],
    "篱": [
        {
            "line": "篱落疏疏一径深，树头花落未成阴",
            "poemId": "poem_172"
        }
    ],
    "暖": [
        {
            "line": "暖风熏得游人醉，直把杭州作汴州",
            "poemId": "poem_173"
        }
    ],
    "半": [
        {
            "line": "半亩方塘一鉴开，天光云影共徘徊",
            "poemId": "poem_174"
        },
        {
            "line": "半生落魄已成翁,独立书斋啸晚风",
            "poemId": "poem_233"
        },
        {
            "line": "半天凉月色，一笛酒人心",
            "poemId": "poem_260"
        },
        {
            "line": "半壁见海日，空中闻天鸡",
            "poemId": "poem_534"
        }
    ],
    "为": [
        {
            "line": "为有源头活水来",
            "poemId": "poem_174"
        },
        {
            "line": "为君聊赋今日诗，努力请从今日始",
            "poemId": "poem_232"
        },
        {
            "line": "为有云屏无限娇，凤城寒尽怕春宵",
            "poemId": "poem_325"
        },
        {
            "line": "为我一挥手，如听万壑松",
            "poemId": "poem_375"
        },
        {
            "line": "为乘阳气行时令，不是宸游玩物华",
            "poemId": "poem_447"
        },
        {
            "line": "为问元戎窦车骑，何时返旆勒燕然",
            "poemId": "poem_474"
        },
        {
            "line": "为感君王辗转思，遂教方士殷勤觅",
            "poemId": "poem_526"
        }
    ],
    "律": [
        {
            "line": "律回岁晚冰霜少，春到人间草木知",
            "poemId": "poem_175"
        }
    ],
    "便": [
        {
            "line": "便觉眼前生意满，东风吹水绿参差",
            "poemId": "poem_175"
        }
    ],
    "胜": [
        {
            "line": "胜日寻芳泗水滨，无边光景一时新",
            "poemId": "poem_176"
        }
    ],
    "等": [
        {
            "line": "等闲识得东风面，万紫千红总是春",
            "poemId": "poem_176"
        },
        {
            "line": "等是有家归未得，杜鹃休向耳边啼",
            "poemId": "poem_347"
        }
    ],
    "年": [
        {
            "line": "年年送客横塘路，细雨垂杨系画船",
            "poemId": "poem_177"
        },
        {
            "line": "年年越溪女，相忆采芙蓉",
            "poemId": "poem_397"
        },
        {
            "line": "年深岂免有缺画，快剑斫断生蛟鼍",
            "poemId": "poem_551"
        },
        {
            "line": "年年战骨埋荒外，空见蒲桃入汉家",
            "poemId": "poem_584"
        }
    ],
    "曲": [
        {
            "line": "曲终过尽松陵路，回首烟波十四桥",
            "poemId": "poem_178"
        },
        {
            "line": "曲径通幽处，禅房花木深",
            "poemId": "poem_418"
        },
        {
            "line": "曲径通幽处，禅房花木深",
            "poemId": "poem_418"
        },
        {
            "line": "曲终收拨当心画，四弦一声如裂帛",
            "poemId": "poem_529"
        },
        {
            "line": "曲罢曾教善才服，妆成每被秋娘妒",
            "poemId": "poem_529"
        }
    ],
    "乡": [
        {
            "line": "乡村四月闲人少，才了蚕桑又插田",
            "poemId": "poem_181"
        },
        {
            "line": "乡书何处达",
            "poemId": "poem_367"
        },
        {
            "line": "乡泪客中尽，孤帆天际看",
            "poemId": "poem_401"
        },
        {
            "line": "乡书不可寄，秋雁又南回",
            "poemId": "poem_409"
        },
        {
            "line": "乡心新岁切，天畔独潸然",
            "poemId": "poem_422"
        }
    ],
    "美": [
        {
            "line": "美人台上昔欢娱，今日空台望五湖",
            "poemId": "poem_182"
        },
        {
            "line": "美人卷珠帘，深坐颦蛾眉",
            "poemId": "poem_294"
        },
        {
            "line": "美人清江畔，是夜越吟苦",
            "poemId": "poem_492"
        },
        {
            "line": "美服患人指，高明逼神恶",
            "poemId": "poem_521"
        },
        {
            "line": "美人娟娟隔秋水，濯足洞庭望八荒",
            "poemId": "poem_546"
        },
        {
            "line": "美人胡为隔秋水，焉得置之贡玉堂",
            "poemId": "poem_546"
        },
        {
            "line": "美人如花隔云端",
            "poemId": "poem_572"
        }
    ],
    "沙": [
        {
            "line": "沙尾风回一棹寒，椒花今夕不登盘",
            "poemId": "poem_182"
        },
        {
            "line": "沙场烽火侵胡月，海畔云山拥蓟城",
            "poemId": "poem_480"
        },
        {
            "line": "沙平水息声影绝，一杯相属君当歌",
            "poemId": "poem_554"
        }
    ],
    "笠": [
        {
            "line": "笠泽茫茫雁影微，玉峰重叠护云衣",
            "poemId": "poem_182"
        }
    ],
    "桑": [
        {
            "line": "桑间篝火却定蚕，风土相传我未谙",
            "poemId": "poem_182"
        }
    ],
    "旧": [
        {
            "line": "旧时曾作梅花赋，研墨于今亦自香",
            "poemId": "poem_182"
        },
        {
            "line": "旧业已随征战尽，更堪江上鼓鼙声",
            "poemId": "poem_487"
        }
    ],
    "环": [
        {
            "line": "环玦随波冷未销，古苔留雪卧墙腰",
            "poemId": "poem_182"
        }
    ],
    "乳": [
        {
            "line": "乳鸭池塘水浅深，熟梅天气半阴晴",
            "poemId": "poem_185"
        }
    ],
    "门": [
        {
            "line": "门外无人问落花，绿阴冉冉遍天涯",
            "poemId": "poem_187"
        },
        {
            "line": "门前冷落鞍马稀，老大嫁作商人妇",
            "poemId": "poem_529"
        }
    ],
    "林": [
        {
            "line": "林莺啼到无声处，青草池塘独听蛙",
            "poemId": "poem_187"
        },
        {
            "line": "林表明霁色，城中增暮寒",
            "poemId": "poem_298"
        },
        {
            "line": "林卧愁春尽，搴帷览物华",
            "poemId": "poem_415"
        },
        {
            "line": "林暗草惊风，将军夜引弓",
            "poemId": "poem_595"
        }
    ],
    "沾": [
        {
            "line": "沾衣欲湿杏花雨，吹面不寒杨柳风",
            "poemId": "poem_188"
        }
    ],
    "辛": [
        {
            "line": "辛苦遭逢起一经，干戈寥落四周星",
            "poemId": "poem_190"
        }
    ],
    "惶": [
        {
            "line": "惶恐滩头说惶恐，零丁洋里叹零丁",
            "poemId": "poem_190"
        }
    ],
    "掷": [
        {
            "line": "掷柳迁乔太有情，交交时作弄机声",
            "poemId": "poem_191"
        }
    ],
    "洛": [
        {
            "line": "洛阳三月花如锦，多少工夫织得成",
            "poemId": "poem_191"
        },
        {
            "line": "洛阳亲友如相问，一片冰心在玉壶",
            "poemId": "poem_305"
        },
        {
            "line": "洛阳女儿对门居，才可颜容十五余",
            "poemId": "poem_562"
        }
    ],
    "愁": [
        {
            "line": "愁里高歌梁父吟，犹如金玉戛商音",
            "poemId": "poem_192"
        }
    ],
    "胸": [
        {
            "line": "胸中有誓深于海，肯使神州竟陆沉",
            "poemId": "poem_192"
        }
    ],
    "几": [
        {
            "line": "几处败垣围故井，向来一一是人家",
            "poemId": "poem_193"
        },
        {
            "line": "几家夫妇同罗帐，几个飘零在外头",
            "poemId": "poem_202"
        },
        {
            "line": "几时杯重把，昨夜月同行",
            "poemId": "poem_388"
        },
        {
            "line": "几行归塞尽，念尔独何之",
            "poemId": "poem_417"
        }
    ],
    "寻": [
        {
            "line": "寻常一样窗前月，才有梅花便不同",
            "poemId": "poem_197"
        },
        {
            "line": "寻声暗问弹者谁",
            "poemId": "poem_529"
        }
    ],
    "太": [
        {
            "line": "太行直上犹千里，井底残山枉呼号",
            "poemId": "poem_199"
        },
        {
            "line": "太乙近天都，连山接海隅",
            "poemId": "poem_360"
        }
    ],
    "湍": [
        {
            "line": "湍溪已作风雷恶，更在云山气象中",
            "poemId": "poem_199"
        }
    ],
    "高": [
        {
            "line": "高原出水山河改，战地风来草木腥",
            "poemId": "poem_200"
        },
        {
            "line": "高斋今夜雨，独卧武昌城",
            "poemId": "poem_222"
        },
        {
            "line": "高田如楼梯，平田如棋局",
            "poemId": "poem_224"
        },
        {
            "line": "高山安可仰，徒此揖清芬",
            "poemId": "poem_377"
        },
        {
            "line": "高阁客竟去，小园花乱飞",
            "poemId": "poem_387"
        },
        {
            "line": "高风汉阳渡，初日郢门山",
            "poemId": "poem_425"
        },
        {
            "line": "高树晓还密，远山晴更多",
            "poemId": "poem_427"
        },
        {
            "line": "高卧南斋时，开帷月初吐",
            "poemId": "poem_492"
        },
        {
            "line": "高才脱略名与利，日夕望君抱琴至",
            "poemId": "poem_537"
        },
        {
            "line": "高殿秋砧响夜阑，霜深犹忆御衣寒",
            "poemId": "poem_563"
        },
        {
            "line": "高帝子孙尽隆准，龙种自与常人殊",
            "poemId": "poem_585"
        }
    ],
    "并": [
        {
            "line": "并州豪杰知谁在，莫拟分军下井陉",
            "poemId": "poem_200"
        },
        {
            "line": "并刀昨夜匣中鸣，燕赵悲歌最不平",
            "poemId": "poem_238"
        }
    ],
    "爱": [
        {
            "line": "爱惜芳心莫轻吐， 且教桃李闹春风",
            "poemId": "poem_201"
        },
        {
            "line": "爱子心无尽，归家喜及辰",
            "poemId": "poem_257"
        },
        {
            "line": "爱好由来下笔难，一诗千改始心安",
            "poemId": "poem_261"
        }
    ],
    "吾": [
        {
            "line": "吾家洗砚池头树，个个花开淡墨痕",
            "poemId": "poem_205"
        },
        {
            "line": "吾爱孟夫子，风流天下闻",
            "poemId": "poem_377"
        },
        {
            "line": "吾谋适不用，勿谓知音稀",
            "poemId": "poem_495"
        },
        {
            "line": "吾观自古贤达人，功成不退皆殒身",
            "poemId": "poem_573"
        }
    ],
    "城": [
        {
            "line": "城雪初消荠菜生，角门深巷少人行",
            "poemId": "poem_206"
        },
        {
            "line": "城头一片西山月，多少征人马上看",
            "poemId": "poem_229"
        },
        {
            "line": "城阙辅三秦，风烟望五津",
            "poemId": "poem_354"
        },
        {
            "line": "城上高楼接大荒，海天愁思正茫茫",
            "poemId": "poem_470"
        },
        {
            "line": "城小贼不屠，人贫伤可怜",
            "poemId": "poem_502"
        },
        {
            "line": "城中相识尽繁华，日夜经过赵李家",
            "poemId": "poem_562"
        }
    ],
    "茸": [
        {
            "line": "茸茸毛色起，应解自呼名",
            "poemId": "poem_209"
        }
    ],
    "牛": [
        {
            "line": "牛羊散漫落日下，野草生香乳酪甜",
            "poemId": "poem_211"
        },
        {
            "line": "牛渚西江夜，青天无片云",
            "poemId": "poem_376"
        }
    ],
    "卷": [
        {
            "line": "卷地朔风沙似雪，家家行帐下毡帘",
            "poemId": "poem_211"
        }
    ],
    "徐": [
        {
            "line": "徐行不记山深浅，一路莺啼送到家",
            "poemId": "poem_212"
        }
    ],
    "知": [
        {
            "line": "知是人家花落尽，菜畦今日蝶来多",
            "poemId": "poem_213"
        }
    ],
    "渡": [
        {
            "line": "渡水复渡水，看花还看花",
            "poemId": "poem_214"
        },
        {
            "line": "渡头馀落日，墟里上孤烟",
            "poemId": "poem_366"
        },
        {
            "line": "渡远荆门外，来从楚国游",
            "poemId": "poem_378"
        }
    ],
    "下": [
        {
            "line": "下床着新衣，初学小姑拜",
            "poemId": "poem_217"
        },
        {
            "line": "下杜城边南北路，上阑门外去来车",
            "poemId": "poem_267"
        },
        {
            "line": "下窥指高鸟，俯听闻惊风",
            "poemId": "poem_497"
        },
        {
            "line": "下马饮君酒，问君何所之",
            "poemId": "poem_500"
        },
        {
            "line": "下床畏蛇食畏药，海气湿蛰熏腥臊",
            "poemId": "poem_554"
        }
    ],
    "低": [
        {
            "line": "低头羞见人，双手结裙带",
            "poemId": "poem_217"
        },
        {
            "line": "低徊愧人子，不敢叹风尘",
            "poemId": "poem_257"
        },
        {
            "line": "低头向暗壁，千唤不一回",
            "poemId": "poem_575"
        }
    ],
    "粉": [
        {
            "line": "粉身碎骨全不怕，要留清白在人间",
            "poemId": "poem_218"
        },
        {
            "line": "粉墙丹柱动光彩，鬼物图画填青红",
            "poemId": "poem_553"
        }
    ],
    "微": [
        {
            "line": "微吟不道惊溪鸟，飞入乱云深处啼",
            "poemId": "poem_219"
        },
        {
            "line": "微微风簇浪，散作满河星",
            "poemId": "poem_248"
        },
        {
            "line": "微雨霭芳原，春鸠鸣何处",
            "poemId": "poem_517"
        }
    ],
    "闲": [
        {
            "line": "闲来写就青山卖，不使人间造孽钱",
            "poemId": "poem_221"
        },
        {
            "line": "闲坐悲君亦自悲，百年多是几多时",
            "poemId": "poem_439"
        },
        {
            "line": "闲持贝叶书，步出东斋读",
            "poemId": "poem_509"
        },
        {
            "line": "闲依农圃邻，偶似山林客",
            "poemId": "poem_513"
        },
        {
            "line": "闲窥石镜清我心，谢公行处苍苔没",
            "poemId": "poem_540"
        }
    ],
    "洞": [
        {
            "line": "洞庭叶未下，潇湘秋欲生",
            "poemId": "poem_222"
        },
        {
            "line": "洞房昨夜停红烛，待晓堂前拜舅姑",
            "poemId": "poem_315"
        },
        {
            "line": "洞门高阁霭馀辉，桃李阴阴柳絮飞",
            "poemId": "poem_440"
        },
        {
            "line": "洞天石扉，訇然中开",
            "poemId": "poem_534"
        },
        {
            "line": "洞庭连天九疑高，蛟龙出没猩鼯号",
            "poemId": "poem_554"
        }
    ],
    "汉": [
        {
            "line": "汉江明月照归人，万里秋风一叶身",
            "poemId": "poem_223"
        },
        {
            "line": "汉女输橦布，巴人讼芋田",
            "poemId": "poem_356"
        },
        {
            "line": "汉文皇帝有高台，此日登临曙色开",
            "poemId": "poem_477"
        },
        {
            "line": "汉文有道恩犹薄，湘水无情吊岂知",
            "poemId": "poem_485"
        },
        {
            "line": "汉口夕阳斜渡鸟，洞庭秋水远连天",
            "poemId": "poem_486"
        },
        {
            "line": "汉皇重色思倾国，御宇多年求不得",
            "poemId": "poem_526"
        },
        {
            "line": "汉兵奋迅如霹雳，虏骑崩腾畏蒺藜",
            "poemId": "poem_561"
        },
        {
            "line": "汉下白登道，胡窥青海湾",
            "poemId": "poem_581"
        },
        {
            "line": "汉家烟尘在东北，汉将辞家破残贼",
            "poemId": "poem_591"
        }
    ],
    "休": [
        {
            "line": "休把客衣轻浣濯，此中犹有帝京尘",
            "poemId": "poem_223"
        }
    ],
    "暝": [
        {
            "line": "暝色满西山，将军猎骑还",
            "poemId": "poem_228"
        }
    ],
    "隔": [
        {
            "line": "隔河见烽火，骄虏夜临关",
            "poemId": "poem_228"
        },
        {
            "line": "隔座送钩春酒暖，分曹射覆蜡灯红",
            "poemId": "poem_455"
        }
    ],
    "浩": [
        {
            "line": "浩气还太虚，丹心照千古",
            "poemId": "poem_230"
        },
        {
            "line": "浩荡离愁白日斜，吟鞭东指即天涯",
            "poemId": "poem_269"
        },
        {
            "line": "浩浩风起波，冥冥日沉夕",
            "poemId": "poem_516"
        }
    ],
    "笔": [
        {
            "line": "笔底明珠无处卖,闲抛闲掷野藤中",
            "poemId": "poem_233"
        }
    ],
    "寂": [
        {
            "line": "寂寂深山暮，微闻钟磬声",
            "poemId": "poem_234"
        },
        {
            "line": "寂历秋江渔火稀，起看残月映林微",
            "poemId": "poem_236"
        },
        {
            "line": "寂寂花时闭院门，美人相并立琼轩",
            "poemId": "poem_313"
        },
        {
            "line": "寂寂竟何待，朝朝空自归",
            "poemId": "poem_402"
        },
        {
            "line": "寂寂江山摇落处，怜君何事到天涯",
            "poemId": "poem_485"
        }
    ],
    "湘": [
        {
            "line": "湘山晴色远微微，尽日江头独醉归",
            "poemId": "poem_235"
        }
    ],
    "波": [
        {
            "line": "波光水鸟惊犹宿，露冷流萤湿不飞",
            "poemId": "poem_236"
        },
        {
            "line": "波上马嘶看棹去，柳边人歇待船归",
            "poemId": "poem_481"
        },
        {
            "line": "波澜誓不起，妾心古井水",
            "poemId": "poem_590"
        }
    ],
    "杀": [
        {
            "line": "杀牛羊，备酒浆，开了城门迎闯王，闯王来了不纳粮",
            "poemId": "poem_237"
        },
        {
            "line": "杀人莫敢前，须如猬毛磔",
            "poemId": "poem_545"
        }
    ],
    "吃": [
        {
            "line": "吃他娘，着她娘，吃着不够有闯王",
            "poemId": "poem_237"
        }
    ],
    "易": [
        {
            "line": "易水潺湲云草碧，可怜无处送荆卿",
            "poemId": "poem_238"
        }
    ],
    "缟": [
        {
            "line": "缟素酬家国，戈船决死生",
            "poemId": "poem_240"
        }
    ],
    "鹧": [
        {
            "line": "鹧鸪声里夕阳西，陌上征人首尽低",
            "poemId": "poem_241"
        }
    ],
    "形": [
        {
            "line": "形容不识识乡音，挑尽寒灯到夜深",
            "poemId": "poem_242"
        }
    ],
    "毅": [
        {
            "line": "毅魄归来日，灵旗空际看",
            "poemId": "poem_243"
        }
    ],
    "居": [
        {
            "line": "居庸关上子规啼，饮马流泉落日低",
            "poemId": "poem_244"
        },
        {
            "line": "居闲始自遣，临感忽难收",
            "poemId": "poem_515"
        },
        {
            "line": "居人共住武陵源，还从物外起田园",
            "poemId": "poem_564"
        }
    ],
    "吠": [
        {
            "line": "吠犬鸣鸡村远近，乳鹅新鸭岸东西",
            "poemId": "poem_247"
        }
    ],
    "丝": [
        {
            "line": "丝缫细雨沾衣润，刀剪良苗出水齐",
            "poemId": "poem_247"
        }
    ],
    "犹": [
        {
            "line": "犹与湖南风土近，春深无处不耕犁",
            "poemId": "poem_247"
        }
    ],
    "到": [
        {
            "line": "到处陂塘决决流，垂杨百里罨平畴",
            "poemId": "poem_249"
        }
    ],
    "虽": [
        {
            "line": "虽缘草成质，不借月为光",
            "poemId": "poem_250"
        }
    ],
    "咬": [
        {
            "line": "咬定青山不放松，立根原在破岩中",
            "poemId": "poem_251"
        }
    ],
    "檐": [
        {
            "line": "檐流未滴梅花冻，一种清孤不等闲",
            "poemId": "poem_252"
        }
    ],
    "卖": [
        {
            "line": "卖得鲜鱼二百钱，籴粮炊饭放归船",
            "poemId": "poem_254"
        }
    ],
    "见": [
        {
            "line": "见面怜清瘦，呼儿问苦辛",
            "poemId": "poem_257"
        }
    ],
    "船": [
        {
            "line": "船板胡在兹，而我寝其上",
            "poemId": "poem_258"
        }
    ],
    "牧": [
        {
            "line": "牧童骑黄牛，歌声振林樾",
            "poemId": "poem_259"
        },
        {
            "line": "牧童敲火牛砺角，谁复著手为摩挲",
            "poemId": "poem_551"
        }
    ],
    "意": [
        {
            "line": "意欲捕鸣蝉，忽然闭口立",
            "poemId": "poem_259"
        },
        {
            "line": "意疑倚巴丘酌于君山之上，诸子环洞庭而坐，酒舫泛泛然触波涛而往来者",
            "poemId": "poem_528"
        }
    ],
    "响": [
        {
            "line": "响遏碧云近，香传红藕深",
            "poemId": "poem_260"
        }
    ],
    "阿": [
        {
            "line": "阿婆还似初笄女，头未梳成不许看",
            "poemId": "poem_261"
        }
    ],
    "李": [
        {
            "line": "李杜诗篇万口传，至今已觉不新鲜",
            "poemId": "poem_263"
        },
        {
            "line": "李斯税驾苦不早",
            "poemId": "poem_573"
        }
    ],
    "搴": [
        {
            "line": "搴帷拜母河梁去，白发愁看泪眼枯",
            "poemId": "poem_264"
        }
    ],
    "布": [
        {
            "line": "布谷飞飞劝早耕，舂锄扑扑趁春睛",
            "poemId": "poem_265"
        }
    ],
    "匆": [
        {
            "line": "匆匆觉得扬州梦，检点闲愁在鬓华",
            "poemId": "poem_267"
        }
    ],
    "唤": [
        {
            "line": "唤起窗前尚宿酲，啼鹃催去又声声",
            "poemId": "poem_267"
        }
    ],
    "丹": [
        {
            "line": "丹青旧誓相如札，禅榻经时杜牧情",
            "poemId": "poem_267"
        },
        {
            "line": "丹青不知老将至，富贵于我如浮云",
            "poemId": "poem_544"
        }
    ],
    "遮": [
        {
            "line": "遮莫临行念我频，竹枝留涴泪痕新",
            "poemId": "poem_267"
        }
    ],
    "望": [
        {
            "line": "望里彩云疑冉冉，愁边春水故粼粼",
            "poemId": "poem_267"
        },
        {
            "line": "望门投止思张俭，忍死须臾待杜根",
            "poemId": "poem_273"
        },
        {
            "line": "望君烟水阔，挥手泪沾巾",
            "poemId": "poem_429"
        }
    ],
    "珊": [
        {
            "line": "珊瑚百尺珠千斛，难换罗敷未嫁身",
            "poemId": "poem_267"
        }
    ],
    "从": [
        {
            "line": "从此音尘各悄然，春山如黛草如烟",
            "poemId": "poem_267"
        },
        {
            "line": "从臣才艺咸第一，拣选撰刻留山阿",
            "poemId": "poem_551"
        },
        {
            "line": "从来幽并客，皆共沙尘老",
            "poemId": "poem_557"
        }
    ],
    "泪": [
        {
            "line": "泪添吴苑三更雨，恨惹邮亭一夜眠",
            "poemId": "poem_267"
        },
        {
            "line": "泪湿罗巾梦不成，夜深前殿按歌声",
            "poemId": "poem_314"
        }
    ],
    "讵": [
        {
            "line": "讵有青乌缄别句，聊将锦瑟记流年",
            "poemId": "poem_267"
        }
    ],
    "他": [
        {
            "line": "他时脱便微之过，百转千回只自怜",
            "poemId": "poem_267"
        },
        {
            "line": "他乡生白发，旧国见青山",
            "poemId": "poem_373"
        },
        {
            "line": "他乡复行役，驻马别孤坟",
            "poemId": "poem_394"
        },
        {
            "line": "他年锦里经祠庙，梁父吟成恨有余",
            "poemId": "poem_456"
        }
    ],
    "牢": [
        {
            "line": "牢盆狎客操全算，团扇才人踞上游",
            "poemId": "poem_268"
        }
    ],
    "避": [
        {
            "line": "避席畏闻文字狱，著书都为稻粱谋",
            "poemId": "poem_268"
        }
    ],
    "田": [
        {
            "line": "田横五百人安在，难道归来尽列侯",
            "poemId": "poem_268"
        },
        {
            "line": "田园寥落干戈后，骨肉流离道路中",
            "poemId": "poem_444"
        },
        {
            "line": "田夫荷锄至，相见语依依",
            "poemId": "poem_493"
        }
    ],
    "草": [
        {
            "line": "草长莺飞二月天，拂堤杨柳醉春烟",
            "poemId": "poem_270"
        },
        {
            "line": "草木有本心，何求美人折",
            "poemId": "poem_523"
        }
    ],
    "石": [
        {
            "line": "石壕村里夫妻别，泪比长生殿上多",
            "poemId": "poem_272"
        },
        {
            "line": "石鱼湖，似洞庭，夏水欲满君山青",
            "poemId": "poem_528"
        },
        {
            "line": "石鼓之歌止于此，呜呼吾意其蹉跎",
            "poemId": "poem_551"
        }
    ],
    "手": [
        {
            "line": "手掷欧刀仰天笑，留将公罪后人论",
            "poemId": "poem_273"
        },
        {
            "line": "手持绿玉杖，朝别黄鹤楼",
            "poemId": "poem_540"
        },
        {
            "line": "手持杯珓导我掷，云此最吉余难同",
            "poemId": "poem_553"
        }
    ],
    "诗": [
        {
            "line": "诗界千年靡靡风，兵魂销尽国魂空",
            "poemId": "poem_276"
        }
    ],
    "集": [
        {
            "line": "集中什九从军乐，亘古男儿一放翁",
            "poemId": "poem_276"
        }
    ],
    "邹": [
        {
            "line": "邹容吾小弟，被发下瀛州",
            "poemId": "poem_277"
        }
    ],
    "快": [
        {
            "line": "快剪刀除辫，干牛肉作餱",
            "poemId": "poem_277"
        }
    ],
    "英": [
        {
            "line": "英雄一入狱，天地亦悲秋",
            "poemId": "poem_277"
        },
        {
            "line": "英雄割据虽已矣，文采风流今尚存",
            "poemId": "poem_544"
        }
    ],
    "临": [
        {
            "line": "临命须掺手，乾坤只两头",
            "poemId": "poem_277"
        },
        {
            "line": "临邛道士鸿都客，能以精诚致魂魄",
            "poemId": "poem_526"
        },
        {
            "line": "临别殷勤重寄词，词中有誓两心知",
            "poemId": "poem_526"
        },
        {
            "line": "临颍美人在白帝，妙舞此曲神扬扬",
            "poemId": "poem_542"
        },
        {
            "line": "临行密密缝，意恐迟迟归",
            "poemId": "poem_589"
        }
    ],
    "浓": [
        {
            "line": "浓似春云淡似烟，参差绿到大江边",
            "poemId": "poem_278"
        }
    ],
    "斜": [
        {
            "line": "斜阳流水推篷坐，翠色随人欲上船",
            "poemId": "poem_278"
        },
        {
            "line": "斜拔玉钗灯影畔，剔开红焰救飞蛾",
            "poemId": "poem_343"
        },
        {
            "line": "斜阳照墟落，穷巷牛羊归",
            "poemId": "poem_493"
        }
    ],
    "寥": [
        {
            "line": "寥落古行宫，宫花寂寞红",
            "poemId": "poem_279"
        }
    ],
    "空": [
        {
            "line": "空山不见人，但闻人语响",
            "poemId": "poem_280"
        },
        {
            "line": "空山松子落，幽人应未眠",
            "poemId": "poem_297"
        },
        {
            "line": "空山新雨后，天气晚来秋",
            "poemId": "poem_364"
        },
        {
            "line": "空园白露滴，孤壁野僧邻",
            "poemId": "poem_413"
        },
        {
            "line": "空山百鸟散还合，万里浮云阴且晴",
            "poemId": "poem_537"
        }
    ],
    "返": [
        {
            "line": "返景入深林，复照青苔上",
            "poemId": "poem_280"
        }
    ],
    "来": [
        {
            "line": "来日绮窗前，寒梅著花未",
            "poemId": "poem_281"
        },
        {
            "line": "来是空言去绝踪，月斜楼上五更钟",
            "poemId": "poem_453"
        },
        {
            "line": "来往不逢人，长歌楚天碧",
            "poemId": "poem_513"
        },
        {
            "line": "来如雷霆收震怒，罢如江海凝清光",
            "poemId": "poem_542"
        }
    ],
    "晚": [
        {
            "line": "晚来天欲雪，能饮一杯无",
            "poemId": "poem_285"
        },
        {
            "line": "晚年唯好静，万事不关心",
            "poemId": "poem_363"
        },
        {
            "line": "晚风吹行舟，花路入溪口",
            "poemId": "poem_524"
        }
    ],
    "欲": [
        {
            "line": "欲穷千里目，更上一层楼",
            "poemId": "poem_286"
        },
        {
            "line": "欲得周郎顾，时时误拂弦",
            "poemId": "poem_288"
        },
        {
            "line": "欲投人处宿，隔水问樵夫",
            "poemId": "poem_360"
        },
        {
            "line": "欲寻芳草去，惜与故人违",
            "poemId": "poem_402"
        },
        {
            "line": "欲祭疑君在，天涯哭此时",
            "poemId": "poem_421"
        },
        {
            "line": "欲知世掌丝纶美，池上于今有凤毛",
            "poemId": "poem_446"
        },
        {
            "line": "欲取鸣琴弹，恨无知音赏",
            "poemId": "poem_511"
        },
        {
            "line": "欲持一瓢酒，远慰风雨夕",
            "poemId": "poem_519"
        },
        {
            "line": "欲渡黄河冰塞川，将登太行雪满山",
            "poemId": "poem_566"
        },
        {
            "line": "欲将轻骑逐，大雪满弓刀",
            "poemId": "poem_596"
        }
    ],
    "深": [
        {
            "line": "深林人不知，明月来相照",
            "poemId": "poem_287"
        }
    ],
    "向": [
        {
            "line": "向晚意不适，驱车登古原",
            "poemId": "poem_289"
        },
        {
            "line": "向来吟秀句，不觉已鸣鸦",
            "poemId": "poem_441"
        }
    ],
    "功": [
        {
            "line": "功盖三分国，名成八阵图",
            "poemId": "poem_290"
        }
    ],
    "床": [
        {
            "line": "床前明月光，疑是地上霜",
            "poemId": "poem_291"
        }
    ],
    "岭": [
        {
            "line": "岭外音书断，经冬复历春",
            "poemId": "poem_293"
        },
        {
            "line": "岭树重遮千里目，江流曲似九回肠",
            "poemId": "poem_470"
        }
    ],
    "近": [
        {
            "line": "近乡情更怯，不敢问来人",
            "poemId": "poem_293"
        },
        {
            "line": "近寒食雨草萋萋，著麦苗风柳映堤",
            "poemId": "poem_347"
        },
        {
            "line": "近泪无干土，低空有断云",
            "poemId": "poem_394"
        },
        {
            "line": "近种篱边菊，秋来未著花",
            "poemId": "poem_428"
        }
    ],
    "移": [
        {
            "line": "移舟泊烟渚，日暮客愁新",
            "poemId": "poem_296"
        },
        {
            "line": "移家虽带郭，野径入桑麻",
            "poemId": "poem_428"
        },
        {
            "line": "移船相近邀相见，添酒回灯重开宴",
            "poemId": "poem_529"
        }
    ],
    "打": [
        {
            "line": "打起黄莺儿，莫教枝上啼",
            "poemId": "poem_300"
        }
    ],
    "啼": [
        {
            "line": "啼时惊妾梦，不得到辽西",
            "poemId": "poem_300"
        }
    ],
    "松": [
        {
            "line": "松下问童子，言师采药去",
            "poemId": "poem_301"
        },
        {
            "line": "松月生夜凉，风泉满清听",
            "poemId": "poem_512"
        },
        {
            "line": "松际露微月，清光犹为君",
            "poemId": "poem_522"
        }
    ],
    "苍": [
        {
            "line": "苍苍竹林寺，杳杳钟声晚",
            "poemId": "poem_303"
        },
        {
            "line": "苍茫古木连穷巷，寥落寒山对虚牖",
            "poemId": "poem_561"
        }
    ],
    "泠": [
        {
            "line": "泠泠七弦上，静听松风寒",
            "poemId": "poem_304"
        }
    ],
    "铅": [
        {
            "line": "铅华不可弃，莫是藁砧归",
            "poemId": "poem_306"
        }
    ],
    "闺": [
        {
            "line": "闺中少妇不知愁，春日凝妆上翠楼",
            "poemId": "poem_308"
        }
    ],
    "忽": [
        {
            "line": "忽见陌头杨柳色，悔教夫婿觅封侯",
            "poemId": "poem_308"
        },
        {
            "line": "忽闻歌古调，归思欲沾巾",
            "poemId": "poem_398"
        },
        {
            "line": "忽逢青鸟使，邀入赤松家",
            "poemId": "poem_415"
        },
        {
            "line": "忽然遭世变，数岁亲戎旃",
            "poemId": "poem_502"
        },
        {
            "line": "忽闻海上有仙山，山在虚无缥渺间",
            "poemId": "poem_526"
        },
        {
            "line": "忽闻水上琵琶声，主人忘归客不发",
            "poemId": "poem_529"
        },
        {
            "line": "忽如一夜春风来，千树万树梨花开",
            "poemId": "poem_530"
        },
        {
            "line": "忽魂悸以魄动，恍惊起而长嗟",
            "poemId": "poem_534"
        }
    ],
    "葡": [
        {
            "line": "葡萄美酒夜光杯，欲饮琵琶马上催",
            "poemId": "poem_311"
        }
    ],
    "醉": [
        {
            "line": "醉卧沙场君莫笑，古来征战几人回",
            "poemId": "poem_311"
        },
        {
            "line": "醉不成欢惨将别，别时茫茫江浸月",
            "poemId": "poem_529"
        },
        {
            "line": "醉卧不知白日暮，有时空望孤云高",
            "poemId": "poem_543"
        },
        {
            "line": "醉和金甲舞，雷鼓动山川",
            "poemId": "poem_597"
        }
    ],
    "宣": [
        {
            "line": "宣室求贤访逐臣，贾生才调更无伦",
            "poemId": "poem_320"
        }
    ],
    "乘": [
        {
            "line": "乘兴南游不戒严，九重谁省谏书函",
            "poemId": "poem_321"
        }
    ],
    "瑶": [
        {
            "line": "瑶池阿母绮窗开，黄竹歌声动地哀",
            "poemId": "poem_322"
        }
    ],
    "嫦": [
        {
            "line": "嫦娥应悔偷灵药，碧海青天夜夜心",
            "poemId": "poem_323"
        }
    ],
    "岐": [
        {
            "line": "岐王宅里寻常见，崔九堂前几度闻",
            "poemId": "poem_326"
        }
    ],
    "嵩": [
        {
            "line": "嵩云秦树久离居，双鲤迢迢一纸书",
            "poemId": "poem_327"
        }
    ],
    "二": [
        {
            "line": "二十四桥明月夜，玉人何处教吹箫",
            "poemId": "poem_328"
        },
        {
            "line": "二月黄莺飞上林，春城紫禁晓阴阴",
            "poemId": "poem_488"
        }
    ],
    "繁": [
        {
            "line": "繁华事散逐香尘，流水无情草自春",
            "poemId": "poem_330"
        }
    ],
    "娉": [
        {
            "line": "娉娉袅袅十三余，豆蔻梢头二月初",
            "poemId": "poem_331"
        }
    ],
    "蜡": [
        {
            "line": "蜡烛有心还惜别，替人垂泪到天明",
            "poemId": "poem_331"
        },
        {
            "line": "蜡烛有心还惜别，替人垂泪到天明",
            "poemId": "poem_337"
        },
        {
            "line": "蜡照半笼金翡翠，麝熏微度绣芙蓉",
            "poemId": "poem_453"
        }
    ],
    "银": [
        {
            "line": "银烛秋光冷画屏，轻罗小扇扑流萤",
            "poemId": "poem_332"
        },
        {
            "line": "银瓶乍破水浆迸，铁骑突出刀枪鸣",
            "poemId": "poem_529"
        },
        {
            "line": "银筝夜久殷勤弄，心怯空房不忍归",
            "poemId": "poem_560"
        },
        {
            "line": "银灯青琐裁缝歇，还向金城明主看",
            "poemId": "poem_563"
        }
    ],
    "烟": [
        {
            "line": "烟笼寒水月笼沙，夜泊秦淮近酒家",
            "poemId": "poem_335"
        },
        {
            "line": "烟波江上使人愁",
            "poemId": "poem_478"
        },
        {
            "line": "烟销日出不见人，欸乃一声山水绿",
            "poemId": "poem_549"
        }
    ],
    "岁": [
        {
            "line": "岁岁金河复玉关，朝朝马策与刀环",
            "poemId": "poem_336"
        },
        {
            "line": "岁暮阴阳催短景，天涯霜雪霁寒宵",
            "poemId": "poem_462"
        },
        {
            "line": "岁夜高堂列明烛，美酒一杯声一曲",
            "poemId": "poem_538"
        }
    ],
    "隐": [
        {
            "line": "隐隐飞桥隔野烟，石矶西畔问渔船",
            "poemId": "poem_340"
        }
    ],
    "禁": [
        {
            "line": "禁门宫树月痕过，媚眼惟看宿鹭窠",
            "poemId": "poem_343"
        },
        {
            "line": "禁里疏钟官舍晚，省中啼鸟吏人稀",
            "poemId": "poem_440"
        }
    ],
    "虢": [
        {
            "line": "虢国夫人承主恩，平明骑马入宫门",
            "poemId": "poem_345"
        }
    ],
    "却": [
        {
            "line": "却嫌脂粉污颜色，淡扫峨眉朝至尊",
            "poemId": "poem_345"
        },
        {
            "line": "却看妻子愁何在，漫卷诗书喜欲狂",
            "poemId": "poem_467"
        },
        {
            "line": "却顾所来径，苍苍横翠微",
            "poemId": "poem_507"
        },
        {
            "line": "却下水晶帘，玲珑望秋月",
            "poemId": "poem_571"
        }
    ],
    "誓": [
        {
            "line": "誓扫匈奴不顾身，五千貂锦丧胡尘",
            "poemId": "poem_346"
        },
        {
            "line": "誓将挂冠去，觉道资无穷",
            "poemId": "poem_497"
        },
        {
            "line": "誓将上雪列圣耻，坐法宫中朝四夷",
            "poemId": "poem_536"
        },
        {
            "line": "誓令疏勒出飞泉，不似颍川空使酒",
            "poemId": "poem_561"
        }
    ],
    "姑": [
        {
            "line": "姑苏城外寒山寺，夜半钟声到客船",
            "poemId": "poem_350"
        }
    ],
    "纱": [
        {
            "line": "纱窗日落渐黄昏，金屋无人见泪痕",
            "poemId": "poem_351"
        }
    ],
    "与": [
        {
            "line": "与君离别意，同是宦游人",
            "poemId": "poem_354"
        },
        {
            "line": "与余问答既有以，感时抚事增惋伤",
            "poemId": "poem_542"
        },
        {
            "line": "与君歌一曲，请君为我倾耳听",
            "poemId": "poem_570"
        }
    ],
    "海": [
        {
            "line": "海内存知己，天涯若比邻",
            "poemId": "poem_354"
        },
        {
            "line": "海日生残夜，江春入旧年",
            "poemId": "poem_367"
        },
        {
            "line": "海上生明月，天涯共此时",
            "poemId": "poem_419"
        },
        {
            "line": "海内风尘诸弟隔，天涯涕泪一身遥",
            "poemId": "poem_468"
        },
        {
            "line": "海上风雨至，逍遥池阁凉",
            "poemId": "poem_518"
        },
        {
            "line": "海客谈瀛洲，烟涛微茫信难求",
            "poemId": "poem_534"
        }
    ],
    "玄": [
        {
            "line": "玄宗回马杨妃死，云雨难忘日月新",
            "poemId": "poem_355"
        }
    ],
    "襄": [
        {
            "line": "襄阳好风日，留醉与山翁",
            "poemId": "poem_358"
        }
    ],
    "更": [
        {
            "line": "更深月色半人家，北斗阑干南斗斜",
            "poemId": "poem_359"
        },
        {
            "line": "更有明朝恨，离杯惜共传",
            "poemId": "poem_371"
        }
    ],
    "新": [
        {
            "line": "新妆宜面下朱楼，深锁春光一院愁",
            "poemId": "poem_361"
        },
        {
            "line": "新知遭薄俗，旧好隔良缘",
            "poemId": "poem_385"
        },
        {
            "line": "新鬼烦冤旧鬼哭，天阴雨湿声啾啾",
            "poemId": "poem_583"
        }
    ],
    "兴": [
        {
            "line": "兴来每独往，胜事空自知",
            "poemId": "poem_362"
        },
        {
            "line": "兴尽方下山，何必待之子",
            "poemId": "poem_508"
        }
    ],
    "偶": [
        {
            "line": "偶然值林叟，谈笑无还期",
            "poemId": "poem_362"
        }
    ],
    "随": [
        {
            "line": "随意春芳歇，王孙自可留",
            "poemId": "poem_364"
        },
        {
            "line": "随山将万转，趣途无百里",
            "poemId": "poem_494"
        }
    ],
    "倚": [
        {
            "line": "倚杖柴门外，临风听暮蝉",
            "poemId": "poem_366"
        }
    ],
    "又": [
        {
            "line": "又送王孙去，萋萋满别情",
            "poemId": "poem_370"
        },
        {
            "line": "又闻子规啼夜月，愁空山",
            "poemId": "poem_576"
        },
        {
            "line": "又向人家啄大屋，屋底达官走避胡",
            "poemId": "poem_585"
        }
    ],
    "乍": [
        {
            "line": "乍见翻疑梦，相悲各问年",
            "poemId": "poem_371"
        }
    ],
    "静": [
        {
            "line": "静夜四无邻，荒居旧业贫",
            "poemId": "poem_372"
        }
    ],
    "平": [
        {
            "line": "平生自有分，况是蔡家亲",
            "poemId": "poem_372"
        },
        {
            "line": "平沙日未没，黯黯见临洮",
            "poemId": "poem_558"
        },
        {
            "line": "平明闾巷扫花开，薄暮渔樵乘水入",
            "poemId": "poem_564"
        },
        {
            "line": "平明寻白羽，没在石棱中",
            "poemId": "poem_595"
        }
    ],
    "蜀": [
        {
            "line": "蜀僧抱绿绮，西下峨眉峰",
            "poemId": "poem_375"
        },
        {
            "line": "蜀主窥吴幸三峡，崩年亦在永安宫",
            "poemId": "poem_461"
        },
        {
            "line": "蜀江水碧蜀山青，圣主朝朝暮暮情",
            "poemId": "poem_526"
        },
        {
            "line": "蜀道之难，难于上青天",
            "poemId": "poem_576"
        },
        {
            "line": "蜀道之难,难于上青天，使人听此凋朱颜",
            "poemId": "poem_576"
        },
        {
            "line": "蜀道之难,难于上青天，侧身西望长咨嗟",
            "poemId": "poem_576"
        }
    ],
    "仍": [
        {
            "line": "仍怜故乡水，万里送行舟",
            "poemId": "poem_378"
        }
    ],
    "联": [
        {
            "line": "联步趋丹陛，分曹限紫微",
            "poemId": "poem_380"
        }
    ],
    "圣": [
        {
            "line": "圣朝无阙事，自觉谏书稀",
            "poemId": "poem_380"
        },
        {
            "line": "圣代即今多雨露，暂时分手莫踌躇",
            "poemId": "poem_482"
        },
        {
            "line": "圣代无隐者，英灵尽来归",
            "poemId": "poem_495"
        },
        {
            "line": "圣恩若许留太学，诸生讲解得切磋",
            "poemId": "poem_551"
        }
    ],
    "挥": [
        {
            "line": "挥手自兹去，萧萧班马鸣",
            "poemId": "poem_381"
        }
    ],
    "永": [
        {
            "line": "永怀当此节，倚立自移时",
            "poemId": "poem_382"
        },
        {
            "line": "永怀愁不寐，松月夜窗虚",
            "poemId": "poem_403"
        },
        {
            "line": "永夜角声悲自语，中天月色好谁看",
            "poemId": "poem_463"
        },
        {
            "line": "永日方戚戚，出行复悠悠",
            "poemId": "poem_515"
        }
    ],
    "烦": [
        {
            "line": "烦君最相警，我亦举家清",
            "poemId": "poem_384"
        },
        {
            "line": "烦疴近消散，嘉宾复满堂",
            "poemId": "poem_518"
        }
    ],
    "凄": [
        {
            "line": "凄凉宝剑篇，羁泊欲穷年",
            "poemId": "poem_385"
        },
        {
            "line": "凄凉蜀故妓，来舞魏宫前",
            "poemId": "poem_430"
        },
        {
            "line": "凄凄去亲爱，泛泛入烟雾",
            "poemId": "poem_520"
        },
        {
            "line": "凄凄不似向前声，满座重闻皆掩泣",
            "poemId": "poem_529"
        }
    ],
    "吴": [
        {
            "line": "吴楚东南坼，乾坤日夜浮",
            "poemId": "poem_386"
        },
        {
            "line": "吴宫花草埋幽径，晋代衣冠成古丘",
            "poemId": "poem_448"
        },
        {
            "line": "吴中盛文史，群彦今汪洋",
            "poemId": "poem_518"
        }
    ],
    "戎": [
        {
            "line": "戎马关山北，凭轩涕泗流",
            "poemId": "poem_386"
        }
    ],
    "芳": [
        {
            "line": "芳心向春尽，所得是沾衣",
            "poemId": "poem_387"
        }
    ],
    "鸿": [
        {
            "line": "鸿雁几时到，江湖秋水多",
            "poemId": "poem_390"
        },
        {
            "line": "鸿雁不堪愁里听，云山况是客中过",
            "poemId": "poem_458"
        },
        {
            "line": "鸿飞冥冥日月白，青枫叶赤天雨霜",
            "poemId": "poem_546"
        }
    ],
    "戍": [
        {
            "line": "戍鼓断人行，边秋一雁声",
            "poemId": "poem_393"
        },
        {
            "line": "戍楼西望烟尘黑，汉军屯在轮台北",
            "poemId": "poem_532"
        },
        {
            "line": "戍客望边邑，思归多苦颜",
            "poemId": "poem_581"
        }
    ],
    "国": [
        {
            "line": "国破山河在，城春草木深",
            "poemId": "poem_395"
        },
        {
            "line": "国家成败吾岂敢，色难腥腐餐枫香",
            "poemId": "poem_546"
        },
        {
            "line": "国初已来画鞍马，神妙独数江都王",
            "poemId": "poem_547"
        }
    ],
    "感": [
        {
            "line": "感时花溅泪，恨别鸟惊心",
            "poemId": "poem_395"
        },
        {
            "line": "感此怀故人，中宵劳梦想",
            "poemId": "poem_511"
        },
        {
            "line": "感我此言良久立，却坐促弦弦转急",
            "poemId": "poem_529"
        },
        {
            "line": "感此伤妾心，坐愁红颜老",
            "poemId": "poem_575"
        }
    ],
    "烽": [
        {
            "line": "烽火连三月，家书抵万金",
            "poemId": "poem_395"
        }
    ],
    "承": [
        {
            "line": "承恩不在貌，教妾若为容",
            "poemId": "poem_397"
        },
        {
            "line": "承欢侍宴无闲暇，春从春游夜专夜",
            "poemId": "poem_526"
        }
    ],
    "淑": [
        {
            "line": "淑气催黄鸟，晴光转绿蘋",
            "poemId": "poem_398"
        }
    ],
    "木": [
        {
            "line": "木落雁南度，北风江上寒",
            "poemId": "poem_401"
        }
    ],
    "当": [
        {
            "line": "当路谁相假，知音世所稀",
            "poemId": "poem_402"
        },
        {
            "line": "当时浣纱伴，莫得同车归",
            "poemId": "poem_496"
        },
        {
            "line": "当君怀归日，是妾断肠时",
            "poemId": "poem_499"
        },
        {
            "line": "当仁自古有不让，言讫屡颔天子颐",
            "poemId": "poem_536"
        },
        {
            "line": "当流赤足踏涧石，水声激激风吹衣",
            "poemId": "poem_552"
        },
        {
            "line": "当时只记入山深，青溪几度到云林",
            "poemId": "poem_564"
        }
    ],
    "待": [
        {
            "line": "待到重阳日，还来就菊花",
            "poemId": "poem_404"
        }
    ],
    "八": [
        {
            "line": "八月湖水平，涵虚混太清",
            "poemId": "poem_406"
        },
        {
            "line": "八月蝴蝶黄，双飞西园草",
            "poemId": "poem_575"
        }
    ],
    "气": [
        {
            "line": "气蒸云梦泽，波撼岳阳城",
            "poemId": "poem_406"
        }
    ],
    "坐": [
        {
            "line": "坐观垂钓者，徒有羡鱼情",
            "poemId": "poem_406"
        },
        {
            "line": "坐看红树不知远，行尽青溪不见人",
            "poemId": "poem_564"
        }
    ],
    "羊": [
        {
            "line": "羊公碑尚在，读罢泪沾襟",
            "poemId": "poem_408"
        }
    ],
    "欢": [
        {
            "line": "欢笑情如旧，萧疏鬓已斑",
            "poemId": "poem_410"
        },
        {
            "line": "欢言得所憩，美酒聊共挥",
            "poemId": "poem_507"
        },
        {
            "line": "欢醉中，据湖岸，引臂向鱼取酒，使舫载之，偏饮坐者",
            "poemId": "poem_528"
        }
    ],
    "漠": [
        {
            "line": "漠漠帆来重，冥冥鸟去迟",
            "poemId": "poem_411"
        },
        {
            "line": "漠漠水田飞白鹭，阴阴夏木啭黄鹂",
            "poemId": "poem_443"
        }
    ],
    "夫": [
        {
            "line": "夫子何为者，栖栖一代中",
            "poemId": "poem_412"
        },
        {
            "line": "夫婿轻薄儿，新人美如玉",
            "poemId": "poem_506"
        }
    ],
    "露": [
        {
            "line": "露气寒光集，微阳下楚丘",
            "poemId": "poem_414"
        }
    ],
    "猿": [
        {
            "line": "猿啼洞庭树，人在木兰舟",
            "poemId": "poem_414"
        },
        {
            "line": "猿鸟犹疑畏简书，风云常为护储胥",
            "poemId": "poem_456"
        },
        {
            "line": "猿鸣钟动不知曙，杲杲寒日生于东",
            "poemId": "poem_553"
        }
    ],
    "广": [
        {
            "line": "广泽生明月，苍山夹乱流",
            "poemId": "poem_414"
        }
    ],
    "那": [
        {
            "line": "那堪正飘泊，明日岁华新",
            "poemId": "poem_416"
        }
    ],
    "暮": [
        {
            "line": "暮雨相呼失，寒塘欲下迟",
            "poemId": "poem_417"
        },
        {
            "line": "暮从碧山下，山月随人归",
            "poemId": "poem_507"
        }
    ],
    "渚": [
        {
            "line": "渚云低暗度，关月冷相随",
            "poemId": "poem_417"
        }
    ],
    "灭": [
        {
            "line": "灭烛怜光满，披衣觉露滋",
            "poemId": "poem_419"
        }
    ],
    "调": [
        {
            "line": "调角断清秋，征人倚戍楼",
            "poemId": "poem_420"
        }
    ],
    "蕃": [
        {
            "line": "蕃情似此水，长愿向南流",
            "poemId": "poem_420"
        },
        {
            "line": "蕃汉断消息，死生长别离",
            "poemId": "poem_421"
        }
    ],
    "前": [
        {
            "line": "前年伐月支，城上没全师",
            "poemId": "poem_421"
        },
        {
            "line": "前不见古人，后不见来者",
            "poemId": "poem_550"
        }
    ],
    "荒": [
        {
            "line": "荒戍落黄叶，浩然离故关",
            "poemId": "poem_425"
        }
    ],
    "惆": [
        {
            "line": "惆怅南朝事，长江独至今",
            "poemId": "poem_426"
        }
    ],
    "报": [
        {
            "line": "报道山中去，归时每日斜",
            "poemId": "poem_428"
        }
    ],
    "掩": [
        {
            "line": "掩泪空相向，风尘何处期",
            "poemId": "poem_431"
        }
    ],
    "幽": [
        {
            "line": "幽映每白日，清辉照衣裳",
            "poemId": "poem_432"
        },
        {
            "line": "幽意无断绝，此去随所偶",
            "poemId": "poem_524"
        },
        {
            "line": "幽人归独卧，滞虑洗孤清",
            "poemId": "poem_527"
        },
        {
            "line": "幽音变调忽飘洒，长风吹林雨堕瓦",
            "poemId": "poem_537"
        }
    ],
    "惟": [
        {
            "line": "惟怜一灯影，万里眼中明",
            "poemId": "poem_433"
        },
        {
            "line": "惟将终夜常开眼，报答平生未展眉",
            "poemId": "poem_439"
        },
        {
            "line": "惟将迟暮供多病，未有涓埃答圣朝",
            "poemId": "poem_468"
        },
        {
            "line": "惟将旧物表深情，钿合金钗寄将去",
            "poemId": "poem_526"
        },
        {
            "line": "惟觉时之枕席，失向来之烟霞",
            "poemId": "poem_534"
        },
        {
            "line": "惟 通：唯)陈王昔时宴平乐，斗酒十千恣欢谑",
            "poemId": "poem_570"
        }
    ],
    "家": [
        {
            "line": "家童扫萝径，昨与故人期",
            "poemId": "poem_434"
        },
        {
            "line": "家住层城临汉苑，心随明月到胡天",
            "poemId": "poem_474"
        },
        {
            "line": "家临九江水，来去九江侧",
            "poemId": "poem_594"
        }
    ],
    "罢": [
        {
            "line": "罢归无旧业，老去恋明时",
            "poemId": "poem_435"
        }
    ],
    "茫": [
        {
            "line": "茫茫江汉上，日暮欲何之",
            "poemId": "poem_435"
        }
    ],
    "尚": [
        {
            "line": "尚想旧情怜婢仆，也曾因梦送钱财",
            "poemId": "poem_437"
        }
    ],
    "羁": [
        {
            "line": "羁旅长堪醉，相留畏晓钟",
            "poemId": "poem_438"
        }
    ],
    "邓": [
        {
            "line": "邓攸无子寻知命，潘岳悼亡犹费词",
            "poemId": "poem_439"
        }
    ],
    "强": [
        {
            "line": "强欲从君无那老，将因卧病解朝衣",
            "poemId": "poem_440"
        }
    ],
    "谢": [
        {
            "line": "谢公最小偏怜女，自嫁黔娄百事乖",
            "poemId": "poem_442"
        },
        {
            "line": "谢公宿处今尚在，渌水荡漾清猿啼",
            "poemId": "poem_534"
        }
    ],
    "积": [
        {
            "line": "积雨空林烟火迟，蒸藜炊黍饷东菑",
            "poemId": "poem_443"
        }
    ],
    "吊": [
        {
            "line": "吊影分为千里雁，辞根散作九秋蓬",
            "poemId": "poem_444"
        }
    ],
    "共": [
        {
            "line": "共看明月应垂泪，一夜乡心五处同",
            "poemId": "poem_444"
        },
        {
            "line": "共来百越文身地，犹自音书滞一乡",
            "poemId": "poem_470"
        }
    ],
    "鸡": [
        {
            "line": "鸡鸣紫陌曙光寒，莺啭皇州春色阑",
            "poemId": "poem_445"
        }
    ],
    "旌": [
        {
            "line": "旌旗日暖龙蛇动，宫殿风微燕雀高",
            "poemId": "poem_446"
        }
    ],
    "渭": [
        {
            "line": "渭水自萦秦塞曲，黄山旧绕汉宫斜",
            "poemId": "poem_447"
        },
        {
            "line": "渭城朝雨浥轻尘，客舍青青柳色新",
            "poemId": "poem_559"
        }
    ],
    "銮": [
        {
            "line": "銮舆迥出千门柳，阁道回看上苑花",
            "poemId": "poem_447"
        }
    ],
    "凤": [
        {
            "line": "凤凰台上凤凰游，凤去台空江自流",
            "poemId": "poem_448"
        },
        {
            "line": "凤尾香罗薄几重，碧文圆顶夜深缝",
            "poemId": "poem_451"
        }
    ],
    "直": [
        {
            "line": "直道相思了无益，未妨惆怅是清狂",
            "poemId": "poem_449"
        },
        {
            "line": "直 通：值)停杯投箸不能食，拔剑四顾心茫然",
            "poemId": "poem_566"
        }
    ],
    "蓬": [
        {
            "line": "蓬山此去无多路，青鸟殷勤为探看",
            "poemId": "poem_450"
        },
        {
            "line": "蓬门未识绮罗香，拟托良媒益自伤",
            "poemId": "poem_476"
        },
        {
            "line": "蓬莱文章建安骨，中间小谢又清发",
            "poemId": "poem_533"
        }
    ],
    "扇": [
        {
            "line": "扇裁月魄羞难掩，车走雷声语未通",
            "poemId": "poem_451"
        }
    ],
    "斑": [
        {
            "line": "斑骓只系垂杨岸，何处西南任好风",
            "poemId": "poem_451"
        }
    ],
    "飒": [
        {
            "line": "飒飒东风细雨来，芙蓉塘外有轻雷",
            "poemId": "poem_452"
        }
    ],
    "贾": [
        {
            "line": "贾氏窥帘韩掾少，宓妃留枕魏王才",
            "poemId": "poem_452"
        }
    ],
    "梦": [
        {
            "line": "梦为远别啼难唤，书被催成墨未浓",
            "poemId": "poem_453"
        }
    ],
    "刘": [
        {
            "line": "刘郎已恨蓬山远，更隔蓬山一万重",
            "poemId": "poem_453"
        }
    ],
    "庄": [
        {
            "line": "庄生晓梦迷蝴蝶，望帝春心托杜鹃",
            "poemId": "poem_454"
        }
    ],
    "身": [
        {
            "line": "身无彩凤双飞翼，心有灵犀一点通",
            "poemId": "poem_455"
        },
        {
            "line": "身多疾病思田里，邑有流亡愧俸钱",
            "poemId": "poem_475"
        },
        {
            "line": "身当恩遇常轻敌，力尽关山未解围",
            "poemId": "poem_591"
        }
    ],
    "嗟": [
        {
            "line": "嗟余听鼓应官去，走马兰台类转蓬",
            "poemId": "poem_455"
        },
        {
            "line": "嗟君此别意何如，驻马衔杯问谪居",
            "poemId": "poem_482"
        },
        {
            "line": "嗟余好古生苦晚，对此涕泪双滂沱",
            "poemId": "poem_551"
        }
    ],
    "管": [
        {
            "line": "管乐有才原不忝，关张无命欲何如",
            "poemId": "poem_456"
        }
    ],
    "怅": [
        {
            "line": "怅卧新春白袷衣，白门寥落意多违",
            "poemId": "poem_457"
        },
        {
            "line": "怅望千秋一洒泪，萧条异代不同时",
            "poemId": "poem_464"
        }
    ],
    "群": [
        {
            "line": "群山万壑赴荆门，生长明妃尚有村",
            "poemId": "poem_459"
        }
    ],
    "画": [
        {
            "line": "画图省识春风面，环佩空归夜月魂",
            "poemId": "poem_459"
        },
        {
            "line": "画阁朱楼尽相望，红桃绿柳垂檐向",
            "poemId": "poem_562"
        }
    ],
    "紫": [
        {
            "line": "紫泉宫殿锁烟霞，欲取芜城作帝家",
            "poemId": "poem_460"
        },
        {
            "line": "紫盖连延接天柱，石廪腾掷堆祝融",
            "poemId": "poem_553"
        },
        {
            "line": "紫驼之峰出翠釜，水精之盘行素鳞",
            "poemId": "poem_586"
        }
    ],
    "于": [
        {
            "line": "于今腐草无萤火，终古垂杨有暮鸦",
            "poemId": "poem_460"
        }
    ],
    "翠": [
        {
            "line": "翠华想像空山里，玉殿虚无野寺中",
            "poemId": "poem_461"
        },
        {
            "line": "翠华摇摇行复止，西出都门百余里",
            "poemId": "poem_526"
        },
        {
            "line": "翠影红霞映朝日，鸟飞不到吴天长",
            "poemId": "poem_540"
        },
        {
            "line": "翠微盍叶垂鬓唇",
            "poemId": "poem_586"
        }
    ],
    "武": [
        {
            "line": "武侯祠堂常邻近，一体君臣祭祀同",
            "poemId": "poem_461"
        },
        {
            "line": "武帝祠前云欲散，仙人掌上雨初晴",
            "poemId": "poem_479"
        }
    ],
    "最": [
        {
            "line": "最是楚宫俱泯灭，舟人指点到今疑",
            "poemId": "poem_464"
        }
    ],
    "诸": [
        {
            "line": "诸葛大名垂宇宙，宗臣遗像肃清高",
            "poemId": "poem_465"
        }
    ],
    "伯": [
        {
            "line": "伯仲之间见伊吕，指挥若定失萧曹",
            "poemId": "poem_465"
        }
    ],
    "运": [
        {
            "line": "运移汉祚终难复，志决身歼军务劳",
            "poemId": "poem_465"
        },
        {
            "line": "运命惟所遇，循环不可寻",
            "poemId": "poem_525"
        }
    ],
    "剑": [
        {
            "line": "剑外忽传收蓟北，初闻涕泪满衣裳",
            "poemId": "poem_467"
        },
        {
            "line": "剑河风急雪片阔，沙口石冻马蹄脱",
            "poemId": "poem_532"
        }
    ],
    "即": [
        {
            "line": "即从巴峡穿巫峡，便下襄阳向洛阳",
            "poemId": "poem_467"
        },
        {
            "line": "即此羡闲逸，怅然吟式微",
            "poemId": "poem_493"
        },
        {
            "line": "即今漂泊干戈际，屡貌寻常行路人",
            "poemId": "poem_544"
        }
    ],
    "支": [
        {
            "line": "支离东北风尘际，漂泊西南天地间",
            "poemId": "poem_469"
        }
    ],
    "羯": [
        {
            "line": "羯胡事主终无赖，词客哀时且未还",
            "poemId": "poem_469"
        }
    ],
    "庾": [
        {
            "line": "庾信平生最萧瑟，暮年诗赋动江关",
            "poemId": "poem_469"
        }
    ],
    "惊": [
        {
            "line": "惊风乱飐芙蓉水，密雨斜侵薜荔墙",
            "poemId": "poem_470"
        },
        {
            "line": "惊闻俗客争来集，竞引还家问都邑",
            "poemId": "poem_564"
        }
    ],
    "丞": [
        {
            "line": "丞相祠堂何处寻，锦官城外柏森森",
            "poemId": "poem_471"
        }
    ],
    "映": [
        {
            "line": "映阶碧草自春色，隔叶黄鹂空好音",
            "poemId": "poem_471"
        }
    ],
    "舍": [
        {
            "line": "舍南舍北皆春水，但见群鸥日日来",
            "poemId": "poem_472"
        }
    ],
    "盘": [
        {
            "line": "盘飧市远无兼味，樽酒家贫只旧醅",
            "poemId": "poem_472"
        },
        {
            "line": "盘赐将军拜舞归，轻纨细绮相追飞",
            "poemId": "poem_547"
        }
    ],
    "肯": [
        {
            "line": "肯与邻翁相对饮，隔篱呼取尽馀杯",
            "poemId": "poem_472"
        }
    ],
    "艰": [
        {
            "line": "艰难苦恨繁霜鬓，潦倒新停浊酒杯",
            "poemId": "poem_473"
        }
    ],
    "莺": [
        {
            "line": "莺啼燕语报新年，马邑龙堆路几千",
            "poemId": "poem_474"
        }
    ],
    "敢": [
        {
            "line": "敢将十指夸针巧，不把双眉斗画长",
            "poemId": "poem_476"
        }
    ],
    "苦": [
        {
            "line": "苦恨年年压金线，为他人作嫁衣裳",
            "poemId": "poem_476"
        },
        {
            "line": "苦心岂免容蝼蚁，香叶终经宿鸾凤",
            "poemId": "poem_541"
        }
    ],
    "且": [
        {
            "line": "且欲近寻彭泽宰，陶然共醉菊花杯",
            "poemId": "poem_477"
        },
        {
            "line": "且放白鹿青崖间",
            "poemId": "poem_534"
        },
        {
            "line": "且乐生前一杯酒，何须身后千载名",
            "poemId": "poem_573"
        },
        {
            "line": "且如今年冬，未休关西卒",
            "poemId": "poem_583"
        }
    ],
    "晴": [
        {
            "line": "晴川历历汉阳树，芳草萋萋鹦鹉洲",
            "poemId": "poem_478"
        }
    ],
    "岧": [
        {
            "line": "岧峣太华俯咸京，天外三峰削不成",
            "poemId": "poem_479"
        }
    ],
    "澹": [
        {
            "line": "澹然空水对斜晖，曲岛苍茫接翠微",
            "poemId": "poem_481"
        },
        {
            "line": "澹然离言说，悟悦心自足",
            "poemId": "poem_509"
        }
    ],
    "数": [
        {
            "line": "数丛沙草群鸥散，万顷江田一鹭飞",
            "poemId": "poem_481"
        }
    ],
    "茂": [
        {
            "line": "茂陵不见封侯印，空向秋波哭逝川",
            "poemId": "poem_484"
        }
    ],
    "汀": [
        {
            "line": "汀洲无浪复无烟，楚客相思益渺然",
            "poemId": "poem_486"
        }
    ],
    "估": [
        {
            "line": "估客昼眠知浪静，舟人夜语觉潮生",
            "poemId": "poem_487"
        }
    ],
    "献": [
        {
            "line": "献赋十年犹未遇，羞将白发对华簪",
            "poemId": "poem_488"
        }
    ],
    "锁": [
        {
            "line": "锁衔金兽连环冷，水滴铜龙昼漏长",
            "poemId": "poem_489"
        }
    ],
    "仙": [
        {
            "line": "仙台初见五城楼，风物凄凄宿雨收",
            "poemId": "poem_490"
        }
    ],
    "冉": [
        {
            "line": "冉冉几盈虚，澄澄变今古",
            "poemId": "poem_492"
        }
    ],
    "雉": [
        {
            "line": "雉雊麦苗秀，蚕眠桑叶稀",
            "poemId": "poem_493"
        }
    ],
    "言": [
        {
            "line": "言入黄花川，每逐清溪水",
            "poemId": "poem_494"
        },
        {
            "line": "言迟更速皆应手，将往复旋如有情",
            "poemId": "poem_537"
        }
    ],
    "声": [
        {
            "line": "声喧乱石中，色静深松里",
            "poemId": "poem_494"
        }
    ],
    "漾": [
        {
            "line": "漾漾泛菱荇，澄澄映葭苇",
            "poemId": "poem_494"
        }
    ],
    "请": [
        {
            "line": "请留磐石上，垂钓将已矣",
            "poemId": "poem_494"
        },
        {
            "line": "请君试问东流水，别意与之谁短长",
            "poemId": "poem_535"
        }
    ],
    "遂": [
        {
            "line": "遂令东山客，不得顾采薇",
            "poemId": "poem_495"
        },
        {
            "line": "遂令天下父母心，不重生男重生女",
            "poemId": "poem_526"
        }
    ],
    "置": [
        {
            "line": "置酒长安道，同心与我违",
            "poemId": "poem_495"
        }
    ],
    "艳": [
        {
            "line": "艳色天下重，西施宁久微",
            "poemId": "poem_496"
        }
    ],
    "邀": [
        {
            "line": "邀人傅香粉，不自著罗衣",
            "poemId": "poem_496"
        }
    ],
    "持": [
        {
            "line": "持谢邻家子，效颦安可希",
            "poemId": "poem_496"
        },
        {
            "line": "持此谢高鸟，因之传远情",
            "poemId": "poem_527"
        }
    ],
    "塔": [
        {
            "line": "塔势如涌出，孤高耸天宫",
            "poemId": "poem_497"
        }
    ],
    "突": [
        {
            "line": "突兀压神州，峥嵘如鬼工",
            "poemId": "poem_497"
        }
    ],
    "似": [
        {
            "line": "似 一作：如)青槐夹驰道，宫馆何玲珑",
            "poemId": "poem_497"
        },
        {
            "line": "似闻昨者赤松子，恐是汉代韩张良",
            "poemId": "poem_546"
        }
    ],
    "净": [
        {
            "line": "净理了可悟，胜因夙所宗",
            "poemId": "poem_497"
        }
    ],
    "暂": [
        {
            "line": "暂伴月将影，行乐须及春",
            "poemId": "poem_498"
        }
    ],
    "醒": [
        {
            "line": "醒时同交欢，醉后各分散",
            "poemId": "poem_498"
        }
    ],
    "恐": [
        {
            "line": "恐非平生魂，路远不可测",
            "poemId": "poem_501"
        },
        {
            "line": "恐非平生魂，路远不可测",
            "poemId": "poem_501"
        }
    ],
    "魂": [
        {
            "line": "魂来枫林青，魂返关塞黑",
            "poemId": "poem_501"
        },
        {
            "line": "魂来枫林青，魂返关塞黑",
            "poemId": "poem_501"
        }
    ],
    "井": [
        {
            "line": "井税有常期，日晏犹得眠",
            "poemId": "poem_502"
        }
    ],
    "是": [
        {
            "line": "是以陷邻境，此州独见全",
            "poemId": "poem_502"
        },
        {
            "line": "是日牵来赤墀下，迥立阊阖生长风",
            "poemId": "poem_544"
        }
    ],
    "使": [
        {
            "line": "使臣将王命，岂不如贼焉",
            "poemId": "poem_502"
        }
    ],
    "告": [
        {
            "line": "告归常局促，苦道来不易",
            "poemId": "poem_503"
        }
    ],
    "冠": [
        {
            "line": "冠盖满京华，斯人独憔悴",
            "poemId": "poem_503"
        }
    ],
    "孰": [
        {
            "line": "孰云网恢恢，将老身反累",
            "poemId": "poem_503"
        }
    ],
    "岱": [
        {
            "line": "岱宗夫如何",
            "poemId": "poem_504"
        }
    ],
    "齐": [
        {
            "line": "齐鲁青未了",
            "poemId": "poem_504"
        }
    ],
    "造": [
        {
            "line": "造化钟神秀，阴阳割昏晓",
            "poemId": "poem_504"
        }
    ],
    "鬓": [
        {
            "line": "鬓发各已苍",
            "poemId": "poem_505"
        }
    ],
    "访": [
        {
            "line": "访旧半为鬼，惊呼热中肠",
            "poemId": "poem_505"
        }
    ],
    "焉": [
        {
            "line": "焉知二十载，重上君子堂",
            "poemId": "poem_505"
        }
    ],
    "怡": [
        {
            "line": "怡然敬父执，问我来何方",
            "poemId": "poem_505"
        }
    ],
    "主": [
        {
            "line": "主称会面难，一举累十觞",
            "poemId": "poem_505"
        },
        {
            "line": "主人下马客在船，举酒欲饮无管弦",
            "poemId": "poem_529"
        },
        {
            "line": "主人有酒欢今夕，请奏鸣琴广陵客",
            "poemId": "poem_539"
        },
        {
            "line": "主人何为言少钱，径须沽取对君酌",
            "poemId": "poem_570"
        }
    ],
    "官": [
        {
            "line": "官高何足论，不得收骨肉",
            "poemId": "poem_506"
        }
    ],
    "合": [
        {
            "line": "合昏尚知时，鸳鸯不独宿",
            "poemId": "poem_506"
        }
    ],
    "在": [
        {
            "line": "在山泉水清，出山泉水浊",
            "poemId": "poem_506"
        },
        {
            "line": "在天愿作比翼鸟，在地愿为连理枝",
            "poemId": "poem_526"
        }
    ],
    "侍": [
        {
            "line": "侍婢卖珠回，牵萝补茅屋",
            "poemId": "poem_506"
        },
        {
            "line": "侍儿扶起娇无力，始是新承恩泽时",
            "poemId": "poem_526"
        }
    ],
    "摘": [
        {
            "line": "摘花不插发，采柏动盈掬",
            "poemId": "poem_506"
        }
    ],
    "扣": [
        {
            "line": "扣关无僮仆，窥室唯案几",
            "poemId": "poem_508"
        }
    ],
    "差": [
        {
            "line": "差池不相见，黾勉空仰止",
            "poemId": "poem_508"
        }
    ],
    "汲": [
        {
            "line": "汲井漱寒齿，清心拂尘服",
            "poemId": "poem_509"
        }
    ],
    "真": [
        {
            "line": "真源了无取，妄迹世所逐",
            "poemId": "poem_509"
        },
        {
            "line": "真成薄命久寻思，梦见君王觉后疑",
            "poemId": "poem_563"
        }
    ],
    "散": [
        {
            "line": "散发乘夕凉，开轩卧闲敞",
            "poemId": "poem_511"
        },
        {
            "line": "散入珠帘湿罗幕，狐裘不暖锦衾薄",
            "poemId": "poem_530"
        }
    ],
    "幼": [
        {
            "line": "幼为长所育，两别泣不休",
            "poemId": "poem_515"
        }
    ],
    "赖": [
        {
            "line": "赖兹托令门，任恤庶无尤",
            "poemId": "poem_515"
        }
    ],
    "贫": [
        {
            "line": "贫俭诚所尚，资从岂待周",
            "poemId": "poem_515"
        }
    ],
    "孝": [
        {
            "line": "孝恭遵妇道，容止顺其猷",
            "poemId": "poem_515"
        }
    ],
    "吏": [
        {
            "line": "吏舍跼终年，出郊旷清曙",
            "poemId": "poem_517"
        }
    ],
    "杨": [
        {
            "line": "杨柳散和风，青山澹吾虑",
            "poemId": "poem_517"
        },
        {
            "line": "杨家有女初长成，养在深闺人未识",
            "poemId": "poem_526"
        },
        {
            "line": "杨花雪落覆白苹，青鸟飞去衔红巾",
            "poemId": "poem_586"
        }
    ],
    "依": [
        {
            "line": "依丛适自憩，缘涧还复去",
            "poemId": "poem_517"
        }
    ],
    "兵": [
        {
            "line": "兵卫森画戟，宴寝凝清香",
            "poemId": "poem_518"
        }
    ],
    "理": [
        {
            "line": "理会是非遣，性达形迹忘",
            "poemId": "poem_518"
        }
    ],
    "鲜": [
        {
            "line": "鲜肥属时禁，蔬果幸见尝",
            "poemId": "poem_518"
        }
    ],
    "涧": [
        {
            "line": "涧底束荆薪，归来煮白石",
            "poemId": "poem_519"
        }
    ],
    "侧": [
        {
            "line": "侧见双翠鸟，巢在三珠树",
            "poemId": "poem_521"
        }
    ],
    "矫": [
        {
            "line": "矫矫珍木巅，得无金丸惧",
            "poemId": "poem_521"
        }
    ],
    "欣": [
        {
            "line": "欣欣此生意，自尔为佳节",
            "poemId": "poem_523"
        }
    ],
    "际": [
        {
            "line": "际夜转西壑，隔山望南斗",
            "poemId": "poem_524"
        }
    ],
    "潭": [
        {
            "line": "潭烟飞溶溶，林月低向后",
            "poemId": "poem_524"
        }
    ],
    "后": [
        {
            "line": "后宫佳丽三千人，三千宠爱在一身",
            "poemId": "poem_526"
        },
        {
            "line": "后来鞍马何逡巡，当轩下马入锦茵",
            "poemId": "poem_586"
        }
    ],
    "姊": [
        {
            "line": "姊妹弟兄皆列土，可怜光彩生门户",
            "poemId": "poem_526"
        }
    ],
    "骊": [
        {
            "line": "骊宫高处入青云，仙乐风飘处处闻",
            "poemId": "poem_526"
        }
    ],
    "缓": [
        {
            "line": "缓歌慢舞凝丝竹，尽日君王看不足",
            "poemId": "poem_526"
        }
    ],
    "渔": [
        {
            "line": "渔阳鼙鼓动地来，惊破霓裳羽衣曲",
            "poemId": "poem_526"
        },
        {
            "line": "渔翁夜傍西岩宿，晓汲清湘燃楚竹",
            "poemId": "poem_549"
        },
        {
            "line": "渔舟逐水爱山春，两岸桃花夹古津",
            "poemId": "poem_564"
        }
    ],
    "芙": [
        {
            "line": "芙蓉如面柳如眉，对此如何不泪垂",
            "poemId": "poem_526"
        },
        {
            "line": "芙蓉旌旗烟雾落，影动倒景摇潇湘",
            "poemId": "poem_546"
        }
    ],
    "迟": [
        {
            "line": "迟迟钟鼓初长夜，耿耿星河欲曙天",
            "poemId": "poem_526"
        }
    ],
    "鸳": [
        {
            "line": "鸳鸯瓦冷霜华重，翡翠衾寒谁与共",
            "poemId": "poem_526"
        }
    ],
    "排": [
        {
            "line": "排空驭气奔如电，升天入地求之遍",
            "poemId": "poem_526"
        }
    ],
    "揽": [
        {
            "line": "揽衣推枕起徘徊，珠箔银屏迤逦开",
            "poemId": "poem_526"
        }
    ],
    "昭": [
        {
            "line": "昭阳殿里恩爱绝，蓬莱宫中日月长",
            "poemId": "poem_526"
        },
        {
            "line": "昭王白骨萦蔓草，谁人更扫黄金台",
            "poemId": "poem_567"
        },
        {
            "line": "昭阳殿里第一人，同辇随君侍君侧",
            "poemId": "poem_587"
        }
    ],
    "钗": [
        {
            "line": "钗留一股合一扇，钗擘黄金合分钿",
            "poemId": "poem_526"
        }
    ],
    "序": [
        {
            "line": "序：漫叟以公田米酿酒，因休暇，则载酒于湖上，时取一醉",
            "poemId": "poem_528"
        }
    ],
    "乃": [
        {
            "line": "乃作歌以长之",
            "poemId": "poem_528"
        }
    ],
    "浔": [
        {
            "line": "浔阳江头夜送客，枫叶荻花秋瑟瑟",
            "poemId": "poem_529"
        },
        {
            "line": "浔阳地僻无音乐，终岁不闻丝竹声",
            "poemId": "poem_529"
        }
    ],
    "琵": [
        {
            "line": "琵琶声停欲语迟",
            "poemId": "poem_529"
        }
    ],
    "转": [
        {
            "line": "转轴拨弦三两声，未成曲调先有情",
            "poemId": "poem_529"
        }
    ],
    "轻": [
        {
            "line": "轻拢慢捻抹复挑，初为《霓裳》后《六幺》（六幺 一作：绿腰）",
            "poemId": "poem_529"
        }
    ],
    "嘈": [
        {
            "line": "嘈嘈切切错杂弹，大珠小珠落玉盘",
            "poemId": "poem_529"
        }
    ],
    "间": [
        {
            "line": "间关莺语花底滑，幽咽泉流冰下难",
            "poemId": "poem_529"
        }
    ],
    "钿": [
        {
            "line": "钿头银篦击节碎，血色罗裙翻酒污",
            "poemId": "poem_529"
        }
    ],
    "弟": [
        {
            "line": "弟走从军阿姨死，暮去朝来颜色故",
            "poemId": "poem_529"
        },
        {
            "line": "弟子韩干早入室，亦能画马穷殊相",
            "poemId": "poem_544"
        }
    ],
    "住": [
        {
            "line": "住近湓江地低湿，黄芦苦竹绕宅生",
            "poemId": "poem_529"
        }
    ],
    "杜": [
        {
            "line": "杜鹃啼血猿哀鸣",
            "poemId": "poem_529"
        }
    ],
    "呕": [
        {
            "line": "呕哑嘲哳难为听",
            "poemId": "poem_529"
        }
    ],
    "纷": [
        {
            "line": "纷纷暮雪下辕门，风掣红旗冻不翻",
            "poemId": "poem_530"
        }
    ],
    "轮": [
        {
            "line": "轮台东门送君去，去时雪满天山路",
            "poemId": "poem_530"
        },
        {
            "line": "轮台城头夜吹角，轮台城北旄头落",
            "poemId": "poem_532"
        }
    ],
    "虏": [
        {
            "line": "虏塞兵气连云屯，战场白骨缠草根",
            "poemId": "poem_532"
        }
    ],
    "俱": [
        {
            "line": "俱怀逸兴壮思飞，欲上青天览明月",
            "poemId": "poem_533"
        }
    ],
    "脚": [
        {
            "line": "脚著谢公屐，身登青云梯",
            "poemId": "poem_534"
        }
    ],
    "熊": [
        {
            "line": "熊咆龙吟殷岩泉，栗深林兮惊层巅",
            "poemId": "poem_534"
        }
    ],
    "列": [
        {
            "line": "列缺霹雳，丘峦崩摧",
            "poemId": "poem_534"
        }
    ],
    "虎": [
        {
            "line": "虎鼓瑟兮鸾回车，仙之人兮列如麻",
            "poemId": "poem_534"
        }
    ],
    "须": [
        {
            "line": "须行即骑访名山",
            "poemId": "poem_534"
        },
        {
            "line": "须臾静扫众峰出，仰见突兀撑青空",
            "poemId": "poem_553"
        }
    ],
    "元": [
        {
            "line": "元和天子神武姿，彼何人哉轩与羲",
            "poemId": "poem_536"
        }
    ],
    "腰": [
        {
            "line": "腰悬相印作都统，阴风惨澹天王旗",
            "poemId": "poem_536"
        },
        {
            "line": "腰下宝玦青珊瑚，可怜王孙泣路隅",
            "poemId": "poem_585"
        }
    ],
    "愬": [
        {
            "line": "愬武古通作牙爪，仪曹外郎载笔随",
            "poemId": "poem_536"
        }
    ],
    "愈": [
        {
            "line": "愈拜稽首蹈且舞，金石刻画臣能为",
            "poemId": "poem_536"
        }
    ],
    "公": [
        {
            "line": "公退斋戒坐小阁，濡染大笔何淋漓",
            "poemId": "poem_536"
        },
        {
            "line": "公之斯文若元气，先时已入人肝脾",
            "poemId": "poem_536"
        },
        {
            "line": "公之斯文不示后，曷与三五相攀追",
            "poemId": "poem_536"
        },
        {
            "line": "公从何处得纸本，毫发尽备无差讹",
            "poemId": "poem_551"
        }
    ],
    "点": [
        {
            "line": "点窜《尧典》《舜典》字，涂改《清庙》《生民》诗",
            "poemId": "poem_536"
        }
    ],
    "碑": [
        {
            "line": "碑高三丈字如斗，负以灵鳌蟠以螭",
            "poemId": "poem_536"
        }
    ],
    "句": [
        {
            "line": "句奇语重喻者少，谗之天子言其私",
            "poemId": "poem_536"
        }
    ],
    "汤": [
        {
            "line": "汤盘孔鼎有述作，今无其器存其辞",
            "poemId": "poem_536"
        }
    ],
    "传": [
        {
            "line": "传之七十有二代，以为封禅玉检明堂基",
            "poemId": "poem_536"
        }
    ],
    "蔡": [
        {
            "line": "蔡女昔造胡笳声，一弹一十有八拍",
            "poemId": "poem_537"
        }
    ],
    "董": [
        {
            "line": "董夫子，通神明，深山窃听来妖精",
            "poemId": "poem_537"
        }
    ],
    "嘶": [
        {
            "line": "嘶酸雏雁失群夜，断绝胡儿恋母声",
            "poemId": "poem_537"
        }
    ],
    "川": [
        {
            "line": "川为静其波，鸟亦罢其鸣",
            "poemId": "poem_537"
        }
    ],
    "乌": [
        {
            "line": "乌孙部落家乡远，逻娑沙尘哀怨生",
            "poemId": "poem_537"
        }
    ],
    "迸": [
        {
            "line": "迸泉飒飒飞木末，野鹿呦呦走堂下",
            "poemId": "poem_537"
        }
    ],
    "傍": [
        {
            "line": "傍邻闻者多叹息，远客思乡皆泪垂",
            "poemId": "poem_538"
        }
    ],
    "枯": [
        {
            "line": "枯桑老柏寒飕飗， 九雏鸣凤乱啾啾",
            "poemId": "poem_538"
        }
    ],
    "龙": [
        {
            "line": "龙吟虎啸一时发，万籁百泉相与秋",
            "poemId": "poem_538"
        }
    ],
    "变": [
        {
            "line": "变调如闻杨柳春， 上林繁花照眼新",
            "poemId": "poem_538"
        }
    ],
    "铜": [
        {
            "line": "铜炉华烛烛增辉，初弹渌水后楚妃",
            "poemId": "poem_539"
        }
    ],
    "庐": [
        {
            "line": "庐山秀出南斗傍，屏风九叠云锦张",
            "poemId": "poem_540"
        }
    ],
    "影": [
        {
            "line": "影落明湖青黛光，金阙前开二峰长，银河倒挂三石梁",
            "poemId": "poem_540"
        }
    ],
    "香": [
        {
            "line": "香炉瀑布遥相望，回崖沓嶂凌苍苍",
            "poemId": "poem_540"
        }
    ],
    "先": [
        {
            "line": "先期汗漫九垓上，愿接卢敖游太清",
            "poemId": "poem_540"
        },
        {
            "line": "先帝侍女八千人，公孙剑器初第一",
            "poemId": "poem_542"
        },
        {
            "line": "先帝御马五花骢，画工如山貌不同",
            "poemId": "poem_544"
        }
    ],
    "孔": [
        {
            "line": "孔明庙前有老柏，柯如青铜根如石",
            "poemId": "poem_541"
        },
        {
            "line": "孔子西行不到秦，掎摭星宿遗羲娥",
            "poemId": "poem_551"
        }
    ],
    "忆": [
        {
            "line": "忆昨路绕锦亭东，先主武侯同閟宫",
            "poemId": "poem_541"
        },
        {
            "line": "忆昔巡幸新丰宫，翠华拂天来向东",
            "poemId": "poem_547"
        },
        {
            "line": "忆昔初蒙博士征，其年始改称元和",
            "poemId": "poem_551"
        },
        {
            "line": "忆君迢迢隔青天，昔日横波目，今作流泪泉",
            "poemId": "poem_574"
        },
        {
            "line": "忆昔霓旌下南苑，苑中万物生颜色",
            "poemId": "poem_587"
        }
    ],
    "崔": [
        {
            "line": "崔嵬枝干郊原古，窈窕丹青户牖空",
            "poemId": "poem_541"
        }
    ],
    "扶": [
        {
            "line": "扶持自是神明力，正直原因造化工",
            "poemId": "poem_541"
        }
    ],
    "志": [
        {
            "line": "志士幽人莫怨嗟：古来材大难为用",
            "poemId": "poem_541"
        }
    ],
    "观": [
        {
            "line": "观者如山色沮丧，天地为之久低昂",
            "poemId": "poem_542"
        },
        {
            "line": "观经鸿都尚填咽，坐见举国来奔波",
            "poemId": "poem_551"
        }
    ],
    "霍": [
        {
            "line": "霍如羿射九日落，矫如群帝骖龙翔",
            "poemId": "poem_542"
        }
    ],
    "绛": [
        {
            "line": "绛唇珠袖两寂寞，晚有弟子传芬芳",
            "poemId": "poem_542"
        }
    ],
    "梨": [
        {
            "line": "梨园弟子散如烟，女乐余姿映寒日",
            "poemId": "poem_542"
        }
    ],
    "玳": [
        {
            "line": "玳筵急管曲复终，乐极哀来月东出",
            "poemId": "poem_542"
        }
    ],
    "陈": [
        {
            "line": "陈侯立身何坦荡，虬须虎眉仍大颡",
            "poemId": "poem_543"
        }
    ],
    "郑": [
        {
            "line": "郑国游人未及家，洛阳行子空叹息",
            "poemId": "poem_543"
        }
    ],
    "学": [
        {
            "line": "学书初学卫夫人，但恨无过王右军",
            "poemId": "poem_544"
        }
    ],
    "褒": [
        {
            "line": "褒公鄂公毛发动，英姿飒爽来酣战",
            "poemId": "poem_544"
        }
    ],
    "诏": [
        {
            "line": "诏谓将军拂绢素，意匠惨澹经营中",
            "poemId": "poem_544"
        }
    ],
    "斯": [
        {
            "line": "斯须九重真龙出，一洗万古凡马空",
            "poemId": "poem_544"
        }
    ],
    "干": [
        {
            "line": "干惟画肉不画骨，忍使骅骝气凋丧",
            "poemId": "poem_544"
        }
    ],
    "途": [
        {
            "line": "途穷反遭俗眼白，世上未有如公贫",
            "poemId": "poem_544"
        }
    ],
    "男": [
        {
            "line": "男儿事长征，少小幽燕客",
            "poemId": "poem_545"
        },
        {
            "line": "男儿本自重横行，天子非常赐颜色",
            "poemId": "poem_591"
        }
    ],
    "赌": [
        {
            "line": "赌胜马蹄下，由来轻七尺",
            "poemId": "poem_545"
        }
    ],
    "辽": [
        {
            "line": "辽东小妇年十五，惯弹琵琶解歌舞",
            "poemId": "poem_545"
        }
    ],
    "内": [
        {
            "line": "内府殷红玛瑙盘，婕妤传诏才人索",
            "poemId": "poem_547"
        }
    ],
    "贵": [
        {
            "line": "贵戚权门得笔迹，始觉屏障生光辉",
            "poemId": "poem_547"
        }
    ],
    "鹿": [
        {
            "line": "鹿门月照开烟树，忽到庞公栖隐处",
            "poemId": "poem_548"
        }
    ],
    "岩": [
        {
            "line": "岩扉松径长寂寥，惟有幽人自来去",
            "poemId": "poem_548"
        }
    ],
    "张": [
        {
            "line": "张生手持石鼓文，劝我试作石鼓歌",
            "poemId": "poem_551"
        }
    ],
    "蒐": [
        {
            "line": "蒐于岐阳骋雄俊，万里禽兽皆遮罗",
            "poemId": "poem_551"
        }
    ],
    "镌": [
        {
            "line": "镌功勒成告万世，凿石作鼓隳嵯峨",
            "poemId": "poem_551"
        }
    ],
    "辞": [
        {
            "line": "辞严义密读难晓，字体不类隶与蝌",
            "poemId": "poem_551"
        }
    ],
    "鸾": [
        {
            "line": "鸾翔凤翥众仙下，珊瑚碧树交枝柯",
            "poemId": "poem_551"
        }
    ],
    "陋": [
        {
            "line": "陋儒编诗不收入，二雅褊迫无委蛇",
            "poemId": "poem_551"
        }
    ],
    "濯": [
        {
            "line": "濯冠沐浴告祭酒，如此至宝存岂多",
            "poemId": "poem_551"
        }
    ],
    "毡": [
        {
            "line": "毡包席裹可立致，十鼓只载数骆驼",
            "poemId": "poem_551"
        }
    ],
    "荐": [
        {
            "line": "荐诸太庙比郜鼎，光价岂止百倍过",
            "poemId": "poem_551"
        }
    ],
    "剜": [
        {
            "line": "剜苔剔藓露节角，安置妥帖平不颇",
            "poemId": "poem_551"
        }
    ],
    "羲": [
        {
            "line": "羲之俗书趁姿媚，数纸尚可博白鹅",
            "poemId": "poem_551"
        }
    ],
    "继": [
        {
            "line": "继周八代争战罢，无人收拾理则那",
            "poemId": "poem_551"
        }
    ],
    "升": [
        {
            "line": "升堂坐阶新雨足，芭蕉叶大栀子肥",
            "poemId": "poem_552"
        },
        {
            "line": "升阶伛偻荐脯酒，欲以菲薄明其衷",
            "poemId": "poem_553"
        }
    ],
    "僧": [
        {
            "line": "僧言古壁佛画好，以火来照所见稀",
            "poemId": "poem_552"
        }
    ],
    "铺": [
        {
            "line": "铺床拂席置羹饭，疏粝亦足饱我饥",
            "poemId": "poem_552"
        }
    ],
    "火": [
        {
            "line": "火维地荒足妖怪，天假神柄专其雄",
            "poemId": "poem_553"
        },
        {
            "line": "火照西宫知夜饮，分明复道奉恩时",
            "poemId": "poem_563"
        }
    ],
    "喷": [
        {
            "line": "喷云泄雾藏半腹，虽有绝顶谁能穷",
            "poemId": "poem_553"
        }
    ],
    "潜": [
        {
            "line": "潜心默祷若有应，岂非正直能感通",
            "poemId": "poem_553"
        }
    ],
    "森": [
        {
            "line": "森然魄动下马拜，松柏一径趋灵宫",
            "poemId": "poem_553"
        }
    ],
    "庙": [
        {
            "line": "庙令老人识神意，睢盱侦伺能鞠躬",
            "poemId": "poem_553"
        }
    ],
    "窜": [
        {
            "line": "窜逐蛮荒幸不死，衣食才足甘长终",
            "poemId": "poem_553"
        }
    ],
    "侯": [
        {
            "line": "侯王将相望久绝，神纵欲福难为功",
            "poemId": "poem_553"
        }
    ],
    "赦": [
        {
            "line": "赦书一日行万里，罪从大辟皆除死",
            "poemId": "poem_554"
        }
    ],
    "迁": [
        {
            "line": "迁者追回流者还，涤瑕荡垢清朝班",
            "poemId": "poem_554"
        }
    ],
    "判": [
        {
            "line": "判司卑官不堪说，未免捶楚尘埃间",
            "poemId": "poem_554"
        }
    ],
    "羌": [
        {
            "line": "羌笛何须怨杨柳，春风不度玉门关",
            "poemId": "poem_555"
        }
    ],
    "秦": [
        {
            "line": "秦时明月汉时关，万里长征人未还",
            "poemId": "poem_556"
        },
        {
            "line": "秦地罗敷女，采桑绿水边",
            "poemId": "poem_579"
        }
    ],
    "桂": [
        {
            "line": "桂魄初生秋露微，轻罗已薄未更衣",
            "poemId": "poem_560"
        }
    ],
    "射": [
        {
            "line": "射杀中山白额虎，肯数邺下黄须儿",
            "poemId": "poem_561"
        }
    ],
    "卫": [
        {
            "line": "卫青不败由天幸，李广无功缘数奇",
            "poemId": "poem_561"
        }
    ],
    "贺": [
        {
            "line": "贺兰山下阵如云，羽檄交驰日夕闻",
            "poemId": "poem_561"
        }
    ],
    "节": [
        {
            "line": "节使三河募年少，诏书五道出将军",
            "poemId": "poem_561"
        }
    ],
    "罗": [
        {
            "line": "罗帷送上七香车，宝扇迎归九华帐",
            "poemId": "poem_562"
        }
    ],
    "狂": [
        {
            "line": "狂夫富贵在青春，意气骄奢剧季伦",
            "poemId": "poem_562"
        }
    ],
    "戏": [
        {
            "line": "戏罢曾无理曲时，妆成祗是熏香坐",
            "poemId": "poem_562"
        }
    ],
    "熏": [
        {
            "line": "熏笼玉枕无颜色，卧听南宫清漏长",
            "poemId": "poem_563"
        }
    ],
    "奉": [
        {
            "line": "奉帚平明金殿开，暂将团扇共徘徊",
            "poemId": "poem_563"
        }
    ],
    "樵": [
        {
            "line": "樵客初传汉姓名，居人未改秦衣服",
            "poemId": "poem_564"
        }
    ],
    "峡": [
        {
            "line": "峡里谁知有人事，世中遥望空云山",
            "poemId": "poem_564"
        }
    ],
    "羞": [
        {
            "line": "羞逐长安社中儿，赤鸡白雉赌梨粟",
            "poemId": "poem_567"
        }
    ],
    "弹": [
        {
            "line": "弹剑作歌奏苦声，曳裾王门不称情",
            "poemId": "poem_567"
        }
    ],
    "剧": [
        {
            "line": "剧辛乐毅感恩分，输肝剖胆效英才",
            "poemId": "poem_567"
        }
    ],
    "烹": [
        {
            "line": "烹羊宰牛且为乐，会须一饮三百杯",
            "poemId": "poem_570"
        }
    ],
    "岑": [
        {
            "line": "岑夫子，丹丘生，将进酒，杯莫停",
            "poemId": "poem_570"
        }
    ],
    "络": [
        {
            "line": "络纬秋啼金井阑，微霜凄凄簟色寒",
            "poemId": "poem_572"
        }
    ],
    "含": [
        {
            "line": "含光混世贵无名，何用孤高比云月",
            "poemId": "poem_573"
        }
    ],
    "陆": [
        {
            "line": "陆机雄才岂自保",
            "poemId": "poem_573"
        }
    ],
    "华": [
        {
            "line": "华亭鹤唳讵可闻",
            "poemId": "poem_573"
        }
    ],
    "赵": [
        {
            "line": "赵瑟初停凤凰柱，蜀琴欲奏鸳鸯弦",
            "poemId": "poem_574"
        }
    ],
    "妾": [
        {
            "line": "妾发初覆额，折花门前剧",
            "poemId": "poem_575"
        }
    ],
    "苔": [
        {
            "line": "苔深不能扫，落叶秋风早",
            "poemId": "poem_575"
        }
    ],
    "噫": [
        {
            "line": "噫吁嚱，危乎高哉",
            "poemId": "poem_576"
        }
    ],
    "蚕": [
        {
            "line": "蚕丛及鱼凫，开国何茫然",
            "poemId": "poem_576"
        },
        {
            "line": "蚕饥妾欲去，五马莫留连",
            "poemId": "poem_579"
        }
    ],
    "扪": [
        {
            "line": "扪参历井仰胁息，以手抚膺坐长叹",
            "poemId": "poem_576"
        }
    ],
    "畏": [
        {
            "line": "畏途巉岩不可攀",
            "poemId": "poem_576"
        }
    ],
    "镜": [
        {
            "line": "镜湖三百里，菡萏发荷花",
            "poemId": "poem_577"
        }
    ],
    "裁": [
        {
            "line": "裁缝寄远道，几日到临洮",
            "poemId": "poem_580"
        }
    ],
    "由": [
        {
            "line": "由来征战地，不见有人还",
            "poemId": "poem_581"
        }
    ],
    "嫁": [
        {
            "line": "嫁得瞿塘贾，朝朝误妾期",
            "poemId": "poem_582"
        }
    ],
    "车": [
        {
            "line": "车辚辚，马萧萧，行人弓箭各在腰",
            "poemId": "poem_583"
        }
    ],
    "耶": [
        {
            "line": "耶娘妻子走相送，尘埃不见咸阳桥",
            "poemId": "poem_583"
        }
    ],
    "或": [
        {
            "line": "或从十五北防河，便至四十西营田",
            "poemId": "poem_583"
        }
    ],
    "纵": [
        {
            "line": "纵有健妇把锄犁，禾生陇亩无东西",
            "poemId": "poem_583"
        }
    ],
    "况": [
        {
            "line": "况复秦兵耐苦战，被驱不异犬与鸡",
            "poemId": "poem_583"
        }
    ],
    "县": [
        {
            "line": "县官急索租，租税从何出",
            "poemId": "poem_583"
        }
    ],
    "信": [
        {
            "line": "信知生男恶，反是生女好",
            "poemId": "poem_583"
        }
    ],
    "豺": [
        {
            "line": "豺狼在邑龙在野，王孙善保千金躯",
            "poemId": "poem_585"
        }
    ],
    "朔": [
        {
            "line": "朔方健儿好身手，昔何勇锐今何愚",
            "poemId": "poem_585"
        }
    ],
    "窃": [
        {
            "line": "窃闻天子已传位，圣德北服南单于",
            "poemId": "poem_585"
        }
    ],
    "哀": [
        {
            "line": "哀哉王孙慎勿疏，五陵佳气无时无",
            "poemId": "poem_585"
        }
    ],
    "态": [
        {
            "line": "态浓意远淑且真，肌理细腻骨肉匀",
            "poemId": "poem_586"
        }
    ],
    "绣": [
        {
            "line": "绣罗衣裳照暮春，蹙金孔雀银麒麟",
            "poemId": "poem_586"
        }
    ],
    "头": [
        {
            "line": "头上何所有",
            "poemId": "poem_586"
        }
    ],
    "背": [
        {
            "line": "背后何所见",
            "poemId": "poem_586"
        }
    ],
    "珠": [
        {
            "line": "珠压腰衱稳称身",
            "poemId": "poem_586"
        }
    ],
    "就": [
        {
            "line": "就中云幕椒房亲，赐名大国虢与秦",
            "poemId": "poem_586"
        }
    ],
    "犀": [
        {
            "line": "犀箸厌饫久未下，鸾刀缕切空纷纶",
            "poemId": "poem_586"
        }
    ],
    "炙": [
        {
            "line": "炙手可热势绝伦，慎莫近前丞相嗔",
            "poemId": "poem_586"
        }
    ],
    "翻": [
        {
            "line": "翻身向天仰射云，一笑正坠双飞翼",
            "poemId": "poem_587"
        }
    ],
    "血": [
        {
            "line": "血污游魂归不得",
            "poemId": "poem_587"
        }
    ],
    "劝": [
        {
            "line": "劝君莫惜金缕衣，劝君惜取少年时",
            "poemId": "poem_588"
        }
    ],
    "慈": [
        {
            "line": "慈母手中线，游子身上衣",
            "poemId": "poem_589"
        }
    ],
    "贞": [
        {
            "line": "贞女贵徇夫，舍生亦如此",
            "poemId": "poem_590"
        }
    ],
    "摐": [
        {
            "line": "摐金伐鼓下榆关，旌旗逶迤碣石间",
            "poemId": "poem_591"
        }
    ],
    "校": [
        {
            "line": "校尉羽书飞瀚海，单于猎火照狼山",
            "poemId": "poem_591"
        }
    ],
    "鹫": [
        {
            "line": "鹫翎金仆姑，燕尾绣蝥弧",
            "poemId": "poem_592"
        }
    ],
    "卢": [
        {
            "line": "卢家少妇郁金堂，海燕双栖玳瑁梁",
            "poemId": "poem_593"
        }
    ],
    "停": [
        {
            "line": "停船暂借问，或恐是同乡",
            "poemId": "poem_598"
        }
    ]
}